window.reviews = [

{
  name: "Kevin O.",
  date: "April 25, 2025",
  title: "A Year of New Freedom",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Kevin-Liberty-Trike-day1.png?v=1745592556",
  video: "",
  html5video: "",
  comment: "It was a year ago today this big ol\' box arrived… and in this decade of immobility, disability, struggle, pain, depression & anxiety — including 4 years of being a house-bound shut-in — two things this past year improved life greatly for me — and they\'re BOTH pictured here. 🐈‍⬛🫐",
  response: "Kevin, thank you for sharing such a powerful reflection. We\'re honored that Liberty Trike could be part of your journey toward greater freedom and joy. Wishing you continued adventures, healing, and happiness with your trike and your furry companion!"
},
{
  name: "Lynne E.",
  date: "April 25, 2025",
  title: "Fabulous Day on the Centennial Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Lynne-Liberty-Trike-spokane.png?v=1745593053",
  video: "",
  html5video: "",
  comment: "Out & about on our trikes on the Centennial Trail along the Spokane River. Fabulous day!",
  response: "Lynne, it sounds like a perfect day for a ride! We\'re so happy to hear you\'re out enjoying beautiful trails with your Liberty Trike. Keep making wonderful memories!"
},
  {
  name: "Brad M.",
  date: "April 25, 2025",
  title: "More Than One Way to the River",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Brad-Liberty_Trike-Camping.png?v=1745593239",
  video: "",
  html5video: "",
  comment: "There’s more than one way to get to the river from your campsite.",
  response: "Brad, sounds like you\'re making the most of every adventure! Love hearing how your Liberty Trike helps you explore in new ways. Keep enjoying the ride and those river views!"
},
  {
  name: "Mary Margaret P.",
  date: "April 23, 2025",
  title: "Finally Hit 3000 Miles",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Mary-3000_miles-_Liberty_Trike.png?v=1745593158",
  video: "",
  html5video: "",
  comment: "Finally got to 3000.",
  response: "Mary Margaret, congratulations on reaching 3000 miles! That\'s an incredible accomplishment and a true testament to your dedication. Here\'s to many more miles and smiles ahead!"
},
{
  name: "Laura P.",
  date: "April 9, 2025",
  title: "Beach Days with Laverne",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Laura-P-Liberty-Trike.png?v=1744288299",
  video: "",
  html5video: "",
  comment: "Took Laverne out on the beach today... my happy place! She needed a boost on the dune but after that it was easy. Such a fun way to explore!",
  response: "Laura, we love hearing how Laverne is helping you enjoy your happy place! Exploring the beach by Liberty Trike sounds like a perfect day. Thanks for sharing the joy and keep soaking in those sunny rides!"
},
{
  name: "Don G.",
  date: "April 7, 2025",
  title: "Freedom to Move at 90",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Don-G-Liberty-Trike.png?v=1744288299",
  video: "",
  html5video: "",
  comment: "The Liberty Trike tagline, “Freedom to Move,” is spot on. I gave up my driver’s license in 2019 and my ability to get around was severely limited. I have had my trike for a little more than three years and it has given me the freedom to move in the Livermore Valley on the many wonderful trails. My odometer today reads 4,253 miles, all ridden on those wonderful trails. I also ride the trike to nearby Trader Joe’s, CVS, medical clinic, and grocery store. Yesterday I celebrated my 90th birthday with a ride to a lake about five miles from home. It was a gorgeous day that began with worship at our church, then watching the San Francisco Giants playing the Seattle Mariners, which I finished listening to on my trike ride to the lake as they ended up winning with a walk-off hit. Then my wife, Pat, treated me to dinner at a favorite restaurant followed by a visit to our favorite ice cream parlor for a sundae. I never dreamed I would reach my 90th birthday. Despite declining vision where I can’t read a printed page any more and limited mobility I’m getting along quite well. My Liberty Trike gets me out and about for which I’m very grateful.",
  response: "Don, your story is absolutely inspiring. Happy 90th birthday! We\’re honored that your Liberty Trike is helping you stay active and independent on those beautiful trails. Thank you for sharing such a meaningful journey with us—and here\’s to many more joyful rides!"
},
{
  name: "Bethany B.",
  date: "April 4, 2025",
  title: "French Toast Friday is Back!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/BethB-Liberty-Trike.png?v=1744288299",
  video: "",
  html5video: "",
  comment: "I bring you the return of #FrenchToastFriday! I even had enough points on the IHOP app that it was free.",
  response: "Bethany, we love a good comeback—especially when it includes French toast and a Liberty Trike adventure! Thanks for bringing the fun back to Fridays and for sharing your ride with us!"
},
{
  name: "Debbie B.",
  date: "April 4, 2025",
  title: "Back on the Greenway!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Debbie-I-Liberty-Trike.png?v=1744288299",
  video: "",
  html5video: "",
  comment: "Seven weeks after my hip replacement I am back riding on the Greenway.",
  response: "Debbie, that\’s amazing news! We\’re so glad to hear you\’re back on your Liberty Trike and enjoying the Greenway again. Wishing you continued healing and many more happy miles!"
},
{
  name: "Angel C.",
  date: "April 2, 2025",
  title: "4000 Miles Strong!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Angel-C-Liberty-Trike.png?v=1744288299",
  video: "",
  html5video: "",
  comment: "Finally hit 4000 miles just short of two years. 😊",
  response: "Angel, 4000 miles in under two years is an incredible milestone—what a journey! We\’re so glad your Liberty Trike has been a part of it. Here\’s to many more smooth and joyful miles ahead!"
},
{
  name: "Roger S.",
  date: "April 1, 2025",
  title: "Camera-Ready Setup",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/RogerS-Liberty-Trike.png?v=1744288299",
  video: "",
  html5video: "",
  comment: "View of my trike with extras used for doing camera work— and yes this is one of the bridges I work from... there is also a monopod mounted to the seat stem, but you can not see it here.",
  response: "Roger, it\’s amazing to see how you\’ve customized your Liberty Trike for your photography adventures! Your setup sounds like a creative dream, and we\’re honored the trike is a part of your process. Keep capturing those beautiful moments!"
},
{
  name: "Joette G.",
  date: "April 1, 2025",
  title: "Ready for Adventure",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Joette-G-Liberty-Trike.png?v=1744288299",
  video: "",
  html5video: "",
  comment: "Here is my trike in my Kia Soul with my camping gear. Ready to leave in the morning.",
  response: "Joette, we love seeing how your Liberty Trike fits right into your adventures! Have an amazing camping trip—can’t wait to hear about where the road (and trail) takes you next!"
},
{
  name: "Ana R.",
  date: "March 18, 2025",
  title: "500 Miles and Smiling!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Ana-r-liberty-trike.png?v=1742576772",
  video: "",
  html5video: "",
  comment: "Today we reach 500 miles.😉",
  response: "Ana, congratulations on reaching 500 miles! That’s a fantastic milestone and definitely something to smile about. Here’s to many more happy and healthy miles on your Liberty Trike!"
},
{
  name: "Roger S.",
  date: "March 15, 2025",
  title: "Spring Tune-Up and Ready to Roll!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/roger-s-Liberty-Trike.png?v=1742577161",
  video: "",
  html5video: "",
  comment: "UPDATE: FRUITPORT, MI. Trike is back, and weather is breaking. Had my trike “tuned up” by a bike shop this winter which included a new seat as the original (3200 miles) was pulling apart. They inspected everything, cleaning and tightening as needed. After I got it back this weekend, I swapped out the mirrors for a 1080p rear-view camera/monitor—which has great night vision as well. I installed the blinkers I won. Removed the rear reflector from basket and drilled two new holes in its metal mount for the blinker—5 min job. I also added some white reflectors to the front basket. This winter, I also worked on the back basket side racks, which I modified, reshaped and then covered with Black Industrial Heat-Shrink Tubing and now they just clip on the basket’s wire frame for use when needed, so they and the front basket will only see action when I need more storage—like recording grandkids outdoor sports or longer nature rides. Hoping to get back to doing morning Trike/nature riding this week.",
  response: "Roger, it sounds like you and your Liberty Trike are more ready than ever for a new season of adventures! We love how much thought and creativity you put into your setup—especially the rear-view camera and basket rack mods. Wishing you many more beautiful nature rides and memorable moments with the grandkids!"
},
  {
  name: "Karen L.",
  date: "March 13, 2025",
  title: "Perfect Transport Solution",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Karen-L-Horse-Trailer-Liberty_trike.png?v=1742577866",
  video: "",
  html5video: "",
  comment: "Found the perfect way to transport my trike when not using it for my horses.",
  response: "Karen, that sounds like a fantastic solution! We love hearing how Liberty Trike fits into your busy life with horses and all. Thanks for sharing your experience—and happy trails, on hooves or wheels!"
},
{
  name: "Nancy W.",
  date: "March 1, 2025",
  title: "Refreshing Ride on the Blackwater Heritage Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/NancyWG-Liberty-Electric-Trike.png?v=1741117643",
  video: "",
  html5video: "",
  comment: "We had a refreshing 12.5 mile bike ride on the Blackwater Heritage Bike Trail in Milton, FL. Gorgeous day! Rails to Trails. All in the countryside! Loved it!",
  response: "Nancy, that sounds like an absolutely perfect ride! The Blackwater Heritage Trail is such a beautiful spot to explore on your Liberty Trike. We're so happy to hear you're loving it—keep enjoying those scenic miles! 🚴‍♀️☀️"
},
  {
  name: "Laura F.",
  date: "February 23, 2025",
  title: "Cheddar and I Out for a Spin!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Laura_F-Liberty-Electric-Trike.png?v=1741119606",
  video: "",
  html5video: "",
  comment: "Cheddar and I out for a spin!",
  response: "Laura, you and Cheddar are looking fantastic out there! 🏈🚲 Love the Green Bay Packers jacket—what a fun way to show team spirit while enjoying the ride. Wishing you and Cheddar many more joyful miles together!"
},
{
  name: "Wendy F.",
  date: "February 15, 2025",
  title: "AAA+ Customer Care",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/WendyF-Liberty_Trike_electric_adult_tricycle.png?v=1724779517",
  video: "",
  html5video: "",
  comment: "\"You gotta be nuts to buy a trike anywhere else!\" That should be their slogan. 100% true. And their care for their customers is AAA+.",
  response: "Wendy, we might just have to put that on a banner! 😆 Thank you for your kind words and for being such an awesome part of the Liberty Trike community. We truly appreciate you!"
},
{
  name: "Bobbi R.",
  date: "February 15, 2025",
  title: "Loving My Liberty Trike!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/BobbiR-Liberty-Trike-Experience.png?v=1739634594",
  video: "",
  html5video: "",
  comment: "Good morning, I'm new here residing in Boynton Beach, FL. I'm loving my Liberty Trike! 🥰",
  response: "Bobbi! We're so happy to hear you're loving your trike. Wishing you many joyful rides in the beautiful Florida sunshine! ☀️🚴‍♀️"
},
{
  name: "Brian F.",
  date: "February 12, 2025",
  title: "5000 Miles and Still Going Strong!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/B-Freeze-Electric_Liberty_Trike-500_miles_odometer_842a9156-e7b9-4ca5-8848-99fef962abde.png?v=1739633056",
  video: "",
  html5video: "",
  comment: "Finally hit 5000 miles on my green LT! Great bike - around 3500 miles replaced the tires, upgraded the brake caliper. At 4500 miles replaced the seat as the old seat broke off. I keep the chain clean and lubed and adjusted properly. I keep my green LT in Florida for the winter and have a red LT for the summer in Alberta, Canada. Such great trikes. I have a balance issue, but at 74 am otherwise healthy and swim a 1 mile-a-day and bike 10 to 15 miles a day. I pedal all the time and run at '5' always.",
  response: "Brian, congratulations on hitting 5000 miles on your Liberty Trike! Your dedication to staying active and maintaining your trikes is truly inspiring. We love hearing how they’re helping you stay mobile and enjoy life in both Florida and Canada. Keep pedaling and enjoying the ride!"
},
{
  name: "Mary Margaret P.",
  date: "February 8, 2025",
  title: "2900 Miles and Counting!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/MMP-Liberty_Trike_-_2900_miles.png?v=1739633296",
  video: "",
  html5video: "",
  comment: "Little slow getting to this 2900 mile mark. It's been pretty cold but as long as only a breeze I'll ride in the 30s. Today 34°.",
  response: "Mary Margaret, congratulations on reaching 2900 miles! That’s dedication—riding even in the 30s! We love hearing how much you’re getting out of your Liberty Trike. Stay warm and keep enjoying the journey!"
},
  {
  name: "Kevin O.",
  date: "February 4, 2025",
  title: "Sunny and Brisk Trike Ride",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/KO-Liberty-Trike-Cold_Weather_Riding.png?v=1739633496",
  video: "",
  html5video: "",
  comment: "Yesterday was twice as warm… but today’s brisk trike-ride was equally as SUNNY! ☀️☀️☀️💙💙💙-k.",
  response: "Kevin, nothing beats a sunny ride, even when it’s brisk! ☀️💙 Keep enjoying those fresh air adventures on your Liberty Trike!"
},
  {
  name: "Nancy G.",
  date: "February 3, 2025",
  title: "Fresh Air & Sunshine",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Nan-Liberty-Trike-Testimonial-Review.png?v=1739634594",
  video: "",
  html5video: "",
  comment: "Hubby and I went to Hammock Bay in Freeport, FL and enjoyed a 10 mile bike ride in Sunny 75 degree weather. So good to be out in the fresh air and sunshine! Love my trike!",
  response: "Nancy, that sounds like a perfect day! Nothing beats fresh air, sunshine, and a great ride. So glad you and your hubby are enjoying your trikes—keep those wheels rolling!"
},
  {
  name: "Jack B.",
  date: "January 28, 2025",
  title: "Top-Notch Service and Customization",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JBarnosky-Liberty-Trike-Upgrade_and_Service_Experience.png?v=1739633760",
  video: "",
  html5video: "",
  comment: "Before and after—When I saw that Liberty Trike had a new model, I was interested. I had already bought three, two were stolen. So I made an appointment to see the new model and went to Croydon for a test ride. When I got there, they were ready for me—very professional. I started talking to Jason and explained what I wanted. He said that I didn't need a new bike, just some changes on the one I had. Made another appointment for the following week and brought the trike in my modest Toyota. Their servicemen went to work. They removed the old basket and put on the new style, changed the tire, and installed the crossbar. Took maybe an hour and a half, and I was done. The cost was very reasonable. I also got a second battery. Now I can ride from Philly to Conshohocken and back. Every dealing I have ever had with Liberty Trike has been satisfactory. You gotta be nuts to buy a trike anywhere else!",
  response: "Jack, we love hearing about your experience and are so glad we could make the right adjustments to keep you rolling strong! 🚲🔧 It’s awesome that you’re set up for longer rides with the extra battery. Thanks for your continued trust in Liberty Trike—happy riding!"
},
{
  name: "Dan G.",
  date: "January 8, 2025",
  title: "Perfect for RV Adventures",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/DanG-Liberty-Electric-Trike.png?v=1736881616",
  video: "",
  html5video: "",
  comment: "Can’t wait to use our new Liberty Trike, perfect size to fit in RV, easy to put together and impressive test ride, Thank You!",
  response: "Dan, we’re thrilled to hear that your Liberty Trike fits perfectly into your RV lifestyle! Thank you for sharing your excitement. We hope it brings you countless adventures and happy miles on your travels. Let us know if you ever need anything—happy triking!"
},
{
  name: "Loretta D.",
  date: "January 7, 2025",
  title: "3500 Miles and Going Strong!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/LorettaD-Liberty-Trike-Experience-3500_Miles_and_going_strong.png?v=1739634883",
  video: "",
  html5video: "",
  comment: "3500 miles! Love my Liberty Trike!",
  response: "Loretta, 3500 miles—what an incredible milestone! We love hearing how much you’re enjoying your Liberty Trike. Here’s to many more miles of fun and adventure!"
},
{
  name: "Cecile S.",
  date: "January 6, 2025",
  title: "Loving My New 20\" Liberty Trike",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/CecileS-Liberty-Electric-Trike.png?v=1736881504",
  video: "",
  html5video: "",
  comment: "Thanks for all the responses and advice while I was trying to decide on a trike. I got my new 20” liberty trike and very happy with it. Has anyone swapped out the seat to a bigger more comfortable one and if so what did you choose? I’ve been riding around my neighborhood and thoroughly enjoying it after many many years since I’d rode 🥰",
  response: "Cecile, welcome to the Liberty Trike family! We’re so happy to hear that you’re enjoying your new 20\" trike and getting back to riding after so many years. For seat swaps, many riders in the community recommend gel-padded or wider seats for extra comfort—feel free to ask the group for their favorites! Happy riding!"
},
{
  name: "Dee Dee G.",
  date: "January 5, 2025",
  title: "Lil’ Red’s Beautiful Inaugural Ride",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Dee_Dee_G-Liberty-Electric-Trike.png?v=1736881869",
  video: "",
  html5video: "",
  comment: "I was able to purchase a used Liberty Trike last week. I wanted to be able to use it for exercise while enjoying riding a “bike” again. Took my time figuring things out and riding it around my neighborhood. Took Lil’ Red out for her inaugural ride along the Coronado bay waterfront today. It’s one of my favorite places here in San Diego. Such a beautiful day and a fun ride. I’m looking forward to more beautiful rides! Keep on moving!",
  response: "Dee Dee, thank you for sharing Lil’ Red’s first adventure! It sounds like a picture-perfect day riding along the Coronado bay waterfront. We’re so glad the Liberty Trike is helping you enjoy exercise and beautiful rides again. Wishing you many more amazing journeys—keep on moving and enjoying life!"
},
{
  name: "Joseph P.",
  date: "January 3, 2025",
  title: "Miami Bound with My Liberty Trike!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Joseph_P-Liberty-Electric-Trike.png?v=1736882092",
  video: "",
  html5video: "",
  comment: "Miami Bound! in my new Liberty Trike!",
  response: "Joseph, Miami sounds like the perfect destination for an adventure on your Liberty Trike! We’re thrilled to hear you’re enjoying your new ride. Wishing you safe travels and amazing experiences along the way!"
},
{
  name: "Loretta D.",
  date: "December 30, 2024",
  title: "3,000 Miles of Love!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-LorettaD.png?v=1733506256",
  video: "",
  html5video: "",
  comment: "My 3,000 miles! Love my Liberty Trike! Happy Thanksgiving to all!",
  response: "Loretta, congratulations on hitting 3,000 miles on your Liberty Trike! What an incredible milestone! We’re so thrilled that your trike continues to bring you joy and adventure. Happy Thanksgiving to you too, and here's to many more miles ahead!"
},
{
  name: "Sylvia B.",
  date: "December 28, 2024",
  title: "500 Miles and Counting",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/sylvia-Liberty-Trike-500miles.png?v=1735673391",
  video: "",
  html5video: "",
  comment: "Reached my first 500 today. Survived pot holes and bad streets in my neighborhood.",
  response: "Sylvia, congratulations on reaching your first 500 miles! It’s amazing to hear how well you and your Liberty Trike are navigating those tough streets. Keep riding and enjoying your trike—we’re thrilled to be part of your journey!"
},
{
  name: "Angelique G.",
  date: "December 26, 2024",
  title: "1st 100 Miles: A Life-Changing Journey",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-AngeliqueG.png?v=1733506256",
  video: "",
  html5video: "",
  comment: "My 1st 100 miles: after a fall and concussion in May, doctors told me to exercise. I was afraid. My friend Debbie Lamb ('Pickle') got her trike and sold me. Mini Pearl (my camper van is 'Pearl') arrived in July to 100° temps, but I started riding with my sidekick Willie. Sometimes I defaulted to the air-conditioned gym. But I started to feel the improvement in my knees after riding at least 2 miles a day with little assistance. It dawned on me that this is exactly what my knee doctor told me to do 5 years ago. I have lost 10 lbs since July (also following a limited carb diet), and I can walk downstairs and actually bend my right knee. The trike is an investment, but worth it for the excellent construction, versatility, and customer service. I'm planning a cross-country van trip next year, and Mini Pearl will be with me.",
  response: "Angelique, thank you so much for sharing your incredible story! We’re thrilled to hear how Mini Pearl has been such a positive influence in your recovery and overall health journey. Losing 10 pounds and improving your knee mobility are amazing achievements! We’re excited to hear about your upcoming cross-country van trip—Mini Pearl sounds like the perfect companion. Keep enjoying the rides and improving your health!"
},
{
  name: "Jo Ann S.",
  date: "December 25, 2024",
  title: "Riding with My Poodle Companion",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-JoAnnS.png?v=1733506256",
  video: "",
  html5video: "",
  comment: "That’s the older model. Got it in June. My 16lb poodle loves it. That’s the Walkey Dog attachment I got from Amazon. I had just put her back in the basket after our ride.",
  response: "Jo Ann, it’s wonderful to hear how much you and your poodle are enjoying your rides together! The Walkey Dog attachment is such a smart addition for your adventures. Thank you for sharing your setup and experience—it’s great to see Liberty Trike bringing you and your furry friend so much joy. Happy riding!"
},
{
  name: "Susan R.",
  date: "November 24, 2024",
  title: "A New Arrival!",
  score: 4,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Susanr.png?v=1733506256",
  video: "",
  html5video: "",
  comment: "Well, she showed up late this afternoon, so we need a little reading and video watching to ride her. We didn't realize that the only paperwork in the box basically had a QR code to the videos and we'd have to download the instructions. But she's pretty and almost matches my Nissan truck.",
  response: "Susan, congratulations on the arrival of your new trike! We’re thrilled to hear you’re already appreciating her beauty and matching style with your Nissan truck. Thank you for the feedback about the assembly instructions—we’ll share this with our team to ensure a smooth experience for everyone. We hope the videos make it easy, and if you have any questions, don’t hesitate to reach out. Happy riding!"
},
{
  name: "Janice B.",
  date: "November 22, 2024",
  title: "Loving My New Trike!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-JaniceB.png?v=1733506256",
  video: "",
  html5video: "",
  comment: "I’m an owner now! I got my Liberty Trike the day after Thanksgiving. Beautiful weather here in Oklahoma. I’m loving my Trike! So much fun! Easy to operate and fun to ride. Quite the attention getter from the neighbors!",
  response: "Janice, congratulations on becoming a Liberty Trike owner! We're so glad to hear you're loving your new trike and enjoying rides in the beautiful Oklahoma weather. It’s wonderful to know that your neighbors are taking notice too! Wishing you many fun and exciting adventures ahead—welcome to the Liberty Trike family!"
},
{
  name: "Kirsten I.",
  date: "November 21, 2024",
  title: "Betty’s First Adventure!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-KirstenI.png?v=1733506256",
  video: "",
  html5video: "",
  comment: "Meet Betty, my new white trike! She arrived a couple of weeks ago and has just returned from her first camping trip. (I haven't attached her fenders yet, as I didn't want to damage anything trying to load her into our camper.) Our dog, Tiny, obviously approves! She tries to jump up into the basket on her own! We were able to ride all around the campground and on some great trails which is exactly what I wanted to do on this trike. We turned heads everywhere we went, and as a matter of fact, a camping neighbor took a test ride and will likely be ordering hers soon! I can see why everyone loves their trikes so much. Thanks for all of the encouragement and input members in this group have offered. Liberty Trike is amazing, and I truly appreciate how responsive and supportive the company is!",
  response: "Kirsten, welcome to the Liberty Trike family and congratulations on Betty’s first adventure! It’s wonderful to hear how much you’ve enjoyed exploring the campground and trails with Tiny, and we’re thrilled to know your neighbor is inspired by your trike too! Thank you for your kind words about our team—we’re here for you every step of the way. Wishing you many more fun-filled rides and memorable moments with Betty!"
},
{
  name: "Margaret P.",
  date: "November 19, 2024",
  title: "2,700 Miles and Counting!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-MargaretP.png?v=1733506256",
  video: "",
  html5video: "",
  comment: "Hit 2700 miles while out dropping an Amazon return at the UPS Store and voting!",
  response: "Mary Margaret, congratulations on hitting an incredible 2,700 miles! It’s inspiring to hear how your Liberty Trike helps you seamlessly integrate errands and civic duties like voting into your rides. Keep enjoying those miles and making the most of every journey!"
},
{
  name: "Jason W.",
  date: "November 15, 2024",
  title: "Zooming Everywhere with My LT!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/jASONw-lIBERTY-tRIKE_43076631-d0fc-4e80-ba7a-6b29d1bcfec7.png?v=1731704983",
  video: "",
  html5video: "",
  comment: "State parks, springs, camping, work. If I have room, I'm always packing these things! Zoom zoom!!!",
  response: "Jason, we love hearing about all the places your Liberty Trike takes you! From state parks to work, it sounds like your LT is the perfect companion for all your adventures. Keep on zooming and enjoy the ride!"
},
{
  name: "Brian F.",
  date: "November 11, 2024",
  title: "4500 Miles and Counting!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/bRIANf-11-15-2024-lIBERTY-tRIKE.png?v=1731704983",
  video: "",
  html5video: "",
  comment: "Florida - North Palm Beach for the winter. My Florida green LT hit 4500 miles on November 11, 2024. My Canadian (Alberta) red LT was at 1111.1 miles in October 2024 before we left for the winter.",
  response: "Brian, congratulations on hitting those impressive mileage milestones with both your Liberty Trikes! It's wonderful to hear about your journeys from Alberta to sunny Florida. Keep enjoying the rides and racking up those miles. We're proud to be part of your adventures across North America!"
},
{
  name: "Cindy C.",
  date: "November 7, 2024",
  title: "Excited for My New Liberty Trike!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/CindyC-Liberty-Trike.png?v=1731007179",
  video: "",
  html5video: "",
  comment: "My trike came today! It took a couple of hours to get it unboxed and be sure we put it together correctly. The battery was mostly fully charged. Nice surprise Liberty Trike! 💙 So I rode it up and down the driveway and in the yard very slowly and carefully. It’s going to be a learning curve to ride it but it feels much better than my non-electric trike. I need to get a helmet before we go camping next week. We’re taking our camper out one last time before putting it to bed for the winter. It’s cold 🥶 here today, 57° but cloudy and feels colder. So I need to go in for a bit. But so far I think I’m going to LOVE it! Thank you Linda Starnes for bringing yours out last weekend for me to try. That was very helpful! 🥰",
  response: "Cindy, we’re thrilled to hear that your Liberty Trike has arrived and that you’re already enjoying it! The learning curve is all part of the adventure, and it sounds like you’re off to a great start. We’re sure it’ll add an extra level of fun to your upcoming camping trip. Stay warm and safe, and thank you for choosing Liberty Trike!"
},
{
  name: "Jason W.",
  date: "November 6, 2024",
  title: "Zippin' Around for Work!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JasonW-Liberty-Trike.png?v=1730914821",
  video: "",
  html5video: "",
  comment: "Fixing cable and fiber optics in Tampa... Never utilized it for work before! Zippin' and zoomin' around! Not all jobs, but occasionally... Putting signs out, running around with tools, carrying necessities when doing easements/backyards! Liberty Trike. Let me know when my wife and I can get new models to promote! State parks, beach, concerts, now work!",
  response: "Jason, we're so glad to hear that your Liberty Trike is helping you on the job! It’s amazing to see how versatile it can be, from work to leisure. We’ll be sure to let you know about new models – sounds like you and your wife are true Liberty Trike ambassadors! Keep zippin' and zoomin'!"
},
{
  name: "Jo Ann S.",
  date: "November 5, 2024",
  title: "First 100 Miles!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/6_618adc94-85d9-414c-a6ae-a98f922fb2e6.png?v=1730913496",
  video: "",
  html5video: "",
  comment: "Reached my 1st 100 miles yesterday. Many more to go!",
  response: "Congratulations on hitting your first 100 miles, Jo Ann! We’re thrilled to hear about your journey and can’t wait to see where your Liberty Trike takes you next. Keep up the amazing rides!"
},
{
  name: "Kevin O.",
  date: "November 5, 2024",
  title: "Triking Everywhere!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/7_48aa1d9d-29a6-4907-bada-9a57ad624f40.png?v=1730913499",
  video: "",
  html5video: "",
  comment: "I can’t imagine triking without it… I have one on each side of my front basket and there’s nowhere I don’t take it - into cafes, bakeries, my local watering hole on bingo night, the barber shop, library & church - most recently even into the election commission.",
  response: "Kevin, we love hearing about all the places your Liberty Trike takes you! It sounds like you've truly embraced the freedom it brings, and we're thrilled to be part of your adventures. Keep on triking and exploring everywhere!"
},
  {
  name: "James B.",
  date: "November 3, 2024",
  title: "Riding Across the Soybean Fields",
  score: 5,
  image: "",
  video: "",
  html5video: "https://cdn.shopify.com/videos/c/o/v/654562fa62f14aeaa68023a5a60767de.mp4",
  comment: "The Framers harvested the Soy Bean fields that surround our neighborhood... We don't have sidewalks, and the Grand Daughter wanted to ride the bikes to play Putt Putt at the local small airport adjacent to our neighborhood on one side... So I took her for a ride across the Soy Bean Fields to the airport road. It was a rough ride, and it started sprinkling rain on us, so we had to rush back home. Riding on farm fields is not recommended as the rows and hills make for a rough ride for an OLD MAN... Not so much for the Grand Daughter; she had a blast!",
  response: "James, sounds like quite the adventure! While riding across fields might not be the smoothest journey, we're glad to hear your granddaughter had a blast. Thanks for sharing this fun story with us – it’s wonderful to see your Liberty Trike bringing joy to you and your family. Happy triking!"
},
  {
  name: "Roger S.",
  date: "October 31, 2024",
  title: "Morning Ride with Safety and Snacks",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/8_f2a15df0-7ed9-494b-afcf-d77a5a41141b.png?v=1730913501",
  video: "",
  html5video: "",
  comment: "Windy and then some light rain being blown in during my morning trike ride/nature shoot; so I pulled into a pavilion to keep dry and have my morning breakfast: Hot chocolate, triscuits with peanut butter, string cheese, seedless grapes. In this shot, you can see my two front lights, one set to blink, and I have two of the same (but red, one on the back of the seat and the other on the lower cross bar, both set to blink) on the rear. Although they are mainly for when I start out in the dark in the morning, I keep them on for the full ride as added safety since I am along the side of the road most of the time. At the end of the ride, they snap off with a twist and go in with my camera for a USB recharge.",
  response: "Roger, we love how prepared you are for your morning adventures on your Liberty Trike! From safety lights to delicious snacks, it sounds like you've got it all figured out. Thank you for sharing your setup and dedication to safety. Enjoy your rides and keep inspiring us with your nature shoots!"
},
{
  name: "Rose G.",
  date: "October 24, 2024",
  title: "First Ride with My Liberty Trike",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/RoseG-LibertyTrike.png?v=1730914354",
  video: "",
  html5video: "",
  comment: "Rode my Liberty Trike for the first time today. I had to raise the seat height because my new left knee replacement wasn't happy with it being lower. Takes a while to adjust to turning and braking, but at the end of the ride, I enjoyed just using the electric without pedaling. I also bought some non-adhesive polarizing film to put over the LCD to help avoid damage from the Florida Sun. Added a phone holder, rear view mirrors, and a water holder attached to the basket. Very happy with my new trike and the assistance given from Liberty Trike during assembly.",
  response: "Rose, we're thrilled to hear about your first experience with your Liberty Trike! It sounds like you've done a fantastic job personalizing it to meet your needs. We’re especially glad to hear that our team could assist you during assembly. Here’s to many more enjoyable rides ahead – happy triking!"
},
{
  name: "Wendy F.",
  date: "October 22, 2024",
  title: "Night Rides Before Winter",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/2_ed51e996-6ce3-4d52-8375-2871b4c084f6.png?v=1729625364",
  video: "",
  html5video: "",
  comment: "A new waterfront park just opened in my neighbourhood that I wanted to check out on another night ride. Major restoration work took place on the grain silos for approximately two years with magnificent results. Soon it’ll be too cold and snowy so I’m trying to get in as many rides as possible before my LT, Indy, goes into hibernation for the winter.",
  response: "Wendy, it's amazing to hear about your night rides and the stunning restoration work at the new park! It sounds like a beautiful spot to explore with Indy before the winter sets in. Enjoy every moment, and we can't wait to see you and Indy back out when the snow melts!"
},
{
  name: "Deborah A.",
  date: "October 21, 2024",
  title: "New Adventures on My Trike",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/1_84702cb0-f8c5-498e-89d8-2a0d545e1cc2.png?v=1729625364",
  video: "",
  html5video: "",
  comment: "I rode my trike in Grand Haven, MI with our friend, Carey Korpi. She rode Joel Altsman's trike and loved it! I have been able to go to so many places on my trike l never would have seen without it!",
  response: "Deborah, we love hearing about your adventures in Grand Haven! It’s so great that you and Carey both got to enjoy the trikes, and we’re thrilled that your Liberty Trike has opened up so many new places for you to explore. Keep on riding and discovering!"
},
{
  name: "John R.",
  date: "October 19, 2024",
  title: "Getting Easier to Steer",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/3_7a0f72ec-c021-4713-a5d6-d78c978ccf01.png?v=1729625364",
  video: "",
  html5video: "",
  comment: "Put in 6.2 miles last night. Getting easier to steer.",
  response: "John, it’s great to hear that you're getting more comfortable with steering on your Liberty Trike! 6.2 miles is an impressive ride—keep enjoying the journey and those miles ahead!"
},
{
  name: "Debbie I.",
  date: "October 18, 2024",
  title: "Last Day of Octoberfest",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/4_f435b16e-3a81-4105-82e3-84e8b7f1965a.png?v=1729625364",
  video: "",
  html5video: "",
  comment: "Last Day of Octoberfest at Uchee Creek Event Area in Fort Mitchell, AL!",
  response: "Debbie, sounds like you had an amazing time at Octoberfest! We hope you and your Liberty Trike had a blast exploring the event area. Enjoy the festivities!"
},
{
  name: "Joseph L.",
  date: "October 17, 2024",
  title: "2022 Liberty Trike",
  score: 4,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Joseph_L-Liberty-Trike.png?v=1729281311",
  video: "",
  html5video: "",
  comment: "Thought I would share some pictures of my 2022 LT. It has LT and aftermarket accessories. The JBL FM/bluetooth speaker keeps me great company going down the road. The reason I gave the trike four stars is because the main pedal chain is very sloppy. It is impossible to adjust without making the smaller electric motor chain way too tight or throwing the axles out of whack. All in all, I love the trike. Probably will end up taking a link or two out of the chain to take up some slack.",
  response: "Joseph, thanks for sharing your feedback and those great pics of your 2022 LT! We appreciate the note about the chain, and we’re happy to help troubleshoot if you need. Glad to hear you’re enjoying your rides with the JBL speaker and all the accessories!"
},
{
  name: "Daphne H.",
  date: "October 17, 2024",
  title: "First Successful Ride!",
  score: 5,
  image: "",
  video: "",
  html5video: "https://cdn.shopify.com/videos/c/o/v/ab96f4b4b6a34661b84c3a8707862b06.mp4",
  comment: "It took three years for our son not to be scared of it. Today was his first successful ride. We’re just so happy he’s finally enjoying it! We went for three rides/walks today! (We’re out on our last camping trip of the year). We think it helped having the campground pretty empty and little to no traffic. My son's name is Jernie.",
  response: "Daphne, we're so thrilled to hear that Jernie finally enjoyed his first ride! What a wonderful moment for your family. It sounds like the perfect setting for him to feel comfortable. Here's to many more joyful rides ahead!"
},
{
  name: "Joel A.",
  date: "October 14, 2024",
  title: "Selling Our Classic Liberty Trikes",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Joel_A-Liberty-Electric-adult-tricycle.png?v=1728925696",
  video: "",
  html5video: "",
  comment: "We have upgraded to the new Liberty Trikes, so we're selling our old ones. They're in great shape and waiting for their new home. They are the 16\" classic model. We're including the original seat and the upgraded ones that ship with the new models, since we already have alternates. Each trike comes with a battery and a charger. Both were purchased in January 2023 so they're less than 2 years old. The red one has less than 400 miles on it and the blue one has less than 60. They originally sold for $1598 plus shipping and are now $1498 plus shipping on the Liberty Trike site. We are asking for $1200 each, a savings of $300. You can buy both for only $2000, a $1000 savings over new! We are in Lavon, TX - a northeast suburb of Dallas. Local pick up only, no shipping. Message me with questions or interest.",
  response: "Joel, it's awesome to hear that you've upgraded to the new Liberty Trikes! We hope the classic models find great new homes with happy riders. Thanks for spreading the joy and for being part of the Liberty Trike community!"
},
{
  name: "Debbie B.",
  date: "October 14, 2024",
  title: "First Ride on the Greenway",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Debbie_B._Liberty-Electric-adult-tricycle.png?v=1728923658",
  video: "",
  html5video: "",
  comment: "My 20 inch has arrived. I took it for a test ride on our Greenway this morning.",
  response: "Debbie, we’re thrilled to hear your 20-inch Liberty Trike has arrived and that you’ve already taken it out for a spin on the Greenway! We hope you enjoy many more scenic rides ahead!"
},
{
  name: "Lynne K.",
  date: "October 13, 2024",
  title: "Beautiful Day on the Centennial Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Lynne_K._Liberty-Electric-adult-tricycle.png?v=1728923653",
  video: "",
  html5video: "",
  comment: "Another beautiful day out on the trikes. This is Mirabeau Park and it is in Spokane Valley off of the Centennial Trail. We did 10 miles today and I have to say I definitely need a softer seat whew my rear-end is sore �✌️✌️✌️😍",
  response: "Lynne, sounds like an amazing day out at Mirabeau Park! Ten miles is quite the ride—glad you're enjoying your Liberty Trike, though we understand about the seat. Feel free to reach out for recommendations on making your ride even more comfortable! Keep on triking!"
},
{
  name: "Roger S.",
  date: "October 10, 2024",
  title: "Chilly Off-Road Ride & Family Time",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Roger_S._Liberty-Electric-adult-tricycle.png?v=1728923652",
  video: "",
  html5video: "",
  comment: "Wife and I took our trikes to another of our granddaughter's College Cross Country meets...very chilly but a great off-road/trail ride and sharing some time with the family. PS we got to watch/record her set a new personal record while becoming the lead runner for her team across the finish line.",
  response: "Roger, what a wonderful family experience! It's great to hear that your Liberty Trikes allowed you and your wife to enjoy the meet and be there for your granddaughter's big moment. Kudos to her on the new personal record! Stay warm and keep riding!"
},
{
  name: "James B.",
  date: "October 8, 2024",
  title: "First Ride Success!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/James_B._Liberty-Electric-adult-tricycle.png?v=1728923645",
  video: "",
  html5video: "",
  comment: "Kyu took her first ride on her new LT16 this afternoon. She started slow, staying at 1-2 power. But it was obvious that she was learning quickly. When she got back home, she wanted to take it up a moderate hill near our house, which she did and came back with a big smile.",
  response: "James, what a fantastic first ride for Kyu! It’s great to hear she was up for the challenge of the hill and returned with a big smile. We hope you both enjoy many more rides and adventures together. Thanks for sharing her journey with us!"
},
{
  name: "Bryan L. V.",
  date: "October 2, 2024",
  title: "Morning Ride on Frisco Highline Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Bryan_L._V._Liberty-Electric-adult-tricycle.png?v=1728923643",
  video: "",
  html5video: "",
  comment: "Morning ride, Willard, MO.",
  response: "Bryan, sounds like a peaceful morning on the trail in Willard! We hope you and your Liberty Trike are enjoying all the adventures along the Frisco Highline Trail. Thanks for sharing!"
},
{
  name: "Nancy G.",
  date: "September 19, 2024",
  title: "Exploring the Blackwater Heritage Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/11.png?v=1726849866",
  video: "",
  html5video: "",
  comment: "My hubby and I took our bikes to Milton, FL and rode 18 miles on the Blackwater Heritage Bike Trail. Such a beautiful paved and mostly shady trail! Love my trike! 275 miles ridden!",
  response: "Nancy, it sounds like you and your husband had a fantastic time on the Blackwater Heritage Bike Trail! We’re thrilled to hear you’re enjoying your trike and exploring beautiful trails together. Keep racking up those miles and enjoying every moment!"
},
{
  name: "Susan C.",
  date: "September 18, 2024",
  title: "Riding Around NW Indiana",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/13.png?v=1726849866",
  video: "",
  html5video: "",
  comment: "Exploring the beautiful NW Indiana on my Liberty Trike. Enjoying the scenic views and the freedom it brings!",
  response: "Susan, it's wonderful to hear that you're enjoying your rides around NW Indiana on your Liberty Trike! Keep taking in those beautiful views and making the most of your adventures. Happy riding!"
},
{
  name: "Henry K.",
  date: "September 16, 2024",
  title: "Creek Adventures in Yosemite",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/12.png?v=1726849866",
  video: "",
  html5video: "",
  comment: "Exploring the beauty of Yosemite on my Liberty Trike! Riding through the creek was an unforgettable experience.",
  response: "Henry, what an incredible way to experience Yosemite! Riding through a creek sounds like an adventure for the books. We're so glad your Liberty Trike is taking you on these amazing journeys. Keep exploring and enjoying the great outdoors!"
},
{
  name: "Joan C.",
  date: "September 14, 2024",
  title: "Boardwalk Bliss",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/14.png?v=1726849866",
  video: "",
  html5video: "",
  comment: "Fun week at the shore & riding length of boardwalk without crowds.",
  response: "Joan, it sounds like you had a fantastic time riding along the boardwalk! The shore is always more enjoyable when you have the space to explore freely. We're thrilled that your Liberty Trike added to the fun of your week. Keep enjoying those peaceful rides!"
},
{
  name: "Lynne K.",
  date: "August 27, 2024",
  title: "Beautiful Ride on Centennial Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/LynneK-Liberty_Trike_electric_adult_tricycle_21828ee3-3b72-49e6-a48a-08c03aa0bc83.png?v=1724779030",
  video: "",
  html5video: "",
  comment: "Nine mile falls, Spokane Wa. Centennial Trail.",
  response: "Lynne, Centennial Trail sounds like a beautiful place for a ride! We’re thrilled to know you’re enjoying your Liberty Trike in such a scenic area. Keep exploring and enjoying the journey!"
},
{
  name: "Linda E.",
  date: "August 27, 2024",
  title: "3 1/2 Years and 2000 Miles!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/LindaE-Liberty_Trike_electric_adult_tricycle.png?v=1724779231",
  video: "",
  html5video: "",
  comment: "3 1/2 years!! 2000 miles!",
  response: "Linda, congratulations on reaching 2000 miles over 3 1/2 years! That’s an incredible achievement. We’re so happy to be a part of your journey and wish you many more miles of joy and adventure with your Liberty Trike!"
},
  {
  name: "Nancy P.",
  date: "August 26, 2024",
  title: "Dog Carrier Setup Assistance",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/NancyP-Liberty_Trike_electric_adult_tricycle.png?v=1724779416",
  video: "",
  html5video: "",
  comment: "I’m looking for the information from the gal who put a dog carrier on her handlebars for her little dog. I ordered the stuff a while ago and now need to install it. What to do. Found it. This is the set up I'm trying to duplicate.",
  response: "Nancy, we're glad to hear you found the setup you were looking for! It's great to see how creative our Liberty Trike community is when it comes to making their trikes work for their unique needs. If you need any further assistance with the installation, feel free to reach out. We’re here to help!"
},
{
  name: "Eva R.",
  date: "August 26, 2024",
  title: "A New Riding Buddy",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/EvaR-Liberty_Trike_electric_adult_tricycle_7dc5ae26-67ad-4ac2-b874-71d806c7ed51.png?v=1724778930",
  video: "",
  html5video: "",
  comment: "Got another LT, second owner with only .6 miles, for company to ride with me. My husband has been on three short rides this week. He doesn’t even mind that it is Hot Pink. It’s nice to have someone to ride with. His helmet and mirror come tomorrow so he will be safer on our country roads. Happy triking everyone.",
  response: "Eva, it’s fantastic to hear that you’ve got a new riding buddy and that your husband is enjoying the rides too, even with the Hot Pink trike! Riding together makes the experience even more special. We’re glad to be a part of your adventures. Stay safe and happy triking!"
},
{
  name: "Wendy F.",
  date: "August 24, 2024",
  title: "Dusk Ride Along Toronto’s Waterfront",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/WendyF-Liberty_Trike_electric_adult_tricycle.png?v=1724779517",
  video: "",
  html5video: "",
  comment: "Another amazing ride at dusk along Toronto’s waterfront. My LT has front and back basket lights plus a white light in the front and a red flasher in the back that weren’t on at the time. The one photo from inside my basket was entirely my phone’s idea and a surprise to me — although my phone does take photos of me from time to time unprompted! The lower blue bar holds my camera mount so if by chance it falls off it lands in the basket.",
  response: "Wendy, it sounds like you had an incredible evening ride along Toronto’s waterfront! We love hearing about your adventures, and it’s great to know that your LT is well-equipped with lights for safe travels. The surprise photo from your phone is a fun bonus! Keep enjoying those beautiful dusk rides and capturing those special moments."
},
{
  name: "Debbie L.",
  date: "August 22, 2024",
  title: "Triking Across America",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/DebL_-_Liberty_Electric_Adult_Trike.png?v=1724345718",
  video: "",
  html5video: "",
  comment: "I thoroughly enjoy my trike! This spring, I overdid it while hiking in the Appalachian and Smokey Mountains, which affected my right knee. My doctor recommended resistance-free biking, which has helped my knee tremendously. Crazy how peddling my trike has improved my knee. Now, Diesel and I bike for at least four miles daily and explore the areas we camp by bike while traveling across America. It's been a blast!",
  response: "Debbie, we’re so glad to hear that your Liberty Trike has been such a fantastic help in your recovery and adventures! It’s amazing that you and Diesel are exploring new places every day, and it’s wonderful to know that your trike is making such a positive impact on your knee. Keep enjoying those rides and exploring all that America has to offer!"
},
{
  name: "Jo Ann S.",
  date: "August 19, 2024",
  title: "Loving Our Rides Together",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JPScott_-_Liberty_Electric_Adult_Trike.png?v=1724345860",
  video: "",
  html5video: "",
  comment: "At 79 almost 80 I still have my Downs Syndrome son with me. He has always biked among other things, however I no longer feel safe on a bike. And of course will not send him out alone. Bought us both trikes 1 new and 1 refurbished. I don’t know which was which. We are loving our rides together. Also my poodle baby loves going with us.",
  response: "Jo Ann, it warms our hearts to hear that you and your son are enjoying your Liberty Trikes together! It's wonderful to know that you're able to share these special moments and stay active as a family, with your poodle joining in on the fun too. Thank you for choosing Liberty Trike to keep you all moving and making memories. Wishing you many more joyful rides ahead!"
},
{
  name: "Ernie F.",
  date: "August 18, 2024",
  title: "First 100 Trouble-Free Miles",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/EFranco_-_Liberty_Electric_Adult_Trike.png?v=1724346216",
  video: "",
  html5video: "",
  comment: "First 100 trouble free miles on my trike!! Hope to put on many more.",
  response: "Ernie, congratulations on reaching your first 100 miles with your Liberty Trike! We're thrilled to hear that it's been smooth sailing so far, and we look forward to hearing about many more miles of happy riding. Keep enjoying every moment on your trike!"
},
  {
  name: "Bethany B.",
  date: "August 14, 2024",
  title: "I Hit 1K Miles with Gaspee!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/bbrown_-_Liberty_Electric_Adult_Trike.png?v=1724346322",
  video: "",
  html5video: "",
  comment: "I hit 1K miles!!! I don’t drive—thanks to ADHD—and I spent a lot on transportation. I ordered Gaspee from Liberty Trike around Patriots Day 2022. My Gaspee was shipped on Rhode Island Independence Day 2022. Seeing how everyone names their Liberty Trike and was shipped on May 4, I knew I needed a Revolutionary War name. I named her for the British tax ship Gaspee that was burned off Warwick, RI in June 1772. Whether it’s the subway, Target, or the grocery store, I have gained so much freedom and saved so much money by getting myself there. Thanks, Gaspee!",
  response: "Bethany, congratulations on reaching 1,000 miles with Gaspee! What a fantastic story behind your trike’s name, and it’s inspiring to hear how much freedom and independence it’s brought you. We’re honored to be a part of your journey and wish you many more miles of adventure and savings ahead!"
},
{
  name: "Jo S.",
  date: "August 6, 2024",
  title: "All Set for a Safe Ride",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JScott_-_Liberty_Electric_Adult_Trike.png?v=1724346532",
  video: "",
  html5video: "",
  comment: "Finally all tricked for a safe ride. She loves it! Amazon loves me.",
  response: "Jo Ann, it sounds like you’ve got everything set up perfectly for safe and enjoyable rides! We’re so glad to hear that you love your Liberty Trike and that it’s making your rides even more fun. Here’s to many more safe and happy journeys ahead!"
},
{
  name: "Joan B.",
  date: "August 1, 2024",
  title: "Pedaling Made Easy",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JoanB-_Liberty_Electric_Tricycle_7dcd7a38-8a7f-4f21-8e5e-a2d3268d97b8.png?v=1722524629",
  video: "",
  html5video: "",
  comment: "I’m 72, have COPD and am sedentary. I’ve known I’ve needed some exercise in my life and decided that cycling would fit the bill. Decided that 3 wheel was the way to go at my age. I initially bought a regular trike but really struggled with breathing and the muscle power that demanded. Further research led me to Liberty Trike. I pedal as much as I can and take advantage of the extra boost when needed. Sometimes I do both! Having a ball and my daughter bought one too. Thank you Liberty Trike!",
  response: "Joan, it's fantastic to hear that your Liberty Trike is helping you incorporate more exercise into your life while having fun! We're thrilled that both you and your daughter are enjoying your trikes. Keep pedaling and enjoying every ride!"
},
{
  name: "Angelique G.",
  date: "July 30, 2024",
  title: "Taillight Installation Success",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/AngeliqueMG-_Liberty_Adult_Electric_Trike.png?v=1722525342",
  video: "",
  html5video: "",
  comment: "Taillight installation, (the one sold on Liberty Trike website). Step one: WATCH THE INSTALLATION VIDEO ON LIBERTY TRIKE FB! If you try to use the provided instructions you will give up and send it back. It's a really neat light with horn, turn signal and \"theft alarm\". Note: remove the reflector from the basket before installing the light, then you can reattach it one hole higher. Not that hard to install if you watch the video first. Now on to the headlight.",
  response: "Angelique, thank you for sharing your experience and helpful tips for installing the taillight! We're glad to hear that the video tutorial made the process smooth and enjoyable. We're always here to support our Liberty Trike community, so feel free to reach out if you need assistance with the headlight installation. Enjoy the added safety features on your rides!"
}, 
{
  name: "Carol L.",
  date: "July 28, 2024",
  title: "Joining Morning Walks with Friends",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/CarolL_-_Liberty_Electric_Adult_Trike.png?v=1722525420",
  video: "",
  html5video: "",
  comment: "The trike allows me to \"walk\" with my friends that do a 2 mile walk every morning down to our pier in Manistee MI.",
  response: "Carol, it's wonderful to hear that your Liberty Trike is helping you stay connected with friends during your morning walks! Being part of such a routine is a great way to enjoy the outdoors and maintain friendships. We're thrilled to be part of your active lifestyle. Keep enjoying those morning outings and making memories!"
},
{
  name: "Linda B.",
  date: "July 27, 2024",
  title: "Christmas in July Parade",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/LindaB-_Liberty_Folding_Tricycle.png?v=1722525549",
  video: "",
  html5video: "",
  comment: "Maggs and I are lined up and ready for the Christmas in July golf cart parade. Ride through the village was just under 6 miles. Temp reached 92, still a fun day with friends and a nice ride.",
  response: "It's great to hear that you and Maggs had such a fun time participating in the Christmas in July golf cart parade! Even with the temperature soaring to 92, it's awesome that you could enjoy a nice ride and celebrate with friends. Your Liberty Trike sounds like the perfect companion for such festive adventures. Keep enjoying those special moments!"
},
{
  name: "Glenn and Kathy L.",
  date: "July 24, 2024",
  title: "Independence and Convenience",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Glenn_and_Kathy_L-_Liberty_Trikes.png?v=1721914746",
  video: "",
  html5video: "",
  comment: "We brought our Liberty Trikes in 2019. We still enjoy and ride them. We bought Kathy's first and I liked her's so much we ordered one for me. We had 2 converted trikes that we gave away to senior citizens. Our doctor, dentist and dogs vet are only a few blocks away. We have 4 supermarkets, 2 drug stores, 2 coffee shops, several restaurants, fast food restaurants all in triking distance. There is also a Walmart and Target store close by. We are in our 80s so I don't know how long I can drive in the future. The convenience of the Trikes will give us independence. Our Trikes are one of our best purchases and we're happy we found Liberty Trikes.",
  response: "Glenn and Kathy, it\’s fantastic to hear how much you both enjoy your Liberty Trikes and the independence they provide. We\’re delighted that our trikes have become such a valuable part of your daily lives, making it easy to get around and stay active. Thank you for sharing your wonderful experience!"
},
{
  name: "Karen N.",
  date: "July 23, 2024",
  title: "Morning Ride to Saw Mill Pond",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/KarenN-Liberty_Trike.png?v=1721916184",
  video: "",
  html5video: "",
  comment: "Having so much fun on my Liberty Trike. Morning ride to Saw Mill Pond South Lake Tahoe, Ca.",
  response: "Karen, it’s wonderful to hear how much fun you’re having on your Liberty Trike! Your morning ride to Saw Mill Pond sounds delightful. We’re so glad you’re enjoying the beautiful scenery of South Lake Tahoe. Keep enjoying those fantastic rides!"
},
{
  name: "Wendy F.",
  date: "July 22, 2024",
  title: "Life Made Easier with LT",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/WenduF_-_Liberty_Trike.jpg?v=1721916757",
  video: "",
  html5video: "",
  comment: "Indy (Indigo Girl) and I visited the local pharmacy in a super-sized grocery store to get my next Covid bivalent booster. Then I cruised the aisles and picked up some groceries. Having my LT sure has made life easier!",
  response: "Wendy, it’s fantastic to hear how your Liberty Trike has made life easier for you! Being able to visit the pharmacy and pick up groceries with Indy must be incredibly convenient. We’re thrilled that your LT is helping you with your daily errands. Keep enjoying the freedom and ease it brings!"
},
{
  name: "Brian F.",
  date: "July 22, 2024",
  title: "Anniversary Ride in Glacier Park",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/BrianF-Liberty_Trike_df921ab5-ae38-4b63-a7b8-350fa13d3f9b.png?v=1721915743",
  video: "",
  html5video: "",
  comment: "Biking at Apgar Village trail - Glacier Park, Montana along Lake MacDonald and Flathead River - so awesome for our July 21st, 51st Wedding Anniversary.",
  response: "Brian, congratulations on your 51st Wedding Anniversary! We’re thrilled to hear that you celebrated with an amazing ride in Glacier Park. Your adventure sounds incredible, and we’re honored that your Liberty Trike was part of such a special occasion. Here’s to many more joyful rides together!"
},
{
  name: "Julie H.",
  date: "July 21, 2024",
  title: "LT Adventures Across 27 States",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JulieA-_Liberty_Trike.jpg?v=1721916887",
  video: "",
  html5video: "",
  comment: "We have an ultratow carrier with a ramp that will hold 2 LTs if you load them the right way. We have taken our trikes through 27 states so far with ours on the back. We normally put a blue tarp down first, get the trikes in place, lock the ramp upright, use ratchet straps to hold the trikes firmly in place on the carrier, bring the blue tarp sides up and secure them on all 4 sides to the trikes so it keeps dust and water off of them from the bottom, then we put a large BBQ cover over the top and secure that on all sides with a cargo net, followed by bungee cords that will hold the whole thing down so there is no flapping of tarps or covers.",
  response: "Julie, your setup for transporting the Liberty Trikes across 27 states is impressive! It's great to hear how you’ve managed to keep them safe and secure on your journeys. We’re delighted that your LTs have accompanied you on so many adventures. Happy travels and safe riding!"
},
{
  name: "Martha M.",
  date: "July 19, 2024",
  title: "Robin is My Transportation",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/MarthaM_-_Liberty_Trike.png?v=1721917055",
  video: "",
  html5video: "",
  comment: "Robin does so much for me. She's my wheels transportation. Shopping to envirodepot. People look and admire the liberty trike. I hope it makes people think where our food comes from. I hope",
  response: "Martha, we're thrilled to hear that Robin, your Liberty Trike, is such a valuable part of your life and transportation! It's wonderful that your trike is sparking admiration and thoughtful conversations in your community. Keep enjoying your rides and inspiring others!"
},
{
  name: "Anna M.",
  date: "July 16, 2024",
  title: "Rediscovering Joy with Bluey",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/AnnaM_-_Liberty_Trike.png?v=1721918168",
  video: "",
  html5video: "",
  comment: "I bought my LT about 2 years ago. I was caring for my 90 yo father with Alzheimer’s. Until this week I had not ridden it…. Partially grief, partly intimidation. As of today I have over 15 miles on “Bluey” (because my granddaughter’s love Bluey). I have seen places on trails near my home that I have wanted to see. So much fun!! I have also contacted customer service, and they are excellent at helping resolve issues.",
  response: "Anna, we're so glad to hear that you've been able to get out and enjoy your Liberty Trike, 'Bluey.' It sounds like it's been a wonderful way for you to explore new places and find joy again. We're here to support you whenever you need it. Happy riding and take care!"
},
{
  name: "RevTricia M.",
  date: "July 14, 2024",
  title: "Adventures with Spirit",
  score: 5,
  image: "",
  video: "",
  html5video: "https://cdn.shopify.com/videos/c/o/v/ded7cded9257472992c1877c35057a55.mp4",
  comment: "Another wonderful adventure with Spirit enjoying the blessings of being in Mother Nature and being in my happy! ✨🤗✨",
  response: "RevTricia, it's fantastic to hear about your joyful adventures with Spirit in the great outdoors! We're thrilled that your Liberty Trike allows you to connect with nature and find happiness. Keep enjoying those beautiful moments, and if you need any support, we're here for you!"
},
  {
  name: "Lucia G.",
  date: "July 12, 2024",
  title: "Beautiful Ride on the Empire State Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/LuciaG-Liberty_Trike.jpg?v=1721058946",
  video: "",
  html5video: "",
  comment: "Last week we rode our trike 20 miles, in 2 1/2 hours. We bought an extra battery, which is what helped get us this far. I was worried we wouldn’t make it back to the car, but we did with one line on the battery left. We rode the Empire State Trail in Hudson Valley NY. It was a beautiful ride.",
  response: "Lucia, we're thrilled to hear about your amazing 20-mile ride on the Empire State Trail! It's great that your extra battery helped you enjoy the beautiful Hudson Valley without worry. Thank you for sharing your experience, and keep on exploring those scenic trails!"
},
{
  name: "Ronny C.",
  date: "July 11, 2024",
  title: "Excited for the New Liberty Trike!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Linda-Liberty-Trike.jpg?v=1721057473",
  video: "",
  html5video: "",
  comment: "Thank you for all of your comments. Thanks to this group I found Electric Bike Technologies in Croyden just outside of Philadelphia. I visited there this afternoon and met Linda (in photo), who showed me around and I got to see all of their ebikes and etrikes. They have a new Liberty Trike coming out, one with 20\" tires so I put my name on the preorder list for when it's ready. Can't wait to get it. Thank you for all of your advice. (I previously owned a Lectric trike and a HJM trike so I'm excited about the new Liberty)",
  response: "Ronny, we're delighted to hear that you visited our Electric Bike Technologies location and met Linda! We're excited that you've decided to preorder the new Liberty Trike with 20\" tires. Your enthusiasm and support mean a lot to us, and we can't wait for you to enjoy your new trike. If you have any questions or need assistance, feel free to reach out. Happy riding!"
},
{
  name: "Debbie L.",
  date: "July 7, 2024",
  title: "Perfect Fit for Pickles",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/DebbieL-Liberty_Trike.jpg?v=1720357798",
  video: "",
  html5video: "",
  comment: "Oh my goodness ~ Pickles fits perfectly under my bed in the back of Janis!!! ❤️ Pickles ~ Liberty Trike Janis ~ Winnebago Solis",
  response: "Debbie, we're so glad to hear that Pickles fits perfectly under your bed in Janis! It sounds like you're all set for some wonderful adventures. Thank you for sharing your delightful setup with us. Happy travels with Pickles and Janis!"
},
  {
  name: "Marla L.",
  date: "July 7, 2024",
  title: "Enjoying Oregon's State Parks",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/MarlaH-LibertyTrike.jpg?v=1720357959",
  video: "",
  html5video: "",
  comment: "Living in Oregon, we enjoy our beautiful State Parks and do a lot of camping. Really having fun with my Liberty E-trike! Did a lot of reading & searching, glad I decided on the Liberty Trike!",
  response: "Marla, we're so glad to hear that you're enjoying your Liberty Trike while exploring Oregon's beautiful State Parks! It sounds like you've made a wonderful choice, and we're delighted to be a part of your adventures. Happy riding and camping!"
},
  {
  name: "Heidi C.",
  date: "July 6, 2024",
  title: "New Liberty Trike Owner",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/HeidiC-Liberty_Trike.jpg?v=1720358114",
  video: "",
  html5video: "",
  comment: "Got this Beauty yesterday! In love with it already. Can someone tell me how we can hook up the bike trailer we have for the dogs? 🙏",
  response: "Heidi, congratulations on your new Liberty Trike! We're thrilled to hear that you're already in love with it. For hooking up a bike trailer for your dogs, you can use a universal bike trailer coupler. These can usually be attached to the rear axle of the trike. If you need more detailed assistance, feel free to contact our customer support team, and they'll be happy to guide you through the process. Enjoy your rides with your furry friends!"
},
  {
  name: "Ann S.",
  date: "July 6, 2024",
  title: "Beautiful Day on the High Trestle Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/AnnS-Liberty-Trike.jpg?v=1720358020",
  video: "",
  html5video: "",
  comment: "Rode on the High Trestle Trail near Madrid, Iowa. The Trail is an old railroad line. The bridge crosses the Des Moines river, which as you can see has flooded. Was a beautiful day, and lovely ride. We love our trikes!",
  response: "Ann, it sounds like you and Betty had an amazing day riding your trikes on the High Trestle Trail! The scenic beauty and the joy of riding together must have made it a memorable experience. We're thrilled to hear how much you love your Liberty Trikes. Keep enjoying those beautiful rides!"
},
{
  name: "Carol Y.",
  date: "July 6, 2024",
  title: "Ready for the July 4th Parade",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/CarolY-Liberty_Trike_d031d195-9973-446e-94fc-7037558cea4b.jpg?v=1720357902",
  video: "",
  html5video: "",
  comment: "Getting ready to march in the July 4th parade. Mara is my friend who is a candidate I'm supporting. She was like the Energizer Bunny, dancing her way along the whole route.",
  response: "Carol, it sounds like you had an amazing time preparing for the July 4th parade! We're thrilled to hear about your support for Mara and how much fun you had. Thank you for sharing this joyful moment with us. Keep dancing and riding!"
},
{
  name: "Johanna J.",
  date: "July 5, 2024",
  title: "Meeting Pia the Peacemaker",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/JohannaJ-Liberty_Trike.jpg?v=1720357646",
  video: "",
  html5video: "",
  comment: "Just met Pia the Peacemaker, one of the Pacific Northwest Trolls!",
  response: "Johanna, that sounds like an amazing adventure! Meeting Pia the Peacemaker must have been a unique experience. We’re thrilled that your Liberty Trike is taking you to such interesting places. Keep exploring and enjoying the journey!"
},
  {
  name: "Margie N.",
  date: "June 29, 2024",
  title: "First Day Out on My New Teal Liberty Trike!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/MargieN-Liberty_Trike.png?v=1720358840",
  video: "",
  html5video: "",
  comment: "Today was my first day out on my new teal Liberty Trike, and I absolutely love it! Thank you to Linda Cooke from whom I learned that it is possible to keep your Liberty Trike in your Prius and assemble and disassemble whenever you want to ride - even when you are in your seventies.",
  response: "Margie, we're thrilled to hear that you had such a wonderful first day out on your new teal Liberty Trike! It's fantastic that Linda's advice has helped you enjoy the convenience of assembling and disassembling your trike with ease. Keep enjoying your rides, and if you ever need any assistance, we're here to help!"
},
{
  name: "Linda B.",
  date: "June 28, 2024",
  title: "Maggs is Ready for July 4th!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/Linda_B-Liberty_Trike.png?v=1720358721",
  video: "",
  html5video: "",
  comment: "6/28 Maggs is ready for July 4th.",
  response: "Linda, it's fantastic to hear that Maggs is all set for the July 4th celebrations! We hope you both have a wonderful time and enjoy the festivities. If you need any assistance or have any questions, we're here to help. Happy riding!"
},
{
  name: "Renda G.",
  date: "June 28, 2024",
  title: "Fewmets Ready for His Maiden Voyage!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/Renda_G_-_Liberty_Trike.jpg?v=1720358564",
  video: "",
  html5video: "",
  comment: "Fewmets (and tag-a-long) Ready for his maiden voyage! Liberty Trike with kid hauler shown",
  response: "Renda, we're thrilled to hear that Fewmets is all set for his maiden voyage with the Liberty Trike and kid hauler! It sounds like a fun and exciting adventure awaits. If you need any assistance or have any questions, we're here to help. Enjoy your rides!"
},
{
  name: "Loretta B.",
  date: "June 26, 2024",
  title: "Great Service and New Mag Wheels!",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/LorettaB-_Liberty_Trike.jpg?v=1720358943",
  video: "",
  html5video: "",
  comment: "Stopped at Liberty Trike for a checkup on my trike which has 2500 miles on it. Got new tires and tubes and new mag wheels. Thanks so much to Jason and the team at Liberty! As always, great service! I’m styling now!",
  response: "Loretta, we're delighted to hear about your positive experience with our service team! Congratulations on hitting 2500 miles and enjoying your new tires, tubes, and mag wheels. It's wonderful to know that you're styling and ready for more adventures. If you need anything else, don't hesitate to reach out!"
},
{
  name: "Carol R.",
  date: "June 26, 2024",
  title: "Scoot Scoot Adventures",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/CarolL-Liberty_Trike.jpg?v=1720359085",
  video: "",
  html5video: "",
  comment: "Having great fun in Leavenworth, Washington, a Bavarian town in the middle of gorgeous mountains. Camping by the Icicle River and took my trike on the Blackbird Island and Enchantment trails. Even took it to wander around the cute downtown. I wouldn’t have been able to walk that far. I ❤️ my Scoot Scoot (what my family named my trike 🤣).",
  response: "Carol, we're so glad to hear that Scoot Scoot is making your adventures in Leavenworth so enjoyable! It sounds like a beautiful place to explore, and we're thrilled that your Liberty Trike is helping you experience it all. If you ever need any assistance or have questions, we're here to help. Happy trails!"
},
{
  name: "Elaine O.",
  date: "June 25, 2024",
  title: "Riding in Portugal",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/ElaineO-Liberty_Trike.jpg?v=1719318271",
  video: "",
  html5video: "",
  comment: "I live in Portugal, brought my trike with me when we moved here 2 years ago. I ride on bumpy cobblestones and uneven road surfaces and up hills - oh, the hills!! - and so far it’s handled it all very well. Going downhill sometimes I chicken out as my left hand isn’t strong for holding the brake (I know to pedal backwards too) so sometimes I get off and walk as I don’t want to go hurtling down too fast! Would love to know if there are any other Liberty owners here or am I the only one?",
  response: "Elaine, it's wonderful to hear how well your Liberty Trike is handling the beautiful, yet challenging, terrain of Portugal! We’re glad it’s bringing you joy and mobility. Don’t worry, taking it slow on those steep hills is a wise decision. We hope you find fellow Liberty Trike owners in your area soon. Keep enjoying your adventures and stay safe!"
},
{
  name: "Lynne K.",
  date: "June 24, 2024",
  title: "Beautiful Morning Ride on the Centennial Trail",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/LynneK-Liberty_Trike.jpg?v=1719318511",
  video: "",
  html5video: "",
  comment: "Hi from Washington took the Busy 🐝 Bee out on the Centennial Trail between Washington/ Idaho border, that is the Spokane river. Beautiful morning for a ride. Peace to all✌️😍",
  response: "Lynne, we're delighted to hear about your beautiful morning ride on the Centennial Trail! It sounds like a wonderful way to enjoy the day. Peace to you too, and happy riding!"
},
{
  name: "Laura F.",
  date: "June 22, 2024",
  title: "Laverne at Summerfest",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Laura-Liberty_Trike.jpg?v=1719318625",
  video: "",
  html5video: "",
  comment: "I'm pretty sure that Laverne was the first e-trike to roll through the Summerfest music festival in Milwaukee, Wisconsin!",
  response: "Laura, it's fantastic to hear that Laverne made history at the Summerfest music festival! We're thrilled that your e-trike could be part of such a fun event. Keep enjoying those unique and memorable rides!"
},
{
  name: "Sylvia B.",
  date: "June 22, 2024",
  title: "Enjoying Life with Liberty Trike",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0258/1928/3509/files/SylviaB-_Liberty_Trike.jpg?v=1720359008",
  video: "",
  html5video: "",
  comment: "Love all the posts from Liberty Trike owners. I'm so happy that I decided to purchase mine last September after seeing it at a bluegrass festival. The nice lady gave me a card and I took it from there. I'll be 84 in October and enjoying my life with my Liberty Trike.",
  response: "Sylvia, it's fantastic to hear how much you're enjoying your Liberty Trike! We're thrilled that a chance encounter at a bluegrass festival led you to join our community. Here's to many more happy rides and new adventures. If you ever need assistance or have any questions, we're here for you. Happy early birthday and keep enjoying your rides!"
},
{
  name: "Janet G.",
  date: "June 17, 2024",
  title: "Father's Day Surprise",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/mr_paul-_liberty_trike.jpg?v=1719319194",
  video: "",
  html5video: "",
  comment: "So the trike I ordered was supposed to be for my mom. She suggested that this one should be dad's instead…so I saved it for Father's Day and here he is. He’s such a big kid and he took off on it after a quick tutorial by someone (me) who read all the instructions for him first (and took it for several test drives). I parked around the corner from their house and rode up on it. He was so excited! Maybe mom will see how much fun it is and want one next (I think she was a little afraid).",
  response: "Janet, what a wonderful Father's Day surprise for your dad! It's heartwarming to hear how much he enjoyed his new Liberty Trike. We hope your mom sees the fun and joins in soon. Enjoy your rides together!"
},
{
  name: "Patty",
  date: "June 17, 2024",
  title: "Grateful for Liberty Trike",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Patty-O-Liberty_Trike.png?v=1718642206",
  video: "",
  html5video: "",
  comment: "Hi Janet, It's me again, but this time, I don't have any problems to complain about. Err, I have problems, but it is nothing I need your help with. Today, I went to church and picked up Holy Communion to take to a 94 years old woman. Guess what? The battery doesn’t work unless you put the key in and turn it on. Surprise! I was resigned to pushing my trike a mile and a half uphill before I finally figured it out. Just felt like dropping you a line to thank you all at Liberty Trike. I was just reading reviews about Speedrid bikes and the horrible lack of service that buyers have experienced and felt grateful that I invested in such a reputable company: YOURS! I do love all your videos and especially appreciate the prompt customer service. I have been handing out cards and giving great reviews to the many admirers of my \"hot pink, Barbie, bike.\" Even teenagers gasp and praise my bike. I tell you, it was an awful experience when I 1) totaled my car by falling asleep going 50 mph on a major street and 2) realized that my driving days were over. The kind policeman didn’t even write me a ticket since no one else was involved and \"the tree I hit will recover, the grass will grow back, and I didn’t even break a single water sprinkler.\" Hallelujah! Ya, it was scary to imagine a life without driving a car as I’ve done so for 55 years. But thanks to my Liberty Trike, I am outdoors, getting a tan and feeling the wind in my helmeted hair. A friend of a friend recommended your company to me and I sincerely feel as though you all have integrity. It shows with every communication I have had with Liberty. So today is Sunday, the Lord’s Day, and I chose to drop you a line right after I said a prayer for all your employees. Blessings, Patty",
  response: "Patty, thank you so much for your heartfelt message. We’re thrilled to hear that your Liberty Trike has made such a positive impact on your life, allowing you to stay active and enjoy the outdoors. Your story is truly inspiring, and we’re grateful for your kind words and prayers. If you ever need any assistance, we’re always here to help. Wishing you many more happy rides and blessings!"
},
{
  name: "RevTricia M.",
  date: "June 15, 2024",
  title: "Adventure Rides in Nature",
  score: 5,
  image: "",
  video: "",
  html5video: "https://cdn.shopify.com/videos/c/o/v/e13843796e68405b80392787f17f0ff5.mp4",
  comment: "Yosemite National Park. 🏞️ We absolutely love our adventure rides in nature. Me with Spirit, my Liberty \"Freedom\" Trike, and my hubby with his electric scooter. We prefer nature rides to street rides, because that's what our heart's desire. And \"Spirit\" is amazingly adept and capable of riding on various nature trails. She's not so keen or productive on gravel or sand though. And here's a helpful tip for all of you fellow LT owners: If you're traversing a hill and your trike starts to really slow down, and is close to stopping, start swerving sideways from side to side instead of straight up and it will help you to get up the hill 🤗.",
  response: "RevTricia, thank you for sharing your adventure in Yosemite with Spirit, your Liberty \"Freedom\" Trike! We're thrilled to hear about your love for nature rides and your helpful tip for navigating hills. It's fantastic to know that Spirit is helping you explore the great outdoors. If you ever need any assistance or have questions, we're here to support you. Enjoy your beautiful rides!"
},
{
  name: "Jan L.",
  date: "June 12, 2024",
  title: "We are never too old to go adventuring.",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/janl-liberty_trike.jpg?v=1718217283",
  video: "",
  html5video: "",
  comment: "The trike pictured is our first one, purchased just a couple of weeks ago, The second one, a beautiful water blue, arrived last Friday and is in our Subaru Outback waiting for the next outing, which is why I have no photo of it.\n\nMy husband has the same spinal and hip problems that effect many octogenarians. Over the years, his ability has dwindled from being able to hike the nearby hills, to struggling to walk from the front door to the mailbox and back. We ordered a Liberty etrike, hoping he would be able to ride for an extended period of time without aggravating his pain and it passed the test with all flags flying.\n\nFor our first adventure, we packed up both trikes and took them to the parking lot of our local Wally's. We reassembled them there and rode them into the store, where they created quite a buzz. Someone even stopped us to snap a photo for his Mom, texting her that he had found her new wheels.\n\nHusband Johnny likes his trike so much that he now wants to equip it with an \"Easy Rider\" style seat and handlebars. We stopped at \"Alcorn Adaptive Bike and Mobility Shop\" in Palm Springs, to see if they can do that and were happy to learn that they rep Liberty etrikes. We'll be taking Johnny's bike in next week, to talk about the mods he wants.\n\nBased on the public reception the trikes are getting, I expect will will also be sending them lots of new customers in the near future.",
  response: "Jan, thank you for sharing your wonderful story! We're delighted to hear how much you and Johnny are enjoying your Liberty Trikes and the newfound freedom they bring. It's heartwarming to know that Johnny is planning to customize his trike even further to suit his needs. Your adventures and the buzz created at Wally's are exactly what we hope for our customers. We look forward to hearing about more of your outings and any new customers you send our way. Keep adventuring and enjoying every moment!"
},
{
  name: "Karen S.",
  date: "June 11, 2024",
  title: "New Trike Adventures with Sadie",
  score: 5,
  image: "https://cdn.shopify.com/s/files/1/0865/1792/files/KarenS-Liberty_Trike.jpg?v=1719318326",
  video: "",
  html5video: "",
  comment: "I just got my bike and I love it! My dog Sadie wanted to help. I would like to take her along, do any of you use the basket for your dog?",
  response: "Karen, congratulations on your new Liberty Trike! We’re thrilled to hear you and Sadie are enjoying it. Many of our trike owners do use the basket for their furry friends. Just make sure Sadie is securely harnessed in for safety. Enjoy your rides together and let us know if you have any questions or need tips!"
},
{
  "name": "Lynne K.",
  "date": "June 9, 2024",
  "title": "Grateful for Freedom of Movement",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/Lynne_K-Liberty-Trike.jpg?v=1717952750",
  "video": "",
  "html5video": "",
  "comment": "I am 70,soon to be 71,I have severe arthritis in hips,knees and am unable to walk properly anymore,One leg is 3 in.shorter and because my body is twisting to overcompensating for it.My Busy 🐝 Bee has given me the Liberty to move again and get to places I have haven't been able too.I love my trike and am very grateful 🥰😍",
  "response": "Lynne, your story is truly inspiring! We're so glad to hear that your Busy 🐝 Bee Liberty Trike has given you the freedom to move again and explore places you haven't been able to visit before. Thank you for sharing your experience with us. Wishing you many more joyful rides ahead!"
},
{
  "name": "Judith HN.",
  "date": "June 8, 2024",
  "title": "Great Island Adventure",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/judithhn-liberty_trike.jpg?v=1717952593",
  "video": "",
  "html5video": "",
  "comment": "Just took my new Liberty Trike on the first official outing. Folded it up, put it in the Ford Explorer and drove to Jekyll Island, GA. Rode my trike all over the island. It was GREAT!!!",
  "response": "Judith, what an amazing island adventure! We're thrilled to hear that your first official outing with your Liberty Trike on Jekyll Island was such a success. Thank you for sharing your experience with us. Here's to many more fantastic rides ahead!"
},
  {
  "name": "Susan EC",
  "date": "June 1, 2024",
  "title": "Enjoying the Ride at 80",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/Sue_EC-Liberty-Trike.jpg?v=1717953948",
  "video": "",
  "html5video": "",
  "comment": "Violet and me; I turned 80 this year. Had her about 18 months and enjoy riding around town with a friend but we also trailer them to bike trails within a 50 mile radius. Can't wait until the local Calumet Trail is upgraded and paved.",
  "response": "Susan, it's wonderful to hear how much you're enjoying your rides with Violet at 80! Riding around town and exploring bike trails within a 50-mile radius sounds like a fantastic way to stay active and enjoy the outdoors. We hope the local Calumet Trail gets upgraded soon so you can continue to experience new adventures. Happy riding!"
},
{
  "name": "Jan L.",
  "date": "June 1, 2024",
  "title": "Exceeded Expectations",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/JanL-LibertyTrike.jpg?v=1717509914",
  "video": "",
  "html5video": "",
  "comment": "Trike No. 1 arrived Tuesday, I assembled it and we took it for test drives on Wednesday. Between yesterday and today (Thursday), my 82 year old husband, and my 74 year old self  have put about 8 miles on it. We live in a rural community, with some stretches of rough and unpaved roads but the Liberty e trike handles occasional ruts and sand drifts without straining. I must be stronger than I thought as I am able to lift each half of the bike into a Subaru Outback, without assistance. As soon as  we figure out how to load two bikes (ordered Trike No. 2, today), plus luggage and traveling cat, we will be  searching out the best  bike trails in So. California.",
  "response": "Jan, we're thrilled to hear that your experience with the Liberty eTrike has surpassed your expectations! It's fantastic to know that it's handling the rural roads and occasional rough terrain with ease. Your determination to assemble and transport the trike is truly impressive. We're excited for you and your husband to explore the beautiful bike trails of Southern California. Safe travels and happy riding!"
},
{
  "name": "Ana R.",
  "date": "May 20, 2024",
  "title": "A Hit with Scotty Too!",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/AnaR-LibertyTrike.jpg?v=1716233616",
  "video": "",
  "html5video": "",
  "comment": "Like my new trike, however Scotty likes it more!",
  "response": "Ana, it\'s heartwarming to hear that both you and Scotty are enjoying the new trike! Thanks for sharing. Wishing you both many happy rides together!"
},
{
  "name": "Debra FM",
  "date": "May 19, 2024",
  "title": "Life-Changing Lifeline",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/Debra-FM-Liberty_Trike.jpg?v=1716233964",
  "video": "",
  "html5video": "",
  "comment": "I purchased my trike a year ago, happy that I could ride a trike like this! This past week, I rode The Adirondack Rail Trail that is currently between Lake Placid to Saranac and beyond. I had been riding in my neighborhood about 2.5 miles. I rode 6 total miles and probably could have gone further, but I didn’t want to push it too much. I have spinal stenosis, use a cane, and my Liberty Trike has been my lifeline! I love you all! Miss Daisy and I appreciate you!",
  "response": "Debra, your journey on the Adirondack Rail Trail sounds truly amazing! We're thrilled to hear that your Liberty Trike has provided you with newfound freedom and joy, especially in the face of challenges like spinal stenosis. Thank you for sharing your inspiring story with us. Wishing you and Miss Daisy many more memorable rides together!"
},
{
  "name": "Denny D.",
  "date": "May 18, 2024",
  "title": "Mother's Day Gift: Ready for Adventure",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/DennyD-Liberty_TRike.jpg?v=1716233103",
  "video": "",
  "html5video": "",
  "comment": "She got her trike in time for Mother's day. Tomorrow (Monday) heading to Tucker Hollow campground at Bull Shoals for several days of riding her new trike.",
  "response": "Denny, it's wonderful to hear that she received her trike just in time for Mother's Day! Heading to Tucker Hollow campground sounds like an exciting adventure. We hope she enjoys several days of riding her new trike and creates unforgettable memories!"
},
{
  "name": "Nicole L.",
  "date": "May 16, 2024",
  "title": "Excited to Start Riding with My Liberty Trike",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/Nichole_L.jpg?v=1716232925",
  "video": "",
  "html5video": "",
  "comment": "And I’m off!!!!!! My e-bike has a battery, so I don’t have to pedal when I don’t want to. 😎 The hardest part will be practicing getting the trike in and out of my complex, in and out the elevator, etc (my brother did it today). It’s complicated. P.S. I’m on speed 2/5. 😉",
  "response": "Nicole, it's fantastic to hear that you're excited to start riding with your Liberty Trike! We understand that maneuvering the trike in and out of your complex can be challenging, but we're confident that with practice, it'll become easier for you. Enjoy exploring at speed 2/5, and may your rides be filled with joy and freedom!"
},
{
  "name": "Pam B.",
  "date": "May 15, 2024",
  "title": "Loves Riding",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/PamB_Liberty_Trike.png?v=1715804215",
  "video": "",
  "html5video": "",
  "comment": "I am 76, have an arthritic knee, and am so enjoying the freedom of movement, fresh air, scenery, and friendly people of the Ohio River Trail on my Liberty Trike named Matilda. I wholeheartedly recommend the Liberty trike.",
  "response": "Pam, thank you for sharing your wonderful experience riding Matilda on the Ohio River Trail! It's fantastic to hear that despite having an arthritic knee, you're able to enjoy the freedom, fresh air, and beautiful scenery. We're thrilled that the Liberty Trike has brought you such joy and independence. Happy riding!"
},
{
  "name": "Connie K.",
  "date": "May 2, 2024",
  "title": "Exciting 12-Mile Ride Along Long Beach Promenade",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/ConnieK-Liberty-Trike.png?v=1714745921",
  "video": "",
  "html5video": "",
  "comment": "I completed my longest ride so far...12 miles! Bambi loves riding on the back of Pinkie the Trike. She starts to bark whenever I stop. This was on the promenade in Long Beach, CA, along the marina and the ocean. A wonderful ride!",
  "response": "Connie, congratulations on your thrilling 12-mile ride along the Long Beach promenade! It sounds like Pinkie the Trike and Bambi make quite the dynamic duo. We're delighted to hear that you both enjoyed the beautiful scenery and ocean breeze. Here's to many more memorable rides ahead!"
},
{
  "name": "Kevin O.",
  "date": "May 1, 2024",
  "title": "Excited for New Adventures with BonnieBlueButler",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/Kevin_O_-_Liberty-Trike.jpg?v=1714745667",
  "video": "",
  "html5video": "",
  "comment": "My trike arrives tomorrow...after a decade of pesky mobility issues & recent loss of 200 lbs. am SO excited about my coming \"broadening world\"- i'm tickled \"BLUE\"!🌎🌍🌏🌈🌈🌈💙💙💙(chose blue to match my walker...) I live in a big old vintage building- a renovated former high school- that is now senior apartments... I'll ride several days around the 3 floors of corridors here to familiarize myself w/ my new \"BonnieBlueButler (named after Scarlet & Rhett's little girl in GoneWithTheWind) first- then on May 4th venture out to my town's first Summertime SaturdayMorningDowntownFarmer'sMarket of the season, 5 blocks away at the historic courthouse square. 🍎🍐🍇🍉🍓🠀󄀼󤠼󤐾񩠾񤐼󡐼󟐾󄐾񥐾򁐾񤠼󝠠I've not been this excited about the coming summer season since i was a kid! 😀😀😀 (You've all been so helpful w/ all my questions- thank you!💜)",
  "response": "Kevin, congratulations on the arrival of your trike, BonnieBlueButler! We're thrilled to be part of your journey toward a broadening world and newfound adventures. Your enthusiasm is contagious, and we're excited for you to explore your town's farmer's market and beyond. Enjoy your rides, and thank you for being part of our community!"
},
{
  "name": "Lynne K.",
  "date": "April 25, 2024",
  "title": "Perfect Fit for Short Stature and Hip Issues",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/LynneK-Liberty-Trike.png?v=1714069679",
  "video": "",
  "html5video": "",
  "comment": "I am 4'9 1/2 ,we just got ours and we love them! I have no problem either this trike,I reviewed for almost a year and decided on this trike,I have severe hips issues and cannot walk well ,plus I have short leg syndrome so balance is an issue with me. This trike fits all my needs.",
  "response": "Lynne, we're thrilled to hear that your Liberty Trike is a perfect fit for you and addresses your specific needs. It's wonderful to know that you've found such a great solution despite your challenges. Thank you for choosing us, and we wish you many happy rides ahead!"
},
{
  "name": "Jennifer Z.",
  "date": "April 17, 2024",
  "title": "Empowering Ride with Parkinson's",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/JenniferZ-Liberty-Trike_6ae36e17-4eb4-46f5-a0be-98fbe01c51f6.png?v=1714069931",
  "video": "",
  "html5video": "",
  "comment": "I have Parkinson’s, and my Liberty Trike is great - have put 255 miles on it in the last 2 years!",
  "response": "Jennifer, thank you for sharing your experience with us. We're thrilled to hear that your Liberty Trike has been a source of empowerment for you despite the challenges of Parkinson's. Your dedication to riding and the miles you've put on it are truly inspiring. Keep enjoying the freedom and mobility your trike provides!"
},
{
  "name": "Sara C.",
  "date": "April 16, 2024",
  "title": "Smooth Sailing on Three Wheels",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/SaraC-Liberty-Trike.png?v=1713548488",
  "video": "",
  "html5video": "",
  "comment": "I received my trike the day we left for our trip in the newer motor home to view the eclipse.  We took it out of the box and stored it in the compartment.  After several days it was put together and I rode on a very rough gravel road.  Slow is my advice.  I felt better on 3 wheels than I did on Two. Happy days are here again.",
  "response": "Sara, thank you for sharing your experience with us! It's wonderful to hear how your Liberty Trike added joy and comfort to your travel adventures, especially on rough terrain. Taking it slow and steady is excellent advice for getting accustomed to your new ride. Here's to many more happy days ahead with your trike!"
},
{
  "name": "Kerry A.",
  "date": "April 12, 2024",
  "title": "Trail Break",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/KerryA-Liberty-Trike_416fb3a0-6cb0-4453-a3c9-cdddb8227924.jpg?v=1713016536",
  "video": "",
  "html5video": "",
  "comment": "Taking a break on the Pinellas Trail in Florida!",
  "response": "Kerry, it looks like you're enjoying a wonderful ride! Taking breaks on scenic trails like the Pinellas Trail sounds like a fantastic way to enjoy the outdoors. Keep pedaling and enjoying the journey!"
},
{
  "name": "Kim M.",
  "date": "April 10, 2024",
  "title": "Building Confidence with Each Ride",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/KimM-Liberty-Trike.jpg?v=1713018182",
  "video": "",
  "html5video": "",
  "comment": "I felt like you at first. I had to lean to the right to feel comfortable. Kept putting my feet down too-lol. I must have looked so funny!! Congratulated myself each time I went out as was scared. Grew more confident each time. Now I take it out on all different surfaces - even attach my dog. I love love love it! I think you will too! I had to pace myself and go slow until I felt more secure. I believe you will get there too!!! Good luck!!",
  "response": "Kim, thank you for sharing your journey and tips for building confidence with your Liberty Trike! It's inspiring to hear how you overcame initial challenges and embraced the experience. Your encouragement will surely help others navigate their own learning curve. Keep enjoying your rides and the companionship of your furry friend!"
},
{
  "name": "Ann S.",
  "date": "April 10, 2024",
  "title": "First Ride Joy",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/AnnS-Liberty-Trike.jpg?v=1713016532",
  "video": "",
  "html5video": "",
  "comment": "Just bought our trikes and went for our first ride. Love them!",
  "response": "Ann, congratulations on your new trikes! It's fantastic to hear that you enjoyed your first ride. May your Liberty Trikes bring you many more joyful adventures in the days ahead!"
},
{
  "name": "Ginny H.",
  "date": "April 11, 2024",
  "title": "Back on the Trike",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/GinnyH-Liberty-Trike.jpg?v=1713016672",
  "video": "",
  "html5video": "",
  "comment": "Finally, got out on my Trike after 6 months! Not much of a Winter here in MN. Had a beautiful day for a 9 mile ride!",
  "response": "Ginny, it's wonderful to hear that you're back on your trike and enjoying the beautiful weather! Here's to many more sunny rides ahead. Keep on rolling!"
},
{
  "name": "Ashberry P.",
  "date": "April 10, 2024",
  "title": "Scenic Ride at Lake Powell",
  "score": 5,
  "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/AshberryP-Liberty-Trike_6a524c7c-9f63-4b2d-be3c-ef6bca83a65e.jpg?v=1713016528",
  "video": "",
  "html5video": "",
  "comment": "In front of Lake Powell.",
  "response": "Ashberry, what a stunning backdrop for a ride! Thank you for sharing this beautiful moment with us. Wishing you many more scenic adventures on your Liberty Trike!"
},
{
  name: 'Laurie M.',
  date: 'April 9, 2024',
  title: 'Artful Adventures',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LaurieCraigM-Liberty-Trikes.jpg?v=1712693710',
  video: '',
  html5video: '',
  comment: 'Ringling Museum of Art by the Bay. Beautiful Day.',
  response: 'Sounds like a lovely day, Laurie! Exploring art and enjoying the beauty of the bay sounds like a perfect way to spend your time. Thanks for sharing your experience!'
},
{
  name: 'Richard U.',
  date: 'April 8, 2024',
  title: 'Adventures with Furry Friends',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/RichardU-LibertyTrike.jpg?v=1712693805',
  video: '',
  html5video: '',
  comment: 'We went out again with our dogs last evening. Over 3-miles riding now. Yesterday, I finished building a cargo carrier large enough to fit both (fully assembled). I\'m still working out the tie down strategy for keeping it simple. My latest idea is using Velcro strips threaded though the expanded steel flooring of the carrier and through the wheel, around each tire. I haven\'t tried that out yet but I did tie them down with ratchet straps much in the same way. That takes a while though. Any other good tie down ideas?',
  response: 'It sounds like you and your furry friends are having some great adventures, Richard! Your cargo carrier idea with Velcro strips sounds innovative. Another idea could be using bungee cords or adjustable straps to secure the cargo carrier to the trike. Experimenting with different methods will help find the best solution for your needs. Happy riding!'
},
  {
  name: 'Nancy W.',
  date: 'April 7, 2024',
  title: 'Enjoyable Ride on St. Marks Trail',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/NancyW-LibertyTrike.jpg?v=1712693909',
  video: '',
  html5video: '',
  comment: 'Had a very nice 20 mile ride on St. Marks Trail in Tallahassee, FL. Very well maintained and shaded trail. All paved. Gorgeous 80 degrees.',
  response: 'It sounds like you had a wonderful ride, Nancy! The St. Marks Trail sounds like a fantastic route with its well-maintained paths and beautiful surroundings. Perfect weather for an enjoyable cycling experience. Keep on riding!'
},
 {
  name: 'Martha S.',
  date: 'April 5, 2024',
  title: 'Best Purchase Ever!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/MarthaS-Liberty-Trike.jpg?v=1712333068',
  video: '',
  html5video: '',
  comment: 'To potential and future Liberty Trike Owners. There are two trikes at my house. They are one of the best purchases I have made in a while. Let\'s start with Liberty Trike. This is the best company I have ever done business with. Not one of the best, THE BEST. They answered every question I had, not only prior to buying, but after as well. They are professional and kind. I had some minor issues that were dealt with quickly and to my satisfaction. I\'d like to thank Linda Mitala, Janet Smith and Nicole McQiggan for all of your help along the way.  Now, the trike itself. 10 COLORS!! What?!! They are all beautiful. I went with pink myself. The trike is fun to ride. How incredibly helpful it is to get around the hood.  It is compact and fits through the doors of my shed. The fact that you can take it fully apart is a plus if you wish to take it somewhere. It\'s at least 30 lbs lighter than other e tikes I was considering. I don\'t regret buying them.  Those of us that have them, LOVE them! I highly recommend getting yourself a Liberty Trike. P.S. If you name yours, as some of us do, you can\'t use "Panther, Pink Panther" (Like Bond, James Bond) \'cause I already have it lol. Nah Name yours anything you would like!',
  response: 'Martha, thank you for your kind words and for being part of the Liberty Trike community! We\'re thrilled to hear that you\'re enjoying your Liberty Trike and that our team provided you with excellent service. It\'s fantastic to hear that the trike meets your needs and that you\'re loving the pink color. Happy riding!'
},
{
  name: 'Dee Dee G.',
  date: 'April 3, 2024',
  title: 'Exploring San Diego on Lil\' Red',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/DeeDeeG-Liberty-Trike.jpg?v=1712333068',
  video: '',
  html5video: '',
  comment: 'Took Lil’ Red out for her inaugural ride along the Coronado bay waterfront today. It’s one of my favorite places here in San Diego. Such a beautiful day and a fun ride. I’m looking forward to more beautiful rides! Keep on moving!',
  response: 'Dee Dee, it sounds like you had an amazing inaugural ride with Lil’ Red along the Coronado bay waterfront! We’re thrilled to hear that you’re enjoying your Liberty Trike and exploring beautiful San Diego. Here’s to many more enjoyable rides ahead!'
},
  {
  name: 'Jean WH',
  date: 'April 1, 2024',
  title: 'Ten Miles of Freedom!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JeanWH-Liberty-Trike.jpg?v=1712333067',
  video: '',
  html5video: '',
  comment: 'Just back from a ride. I now have a "big" 10 miles on Blue Jeans.',
  response: 'Jean, congratulations on reaching the "big" milestone of 10 miles with Blue Jeans! Keep enjoying the freedom and adventure on your Liberty Trike!'
},
  {
  name: 'Amber L.',
  date: 'March 26, 2024',
  title: 'Excitement Overflows!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/AmberL-JMan-Loberty_trike.jpg?v=1712333068',
  video: '',
  html5video: '',
  comment: 'Jman got his new Liberty Trike! He is beyond excited!',
  response: 'Amber, we\'re thrilled to hear that Jman is beyond excited about his new Liberty Trike! Wishing him many thrilling adventures and enjoyable rides ahead!'
},
  {
  name: 'SherylAnn S.',
  date: 'March 25, 2024',
  title: 'Maiden Voyage Delight!',
  score: 4,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/SherylAnnSC-Liberty-Trike.jpg?v=1712333068',
  video: '',
  html5video: '',
  comment: 'Just finished my maiden voyage and I love it!!!',
  response: 'SherylAnn, congratulations on completing your maiden voyage! We\'re thrilled to hear that you love your new trike. Here\'s to many more enjoyable rides ahead!'
},
  {
  name: 'Karen N.',
  date: 'March 25, 2024',
  title: 'First Ride Excitement!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/KarenN-Liberty-Trike.png?v=1714747161',
  video: '',
  html5video: '',
  comment: 'My first ride on my brand new trike. So much fun!',
  response: 'Karen, congratulations on your first ride with your brand new trike! We\'re thrilled to hear that you had so much fun. Here\'s to many more enjoyable rides ahead!'
},
{
  name: 'Karen & Jim',
  date: 'March 24, 2024',
  title: 'Having fun as seniors!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Karen-Jim-Liberty-Trikes.png?v=1711306492',
  video: '',
  html5video: '',
  comment: 'We took our trikes to an Elks group campout this past week and the campground had miles of trails and also paved roads. Our little dog came with me and was happy being strapped into a basket sitting on a cushy pad.',
  response: 'Karen & Jim, it sounds like you had a fantastic time at the Elks group campout! Exploring miles of trails and paved roads on your trikes must have been so much fun, especially with your little dog enjoying the ride. We\'re thrilled to hear that you\'re having fun and making the most of your adventures!'
},
 {
  name: 'Brenda S.',
  date: 'March 20, 2024',
  title: 'They\'re the Best Thing Out There!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/BrendaS-Liberty-Trike.jpg?v=1711123075',
  video: '',
  html5video: '',
  comment: 'Orange Villa Possee..love our trikes 10 mile ride around Lake Jackson Sebring,Florida. They’re the best thing out there!!',
  response: 'Brenda, thank you for sharing this amazing picture of you and your friends enjoying a 10-mile ride around Lake Jackson in Sebring, Florida! It\'s truly heartwarming to see the joy and camaraderie among the Orange Villa Possee. Riding with friends is indeed one of the best things out there. We\'re thrilled that Liberty Trikes could be a part of your memorable adventure!'
},
{
  name: 'Patrick W.',
  date: 'March 14, 2024',
  title: 'Reliable Companion for Island Adventures',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/patrickw-liberty-trike.jpg?v=1710597103',
  video: '',
  html5video: '',
  comment: 'We have now been cruising on our old sailboat for 15 months. I had a Lectric 2.0 and my wife has a Liberty Trike. I liked the Lectric, and it was much faster than my wife\'s Liberty. However, the Lectric literally dissolved in the salt air, while the Liberty has held up to the elements quite well. The Lectrics fold, but don\'t come apart in 2 sections. We were able to stow the front half of my wife\'s in the forward V berth, because of this attribute. So, I gave the Lectric back to the dealer (he treated me awesome on my purchase) and maybe he can use it for spare parts. I bought a refurbished Liberty and they got it to us fast, so we wouldn\'t miss our weather window, for crossing the Gulf Stream, from Key Largo, FL., to Great Harbour Cay, Berry Islands, Bahamas. It was a 23 hour passage and we are now exploring this incredibly beautiful island on our Liberty e-trikes. We\'ll stay here for at least 3 months, maybe 6, and have decent island transportation.',
  response: 'Patrick, thank you for sharing your amazing journey with us! We\'re delighted to hear that the Liberty Trike has become a reliable companion for your island adventures. It\'s wonderful to know that our trikes are holding up well even in harsh conditions and providing you with the transportation you need for exploring beautiful destinations like the Berry Islands. Enjoy your stay and the freedom of riding!'
},
{
  name: 'Connie K.',
  date: 'March 4, 2024',
  title: 'Grateful for the Support!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/ConnieK-Liberty-Trike.jpg?v=1709652153',
  video: '',
  html5video: '',
  comment: 'Many thanks to everyone in the the Owners Group for all of your encouraging words to new LT riders! Bambi and I rode our new LT, Pinkie, all around the desert oasis RV park for the past 3 days to get comfortable navigating and turning, and using the brakes and the throttle. Pinkie was easy to pack up in 2 pieces to put in the back of our small Ford Escape SUV. (Although we have to practice more putting her back together). I\'m happy to say that I worked my way up to Level 5 at 12mph for several brief moments. I was so fearful on my 2 wheel ebike, this is such a relief! Wish I had done this a long time ago. And Bambi loves the back seat, all harnessed in!',
  response: 'Connie, thank you for sharing your wonderful experience with Pinkie! We\'re thrilled to hear that you and Bambi are enjoying your new Liberty Trike. It\'s heartwarming to know that our community has been supportive and that Pinkie has provided you with a sense of relief and joy. Keep exploring and embracing the freedom of riding!'
},
{
    name: 'Shirley S.',
    date: 'February 24, 2024',
    title: 'Joyful Neighborhood Rides',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/KimC-Liberty-Trike.jpg?v=1708780751',
    video: '',
    html5video: '',
    comment: 'I\'ve got almost 400 miles on mine...I only go on short rides in my neighborhood--maybe 2 or 3 miles. Abby loves it and I always come home feeling better and with a great, big smile!',
    response: 'Shirley, it brings us immense joy to know that your Liberty Trike brings you such happiness during your neighborhood rides. It\'s heartwarming to hear about Abby\'s enjoyment too! Wishing you countless more miles of joyful rides ahead!'
  },
  {
    name: 'Jeff R.',
    date: 'February 23, 2024',
    title: 'First Adventure with Liberty Trike',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JeffR-LibertyTrike.jpg?v=1708781342',
    video: '',
    html5video: '',
    comment: 'This is our first trip with the new Liberty Trike. Hitched the pet trailer to it. The wife loves it. Works great. — at Rocky Point Wright Patman Lake Texarkana Tx.',
    response: 'Jeff, we\'re thrilled to hear that your first adventure with the Liberty Trike was such a success! It\'s fantastic to know that both you and your wife enjoyed the ride. Wishing you many more memorable trips together with your Liberty Trike!'
  },
  {
    name: 'Carolyn C.',
    date: 'February 19, 2024',
    title: 'Never Loved an Inanimate Object More',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Carolyn_CJ_Liberty_Trike.jpg?v=1708368257',
    video: '',
    html5video: '',
    comment: 'Opi (short for orange popsicle) and I regularly go 6 miles a trip with my lil dog Happy in the basket on the back. I have never loved an inanimate object more',
    response: 'Carolyn, thank you for sharing your delightful adventures with Opi and Happy! We\'re thrilled to hear how the Liberty Trike has become an integral part of your outings with your furry friend. Your love for your trike is truly heartwarming, and we\'re honored to be a part of your journey. If you ever need any assistance or have any questions, please feel free to reach out. Happy riding!'
  },
  {
    name: 'Shirley S.',
    date: 'February 19, 2024',
    title: 'Neighborhood Joyrides',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Shirley_S_Liberty-Trike.jpg?v=1708368453',
    video: '',
    html5video: '',
    comment: 'I\'ve got almost 400 miles on mine...I only go on short rides in my neighborhood--maybe 2 or 3 miles. Abby loves it and I always come home feeling better and with a great, big smile!',
    response: 'Shirley, we\'re delighted to hear how much joy your Liberty Trike brings you and Abby during your neighborhood rides! It sounds like the perfect way to spend quality time together while staying active. Keep enjoying those smiles and miles!'
  },
  {
    name: 'Lana S.',
    date: 'February 7, 2024',
    title: 'Life-Changing Trike',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LanaS-Liberty_Trike.jpg?v=1707327081',
    video: '',
    html5video: '',
    comment: 'Without my trike I would be stuck at the campsite. I now am able to ride beside my Grandchildren as they walk. Having Neuropathy makes it hard to walk very far so my trike is a lifesaver to me.',
    response: 'Lana, we\'re delighted to hear how your trike has transformed your mobility and enabled you to enjoy precious moments with your grandchildren. It\'s wonderful to know that our trike has made such a positive impact on your life. If you ever need any assistance or support, please don\'t hesitate to reach out. Happy riding!'
  },
  {
    name: 'Mary A.',
    date: 'February 7, 2024',
    title: 'Grateful for the Experience',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Mary-A-LibertyTrike.jpg?v=1707322852',
    video: '',
    html5video: '',
    comment: 'I hope you get as much enjoyment from your experience as I do. Riding my trike as opened my world back up again. I am so grateful.',
    response: 'Mary, we\'re thrilled to hear that riding your trike has opened up new possibilities and brought enjoyment to your life. Thank you for sharing your positive experience with us. If you ever need any assistance or have questions, don\'t hesitate to reach out. Happy riding!'
  },
  {
    name: 'Glenn L.',
    date: 'February 7, 2024',
    title: 'Pleased owner',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Glen-L-Liberty_Trike.jpg?v=1707321868',
    video: '',
    html5video: '',
    comment: 'We have had our two Liberty Trikes for a couple of years and are just as pleased with them as when first purchased. I purchased one for my wife and liked it so much that I got one for myself and gave my old trike away. I was looking at an email from Liberty Trike today and like the rear mag wheels so much that I think I will order two sets for our trikes. Our location has grocery stores, drug stores, and our doctor and dentist a short trike ride from our home. If I quit driving, the trikes give mobility.',
    response: 'Glenn, thank you for sharing your positive experience with us! We\'re thrilled to hear that you and your wife continue to enjoy your Liberty Trikes after all these years. It\'s fantastic to hear that our email caught your eye, and we\'re delighted to hear that you\'re considering upgrading with the rear mag wheels. If you have any questions or need assistance with your order, feel free to reach out to us. Keep on riding!'
  },
  {
    name: 'Ron W.',
    date: 'February 1, 2024',
    title: 'Tremors Transformed: Freedom!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/RonW-LibertyTrike.jpg?v=1707274910',
    video: '',
    html5video: '',
    comment: 'I have Essential Tremors and mobility issues… can’t say enough about my Liberty Trike that allows me to play disc golf with friends.',
    response: 'Ron, we\'re glad to hear that your Liberty Trike has provided you with the freedom to enjoy activities like disc golf with your friends despite mobility challenges. Your positive feedback means a lot to us!'
  },
  {
    name: 'Kimba L.',
    date: 'January 28, 2024',
    title: 'Daily Rides, New Challenges',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/KimbaL-Liberty_Trike.jpg?v=1706549439',
    video: '',
    html5video: '',
    comment: 'This week I’ve been able to ride my trike every day in the neighborhood! Today I met a new friend who wanted to race. I think I could’ve beaten him 😂',
    response: 'Kimba, we\'re thrilled to hear that you\'re enjoying your Liberty Trike and making new friends along the way! Keep riding and having fun, and if you ever have any questions or need assistance, feel free to reach out. Happy cycling!'
  },
  {
    name: 'Pamela M-J',
    date: 'January 28, 2024',
    title: 'Lemon Zest: Adventure Awaits',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/PamelaJM-LibertyTrike.jpg?v=1706550445',
    video: '',
    html5video: '',
    comment: 'Wanted to share my Liberty Trek photo.....I love my bike. It is yellow so her name is LEMON ZEST! LZ went with me on the trails yesterday to bird watch and photograph birds. Her first time out and the hills, gravel etc were no obstacle. We had a great ride!! LZ and I have many more adventures to come!!',
    response: 'Pamela, thank you for sharing your wonderful experience with Lemon Zest (LZ)! We\'re thrilled to hear that you and LZ had a great ride and that you\'re excited for more adventures together. If you ever have any questions or need assistance, feel free to reach out. Happy riding!'
  },
  {
    "name": "Henry J.",
    "date": "January 24, 2024",
    "title": "A Dream Come True for My Son",
    "score": 5,
    "image": "https://cdn.shopify.com/s/files/1/0865/1792/files/matthewJ-Liberty_Trike_Review.jpg?v=1706124078",
    "video": "",
    "html5video": "",
    "comment": "This is my son Matthew. He has special needs and we just couldn’t find a suitable bike for him. He has always wanted to be able to ride without help from dad, but has trouble balancing and peddling. That all changed today!! 🙏🏼Thank you Liberty Trike for not only making an affordable well built Trike, but helping my son’s dream come true of being able to ride all by himself 😊. Matthew is now the proud owner of this amazing red Liberty Trike and he couldn’t be happier! Thank you from a grateful dad. #LibertyTrike #ProudFather #MakingMemories #MilesOfSmiles",
    "response": "Henry, we're truly moved by your heartfelt review. It's our mission to provide mobility and joy to everyone, and we're delighted to have made Matthew's dream of riding independently come true. Seeing those smiles and creating such meaningful memories is what drives us. If there's anything more we can do to enhance Matthew's riding experience or assist your family in any way, please feel free to reach out. Wishing Matthew many more miles of smiles on his Liberty Trike!"
  },
  {
    name: 'Dennis B.',
    date: 'January 17, 2024',
    title: 'My MIL\'s 1000 Mile Mark',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/dennisB-Liberty-Trike.jpg?v=1705072554',
    video: '',
    html5video: '',
    comment: 'My mother-in-law (MIL), Aurela, has just completed the 1000 mile mark. She has had her Liberty Trike (LT) for about a year now. She started out pedaling, but a hip replacement has her now favoring the electric propulsion. She is 96 years old and the LT gives her the freedom to get out-and-about that she just wouldn\'t have without it. We live in a small community with private roads and I don\'t think she ever gets more than about a half-mile from home. Being in Florida the weather is usually great for riding. Thanks to the folks at LT, the design of this machine is a dream come true.',
    response: 'Dennis, congratulations to your mother-in-law, Aurela, on reaching the impressive milestone of 1000 miles with her Liberty Trike! We\'re thrilled to hear that it\'s been providing her with the freedom and mobility she deserves. It\'s heartwarming to know that she\'s able to enjoy the beautiful Florida weather and the convenience of her LT. If you or Aurela ever need any assistance or have questions, please don\'t hesitate to reach out. We wish her many more enjoyable miles!'
  },
  {
    name: 'Rhonda C.',
    date: 'January 3, 2024',
    title: 'Holiday Season Ride',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/RhondaC-Liberty_Trike.jpg?v=1705073292',
    video: '',
    html5video: '',
    comment: 'We just went to south Louisiana to ride the Tammany Trace Trail (30 miles from Covington to Slidell) with 2 other couples. What a fabulous start to the holiday season. I also have a schnauzer that loves to ride. He never tries to get out of the basket. Love my Liberty Trike.',
    response: 'Rhonda, it sounds like you had a fantastic start to the holiday season with your ride along the Tammany Trace Trail in south Louisiana! We\'re delighted to hear that your Liberty Trike continues to bring joy to your adventures. Having your schnauzer as a riding companion must make those journeys even more special. If you ever have any questions or need assistance, don\'t hesitate to reach out. Wishing you many more wonderful rides!'
  },
  {
    name: 'Brian F.',
    date: 'January 2, 2024',
    title: '4000 Mile Achievement',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Brian_F-Liberty_Trike.jpg?v=1705072845',
    video: '',
    html5video: '',
    comment: 'Reached the 4000 mile mark today in Estero, Florida! Maintenance done to this point: replaced tires, replaced brake caliper, replaced battery case and replaced battery cage bolts with larger ones with hex heads, and adjusted/centered chain drive. I use 2 batteries in succession each with about a 25-30 km range that\'s starting to decline as the number of battery cycles get near their end. Still works great!',
    response: 'Brian, congratulations on reaching an incredible milestone of 4000 miles on your Liberty Trike in sunny Estero, Florida! Your dedication to maintaining and enhancing your trike is truly commendable. It\'s wonderful to hear that it\'s still going strong. If you ever need further assistance or have any questions, feel free to reach out. Here\'s to many more enjoyable miles ahead!'
  },
  {
    name: 'Dave L.',
    date: 'December 26, 2023',
    title: 'LIBERTY TRIKE MADE MY LIFE',
    score: 5,
    image: '',
    video: '',
    html5video: '',
    comment: `I’ve had neuropathy for 6 years using leg supports and using a walker and not going very far. It really hit me last spring that I had lost my freedom. My wife or got a friend to drive me to all my appointments. My kids wouldn’t let me get a bike, they wanted me to get a scooter and l told them no that would give me no exercise so I thought of a trike. I wanted one that was small and it had to fold in half so l could put it in the suv. I spent hours looking at trikes and by luck I seen Liberty Trikes and that was the trike I was looking for. I live in Alberta Canada and they shipped the trike to me and I had in a few days. Good and quick service. With having no feeling no feeling in my hands it only took 10 to 15 minutes to put together very easy. Now at Xmas time lve put on over 600 miles and just love it, I go anywhere at any time to all my appointments. THANKS LIBERTY TRIKE`,
    response: 'Dave, we\'re delighted to hear how the Liberty Trike has made such a positive impact on your life! Your determination and choice of the Liberty Trike for exercise and mobility is truly inspiring. We\'re here to provide you with the freedom and independence you deserve. If you ever need assistance or have questions, please don\'t hesitate to reach out. Keep enjoying your rides!'
  },
  {
    name: 'Kay A.',
    date: 'December 23, 2023',
    title: 'Liberty Trike: My Source of Happiness!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Kay-Liberty_Trike_Christmas.jpg?v=1703359079',
    video: '',
    html5video: '',
    comment: 'I love my Liberty Trike, and everyone who lives here wants one too. I tell them all how to get one, and I have yet to see any LTs in this place. I wish I was good at persuasion, but the proof is how happy I am to be on my Liberty Trike. I live in a four-story, 55+ community, so there are plenty of people.',
    response: 'Kay, thank you for sharing your love for the Liberty Trike with your community! We\'re thrilled to hear how happy it has made you. Your enthusiasm is the best endorsement, and we appreciate you spreading the word about the Liberty Trike. If anyone from your community has questions, feel free to direct them to us. Keep enjoying your rides and the happiness your Liberty Trike brings!'
  },
  {
    name: 'Diane H. M.',
    date: 'December 20, 2023',
    title: 'Milestone Achieved: 1,000 Miles!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/DianeHM-Liberty_Trike.jpg?v=1703276711',
    video: '',
    html5video: '',
    comment: 'My first 1k miles. Yeah!!',
    response: 'Diane, congratulations on reaching a fantastic milestone of 1,000 miles with your Liberty Trike! What an incredible achievement. We\'re thrilled to have been a part of your journey. Here\'s to many more exciting miles of adventure ahead!'
  },
  {
    name: 'Mary Margaret P.',
    date: 'December 18, 2023',
    title: 'Perfect for My Physical Therapy Routine!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/marypt-liberty_trike.jpg?v=1703277082',
    video: '',
    html5video: '',
    comment: 'Using mine 3 days a week to go my 3.25 miles for physical therapy, it\'s been a tad chilly in south jersey. I\'m loving it as although using the motor I\'m pedaling the whole time using it for warm up & cool down.',
    response: 'Mary Margaret, we\'re delighted to hear that your Liberty Trike has become an essential part of your physical therapy routine! It\'s wonderful to know that it\'s helping you stay active even in chilly South Jersey weather. Keep up the fantastic work!'
  },
  {
    name: 'Carol W.',
    date: 'December 11, 2023',
    title: 'Enchanting Night at Galaxy of Lights',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/carolw-liberty_trike-2.jpg?v=1702648149',
    video: '',
    html5video: '',
    comment: 'Went to Galaxy of Lights recently in Huntsville and they allowed me to ride my Liberty Trike. Kept it on speed 1 and it was perfect! Would not have been able to share this with my granddaughter without my trike!',
    response: 'Carol, we\'re delighted to hear that your Liberty Trike added an extra touch of enchantment to your visit to Galaxy of Lights. Sharing this experience with your granddaughter must have been truly special. Your review brightened our day, and we\'re here to support your continued adventures with your trike!',
  },
  {
    name: "Diane H.",
    date: "November 16, 2023",
    title: "A Journey to Strength and Independence with My Liberty Trike",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/DianeH-Liberty_Trike.jpg?v=1700170813",
    video: "",
    html5video: "",
    comment: "Love my Liberty Trike! It has been very helpful in my journey to build my strength so I am now able to walk without assistance. I can now also ride with my husband around the campground and our neighborhood!",
    response: "Diane, your journey to strength and independence is truly inspiring! We're thrilled to hear that your Liberty Trike has played a significant role in achieving these goals. Riding together with your husband around the campground and neighborhood must be a wonderful experience. If you ever have more stories or questions to share, please feel free to reach out. Keep enjoying those rides and your newfound mobility!"
  },
  {
    name: "Anon Liberty Owner",
    date: "November 13, 2023",
    title: "Fantastic Vacation Rides at Shadow Ridge Resort!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty_Trike_-_Anon.jpg?v=1700078694",
    video: "",
    html5video: "",
    comment: "We love riding our LTs around Shadow Ridge Resort while on vacation in Palm Desert.",
    response: "It's wonderful to hear that you're enjoying your Liberty Trikes during your vacation at Shadow Ridge Resort in Palm Desert! Exploring the resort and its surroundings on your LTs must be a fantastic way to make the most of your getaway. If you ever have more vacation adventures or questions, feel free to share. Happy triking!"
  },
  {
    name: "KennyandCandy's Travels",
    date: "November 5, 2023",
    title: "Loving My New-to-Me Liberty Trike!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/KennyandCandy_s_Travel_-_Liberty_Trike.jpg?v=1700079111",
    video: "",
    html5video: "",
    comment: "Just got my trike. It's used but in great shape and I'm really enjoying it. It had 400 miles on it. I've already ordered some accessories to make it mine.",
    response: "KennyandCandy's Travels, congratulations on your new-to-you Liberty Trike! It's fantastic to hear that you're already enjoying it. Personalizing it with accessories is a great idea to make it truly yours. If you ever want to share your adventures or have any questions about your trike or the accessories, don't hesitate to reach out. Happy riding!"
  },
  {
    name: "Jeff B",
    date: "November 2, 2023",
    title: "My Liberty Trike's Unique Adventure to the Southernmost Point!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JeffB-LibertyTrike.jpg?v=1698956162",
    video: "",
    html5video: "",
    comment: "What makes YOUR Liberty Trike unique? I know what makes mine! It is officially the southernmost LT! Just got back from a week at 'Fantasy Fest' in Key West, FL (where my trike performed flawlessly, btw). Snapped this pic at the official 'Southernmost Point in the Continental U.S.' buoy in KW.",
    response: "Jeff, your Liberty Trike's journey to the southernmost point in Key West, FL, is truly remarkable! We're thrilled to hear that your trike performed flawlessly during your week at 'Fantasy Fest.' It's these kinds of adventures that make each Liberty Trike unique. Thank you for sharing this fantastic moment with us. If you have more adventures in store, remember we're here to support you along the way. Happy triking!"
  },
  {
    name: "Richard P",
    date: "October 27, 2023",
    title: "Top Banana at Yuma Family Pumpkin Patch!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/RichardP-Liberty_Trike.jpg?v=1698956307",
    video: "",
    html5video: "",
    comment: "\"Top Banana\" was the first response unit at the \"Yuma Family Pumpkin Patch ( YumaFamilyPumkinPatcth.com ) in Yuma, AZ.",
    response: "Richard, it sounds like you had a fantastic time at the Yuma Family Pumpkin Patch! Being the first response unit and embracing the spirit of the season must have been a delightful experience. We hope your Liberty Trike added an extra layer of fun to your visit. If you have any more exciting adventures ahead, don't hesitate to share them with us. Happy triking!"
  },
  {
    name: "Mary P",
    date: "October 25, 2023",
    title: "Celebrating 2000 Miles with DEX!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/MaryP-Liberty_Trike.png?v=1698956424",
    video: "",
    html5video: "",
    comment: "Achieved 2000 miles - 3219 kms - this week. DEX and me are very comfortable now. Unfortunately,  in Ottawa, Canada, riding season is almost over.",
    response: "Mary, congratulations on reaching an incredible milestone of 2000 miles with DEX! It's clear that you and your Liberty Trike make an excellent team. While the riding season in Ottawa might be winding down, you've undoubtedly created some wonderful memories. We're here to support you year-round, so if you ever want to share more adventures or have any questions, feel free to reach out. Happy triking!"
  },
  {
    name: "Rita F",
    date: "October 24, 2023",
    title: "Discovering Hidden Gems on a Beautiful Ride!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/RitaR-Liberty_Trike.jpg?v=1698956682",
    video: "",
    html5video: "",
    comment: "What a great day to ride. Temps hit 79 in our neck of the woods. Miss Dixie and I rode 10 miles and discovered a park we didn’t know existed.",
    response: "Rita, it sounds like you and Miss Dixie had an amazing adventure on a perfect day for riding! Discovering a new park and exploring together is one of the joys of Liberty Trike ownership. Keep enjoying these wonderful rides, and if you ever have any questions or need assistance, feel free to reach out. Happy triking!"
  },
  {
    name: "Nancy W",
    date: "October 24, 2023",
    title: "10 Mile Ride in Beautiful Weather!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/NancyWG-Liberty_Trike.png?v=1698956546",
    video: "",
    html5video: "",
    comment: "It was a beautiful sunny and breezy day! 10 mile ride with my hubby! Love my trike! 169 miles now!",
    response: "Nancy, it sounds like you had a fantastic ride on that beautiful day! Your Liberty Trike has been a great companion, helping you log 169 miles of wonderful adventures. Keep enjoying the open roads, and if you ever have any questions or need assistance, don't hesitate to reach out. Happy triking!"
  },
  {
    name: "Jim",
    date: "October 23, 2023",
    title: "A Fantastic Experience with My Liberty Trike!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JimF-Liberty_Trike.png?v=1698088477",
    video: "",
    html5video: "",
    comment: "Hi Janet,  It was nice to hear from you and I would be glad to send a couple of photographs (see attached) of my trike.  In the last week I have outfitted it with a waterproof storage bag for the rear basket, a camera bag and phone mount on the front handle bar, and a tool kit under the seat. Each day I have gone for short rides, first just around the front of the house to get used to the handling and power settings.  Then a little further as I felt more confident. I have recently driven electric bikes and motor scooters so it wasn't too difficult for me to get the hang of it. At first I wasn't sure if I'd like the pedal brake but after some time it is now really nice to free up the right hand just for the throttle.   What's unique about this trike is how easy it is to get on and off and sit comfortably with both feet on the ground. The bikes and scooter I have driven always required me to stand on my toes to keep balanced while still.  Sitting flat footed without fear of tipping is quite satisfying, especially when taking photographs.  The power and speed are quite sufficient for my needs.  Any faster than 12mph would be inviting a mishap.  I've fallen off bikes before and have no desire to repeat the experience. One final thing.  It happens that it loads right into the back of my Dodge Grand Caravan without breaking down.  The handle bars just clear the top of the rear hatch opening and with the rear seat down the trike rolls in.  I chalk the front and back wheels and lock the front break.  Now I can go to a remote location for nature photography.  I'll send some photos of some of my experiences. Regards, Jim",
    response: "Hi Jim,\n\nThank you for sharing your wonderful experience with the Liberty Trike! It's great to hear that you've been customizing and enjoying your trike to the fullest. The addition of the waterproof storage bag, camera bag, phone mount, and tool kit sounds like you've turned your Liberty Trike into a versatile companion for your rides and photography adventures.\n\nYour insights into the ease of use, comfort, and stability of the trike are valuable for others considering it. And it's fantastic that it fits so well into your Dodge Grand Caravan, making it convenient to transport to different locations for your nature photography. We appreciate your feedback, and we'd love to see some of the photos from your experiences.\n\nRide on and capture those beautiful moments!\n\nBest regards, Janet and the Liberty Trike Team"
  },
  {
    name: "Maxine H",
    date: "October 23, 2023",
    title: "Congratulations to Kevin on 2,000 Miles!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/MaxineH-Liberty_Trike.png?v=1698087622",
    video: "",
    html5video: "",
    comment: "This morning my husband Kevin completed riding 2,000 miles on his trike. It happened after only 2 years in downtown Milwaukee.",
    response: "Maxine, congratulations to Kevin on reaching the impressive milestone of 2,000 miles on his trike in just 2 years! That's a remarkable achievement, and it's wonderful to hear about his dedication to cycling in downtown Milwaukee. Here's to many more enjoyable rides ahead. If you have any questions or want to share more milestones, please feel free to reach out!"
  },
  {
    name: "Linda B",
    date: "October 22, 2023",
    title: "Scenic Ride on Northwest Lancaster County River Trail",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Linda-B.png?v=1698087543",
    video: "",
    html5video: "",
    comment: "Couldn't pass up the great weather, took Maggs on the Northwest Lancaster County River Trail, from Marietta, PA to Falmouth Trailhead. I'm going to pay for riding 23.8 miles, but it was my first time on this trail and I wanted to ride the whole trail. Views of the Susquehanna River were worth the pain.",
    response: "Linda, it sounds like you had an amazing ride along the Northwest Lancaster County River Trail. Riding the whole trail for the first time, despite the distance, is quite an achievement. The scenic views of the Susquehanna River must have been breathtaking. Thank you for sharing your wonderful experience with us. If you have more adventures or any questions, feel free to reach out!"
  },
  {
    name: "Jim D",
    date: "October 21, 2023",
    title: "Empowering Independence with Liberty!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JimD-Liberty_Trike.jpg?v=1698087682",
    video: "",
    html5video: "",
    comment: "Liberty is what this means to our daughter. Just got it this morning. She's not able to drive but her independence is still important.",
    response: "Jim, we're thrilled to hear that Liberty has brought independence and joy to your daughter's life. It's wonderful to know that she can enjoy the freedom of movement and outdoor adventures with her new trike. If you ever have any questions or need assistance, please don't hesitate to reach out. Wishing your daughter many happy and empowering rides!"
  },
  {
    name: "Cody B",
    date: "October 11, 2023",
    title: "BEST INVESTMENT EVER!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JodyBP-Liberty_Trike.jpg?v=1697049005",
    video: "",
    html5video: "",
    comment: "Love using my Liberty trike (Bay-Bee) and NEW trailer for my fall yard cleanup. I have RA and have shoulder & feet issues so pulling a wagon around the yard while also trying to clean out landscaping used up way too much energy and caused a lot of additional strain. I can also haul my yard waste right to our city dump too! It’s AWESOME! These collapsible crates fit perfectly inside the trailer.",
    response: "Cody Awesome., thank you for sharing your fantastic experience with your Liberty Trike and the new trailer! We're thrilled that it's become the BEST INVESTMENT EVER for you, making yard cleanup more efficient and less strenuous. It's wonderful to hear how the Liberty Trike enhances the quality of life. If you have any more stories or questions, feel free to reach out. Keep enjoying your rides and yard work!"
  },
  {
    name: "AshberryP",
    date: "October 10, 2023",
    title: "A Must-Visit Botanical Garden in Athens, GA!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/AshberryP-Liberty_Trike.jpg?v=1697049078",
    video: "",
    html5video: "",
    comment: "If you’re ever in the Athens GA area, touring this botanical garden is a must. It is free! Almost 100% completely paved paths, a few hard-packed gravel paths, and lots of ramps to help those of us who need wheels to navigate. Some steep paved paths & roads but go slow and you’ll be fine. I kept my feet on my foot pegs almost the entire time. Staff was very friendly and helpful. Multiple different gardens with plants from all over the globe. They were stringing the arbors and trees with lights for their upcoming holiday tours. It was 78 degrees with a light breeze. Beautiful blue skies. I won’t post all 76 photos to spare you. Just go visit!!!",
    response: "Thank you, Ashberry Petro, for sharing your fantastic experience at the State Botanical Garden of Georgia in Athens, GA! Your detailed insights make it clear that this botanical garden is a must-visit, with its accessible paths, diverse gardens, and friendly staff. We appreciate your recommendation, and we hope more people get to enjoy the beauty of this garden."
  },
  {
    name: "EvaR",
    date: "October 8, 2023",
    title: "Enjoying a Beautiful Day for a Ride!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/EvaR-Liberty_Trike.jpg?v=1697049321",
    video: "",
    html5video: "",
    comment: "Took a short ride today in 83-degree weather. Could be the last time it hits above 80 for the next six months in the Pacific Northwest. My husband mowed grass, and I went for a ride. Seems fair. LOL. Happy triking!",
    response: "Eva Roudabush, it sounds like you made the most of a beautiful day for a ride! The Pacific Northwest offers stunning scenery, and we're glad your Liberty Trike allows you to enjoy it comfortably. Keep on triking and making the most of those sunny days!"
  },
  {
    name: "Fred K",
    date: "October 7, 2023",
    title: "Scenic Ride along Cape Cod Canal",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/fredk.png?v=1697049649",
    video: "",
    html5video: "",
    comment: "We rode our Liberty Trikes on Cape Cod Canal path from Sandwich to past the Bourne Bridge and back about 10 miles on Monday. The scenery was absolutely stunning, with picturesque bridges, tranquil waters, and boats passing by. It was a delightful ride!",
    response: "Fred K, we're thrilled to hear about your scenic ride along the Cape Cod Canal with your Liberty Trikes. Exploring picturesque landscapes and enjoying the tranquility of the water is what makes Liberty Trike rides so special. Thank you for sharing your wonderful experience. If you ever have more adventures to share or questions, feel free to reach out!"
  },
  {
    name: "Deborah A",
    date: "October 6, 2023",
    title: "Texas State Fair Adventure!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/deba-Liberty_Trike.png?v=1696602753",
    video: "",
    html5video: "",
    comment: "Joel Altsman and I rode our Liberty Trikes all around the wonderful Texas State Fair. We are so thankful for all the ways our trikes help us enjoy life! We probably gave away over a dozen cards to people envious of our rides. Thanks LT!",
    response: "Deborah A and Joel A, it's fantastic to hear about your Texas State Fair adventure with your Liberty Trikes! We're thrilled that our trikes enhance your enjoyment of life. Sharing your experiences and spreading the joy by giving away cards to envious onlookers is a wonderful way to share the Liberty Trike love. If you have more adventures or questions in the future, feel free to reach out. Happy riding at the fair and beyond!"
  },
  {
    name: "Gerry E",
    date: "October 5, 2023",
    title: "Unforgettable Week at Assateague State Park!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/GerryE-Liberty_Trike.jpg?v=1696602545",
    video: "",
    html5video: "",
    comment: "Just spent a week camping at Assateague State Park in Maryland. Here is a shot of one of the ponies asking about the Liberty trike. We handed out several cards this week.",
    response: "Gerry E, it sounds like you had an unforgettable week at Assateague State Park! Meeting one of the ponies and introducing them to the Liberty trike must have been a unique experience. Thank you for sharing your adventures and for helping spread the word about Liberty Trike by handing out cards. If you have more stories or questions in the future, don't hesitate to reach out. Happy camping and riding!"
  },
  {
    name: "Marcus P",
    date: "October 4, 2023",
    title: "Happy Puppy Rides!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/marcusp-Liberty_Trike.jpg?v=1696603293",
    video: "",
    html5video: "",
    comment: "Our puppy loves to ride behind Mommies cool trike😃",
    response: "Marcus P, it's wonderful to see your happy puppy enjoying rides behind Mommy's cool Liberty Trike! The picture captures a moment of pure joy. If you ever want to share more adventures or have questions, feel free to reach out. Your puppy sure knows how to have a great time!"
  },
  {
    name: "Julie O",
    date: "October 2, 2023",
    title: "Loving My New Liberty Trike!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/JulieO-Liberty_Trike.jpg?v=1696603442",
    video: "",
    html5video: "",
    comment: "Hi! Got my new Liberty Trike and loving it.",
    response: "Julie O, we're thrilled to hear that you're loving your new Liberty Trike! Welcome to the Liberty Trike family. If you ever have questions or want to share more about your adventures, don't hesitate to reach out. Enjoy your rides to the fullest!"
  },
  {
    name: "Donna N",
    date: "September 30, 2023",
    title: "Noah's Amazing Progress",
    score: 5,
    image: "",
    video: "",
    html5video: "https://cdn.shopify.com/videos/c/o/v/74c404aa3ecc44f48a34a805be1f8ed1.mp4",
    comment: "Wanted to update everyone on Noah’s progress, sorry it’s a poor quality but his physical therapist was in front of him running backwards lol…but even though he has autism, down syndrome, is non-verbal…he looks like any other dude on his bike!",
    response: "Donna N, thank you for sharing this heartwarming update on Noah's progress with his Liberty Trike! It's incredible to see him enjoying his ride and looking just like any other happy cyclist. We appreciate you updating us on his journey, and if you ever need assistance or have more updates to share, please don't hesitate to reach out. Noah's determination is truly inspiring!"
  },
  {
    name: "Mary P",
    date: "September 23, 2023", 
    title: "An Amazing Ride Across the William Commanda Bridge!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/Mar_Mary_Payne.yP-Liberty-Trike.jpg?v=1695484422",
    video: "",
    html5video: "",
    comment: "DEX and I rode across the newly opened William Commanda Cycle/Pedestrian Bridge linking the provinces of Ontario and Quebec, Canada, just west of the Canadian Parliament Buildings (shown in a couple of photos) in Ottawa, Ontario.",
    response: "Mary P, what an incredible adventure riding across the newly opened William Commanda Cycle/Pedestrian Bridge! Exploring the beautiful scenery that connects the provinces of Ontario and Quebec must have been truly amazing. Thank you for sharing this memorable experience with us. If you have more exciting stories to tell or need any assistance, feel free to reach out. Happy riding!"
  },
  {
    name: "Chris D",
    date: "September 23, 2023",
    title: "Memorable Granddaughter Adventures!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/ChrisDia-Liberty-Trike.jpg?v=1695476399",
    video: "",
    html5video: "",
    comment: "My granddaughter and I went on a 5-mile bike ride. She loves going on bike rides with her grandpa and me. We never rode bikes together until after I got my LT. Now we usually pack a lunch and ride to the park and have a little picnic. I'm so glad I decided to get the LT.",
    response: "Chris D, your story of biking adventures with your granddaughter is heartwarming! It's wonderful to hear how your Liberty Trike has brought you closer and enabled these memorable outings. Picnics in the park sound like a fantastic way to bond and create lasting memories. We're thrilled that the LT has added joy to your life. If you ever need assistance or have questions, please feel free to reach out. Here's to many more wonderful rides with your granddaughter!"
  },
  {
    name: "Sharon H",
    date: "September 23, 2023",
    title: "A Special Ride for Ivy!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/sharonh-Liberty-Trike.jpg?v=1695476601",
    video: "",
    html5video: "",
    comment: "Thank you to the person who mentioned pool noodles! Our Ivy loves to ride! She is 13 now!",
    response: "Sharon H, it's heartwarming to hear that Ivy enjoys her rides! The idea of using pool noodles to enhance the experience is fantastic. Ivy's love for riding on the Liberty Trike is truly special, and we're delighted to be a part of her journey. If you ever have more stories or need assistance, don't hesitate to reach out. Wishing Ivy many more joyful rides ahead!"
  },
  {
    name: "Brian F",
    date: "September 22, 2023",
    title: "A Milestone Achieved at Waterton National Park!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/brianf-liberty_trike.png?v=1695475787",
    video: "",
    html5video: "",
    comment: "Hit the 3,000 mile mark today in Waterton National Park in Alberta, Canada! Such a perfect, sunny warm day to bike 20 km along the park trail and around the townsite.",
    response: "Brian F, congratulations on reaching the impressive milestone of 3,000 miles at Waterton National Park! What an incredible journey you've had on your Liberty Trike. It's heartwarming to hear that you enjoyed a perfect, sunny day biking along the park trail and exploring the townsite. Your adventures are an inspiration to us all. If you ever want to share more about your experiences or have any questions, feel free to reach out. Keep riding and making memories!"
  },
  {
    name: "Rita F",
    date: "September 21, 2023",
    title: "Scenic Ride at Potato Creek Park, Indiana!",
    score: 4.7,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/RitaF-Liberty-Trike.jpg?v=1695476050",
    video: "",
    html5video: "",
    comment: "Great ride today on the bike trail in Potato Creek Park, Indiana. Some pretty good hills and curves.",
    response: "Rita F, it sounds like you had an excellent ride on the bike trail at Potato Creek Park in Indiana with your yellow Liberty Trike! Navigating those hills and curves must have been a thrilling adventure. Your Liberty Trike is designed for such scenic rides, and we're delighted that you're enjoying it. If you ever want to share more about your rides or have any questions, feel free to reach out. Keep exploring and relishing those beautiful trails!"
  },
  {
    name: "Ann-Marie W",
    date: "September 20, 2023",
    title: "Exploring the Hanover Shaker Community!",
    score: 4.2,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/AMW-LibertyTrike.jpg?v=1695475932",
    video: "",
    html5video: "",
    comment: "Lemonade visits Hanover Shaker community in Massachusetts. Beautiful round stone barn in the background - can milk 50 cows at a time inside.",
    response: "Ann-Marie W, it sounds like you had a delightful visit to the Hanover Shaker community in Massachusetts with Lemonade. The round stone barn and its capacity to milk 50 cows at a time is truly impressive. Your Liberty Trike adventures take you to fascinating places, and we're thrilled to be a part of your explorations. If you ever want to share more about your experiences or have any questions, feel free to reach out. Keep exploring and making wonderful memories!"
  },
  {
    name: "Norma G",
    date: "September 17, 2023",
    title: "A Fun and Youthful Experience!",
    score: 5,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/NormaG-Liberty_Trike.jpg?v=1694799020",
    video: "",
    html5video: "",
    comment: "You will have so much fun!!! Like a kid again!!",
    response: "Norma G, your enthusiasm is contagious! It's fantastic to hear that your Liberty Trike experience is bringing back the joy of feeling like a kid again. That's what our trikes are all about—providing fun, freedom, and a youthful spirit to our riders. If you ever want to share more about your adventures or have any questions, don't hesitate to reach out. Have a blast!"
  },
  {
    name: 'Christine L',
    date: 'September 15, 2023',
    title: 'A Powerful Antidote for Depression and Loneliness!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/ChristineL-LibertyTrike.jpg?v=1694798538',
    video: '',
    html5video: '',
    comment: 'I know, the best antidote for depression/loneliness EVER. Seems I always have a good adventure, and end up meeting nice folks to chat with.',
    response: 'Christine L, we\'re thrilled to hear that your Liberty Trike has become a powerful antidote for depression and loneliness in your life! The way it brings you on exciting adventures and connects you with friendly people is truly heartening. Remember, the Liberty Trike is more than just a mode of transportation; it\'s a gateway to unforgettable experiences. If you ever want to share more of your adventures or have any questions, please feel free to reach out. We\'re here to support you on your journey!'
  },
  {
    name: 'Eva R',
    date: 'September 9, 2023',
    title: 'Memorable Weekend at Mt Hood Village RV Resort!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/evar-Liberty_Trike.png?v=1693930313',
    video: '',
    html5video: '',
    comment: 'Had a wonderful weekend at Mt Hood Village RV Resort with family and friends. My great grandson loves riding in the back basket on my LT. I even took an off-road ride with grandson to see the Salmon River. I did okay until I got stuck on tree roots. Had to get off and walk the trike for about 5 ft. The rest of the ride went fine. I even participated in a bike parade around the campground. A lady saw my trike and said that my next bike. She inquired about if she could get a trailer for her two pups. Told her about Liberty Trike on the internet. What a great weekend.',
    response: 'Eva R, it\'s heartwarming to know that your Liberty Trike brought so much joy to your weekend at Mt Hood Village RV Resort! Your adventures with your great grandson, exploring off-road, and even participating in a bike parade highlight the freedom and fun the Liberty Trike offers. Sharing your experience with others shows how much you cherish your trike. We\'re here to support you and answer any queries you might have. Keep enjoying your wonderful moments on your Liberty Trike!'
  },
  {
    name: 'Brian F',
    date: 'August 31, 2023',
    title: 'Enjoying Family Time on the Trails!',
    score: 4.8,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Brian_F-Liberty_Trike_Canada.jpg?v=1693484844',
    video: '',
    html5video: '',
    comment: 'Biking the trails of Indian Battle Park with grandkids - Lethbridge, Alberta, Canada',
    response: 'Brian F, it sounds like you\'re having a fantastic time exploring the trails of Indian Battle Park with your grandkids! Spending quality family time outdoors and enjoying the beauty of Lethbridge, Alberta, is truly wonderful. The Liberty Trike is all about creating memorable moments and experiences, and we\'re delighted to be a part of your adventures. If you ever have any questions or need assistance, feel free to reach out. Keep on enjoying those rides with your grandkids!'
  },
  {
    name: 'Heidi L.',
    date: 'August 30, 2023',
    title: 'Liberty Trike Changed My Sister\'s Life!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/HeidiL-Liberty_Trike.jpg?v=1693413761',
    video: '',
    html5video: '',
    comment: 'Well! The first thing I have to say is THANK YOU Liberty Trike for making my sister so happy. My sister Penny is deaf. She has a developmental disability and recently had a stroke. Her Liberty Trike has changed her life and gave her freedom back. She is 69 years of age and lives in her own house just a short way from other family that support her. With age it was becoming difficult for her to stay independent. It is the best birthday yet. With the help from Liberty Trike adding a right pedal foot strap, mag wheels and a suggestion of the cramp buster, it is perfect. Her birthday is actually not yet, I have a few more presents up my sleeve to add as well. It took her a week just to learn how to operate it and she was so very nervous, but she got it. The key and battery being the most difficult for her.  Today she rode for 4 hours, 4 hours!, can you believe it! She said she loved the wind in her face. I have not seen such a big smile. So many people stopped her to ask about her Trike. She proudly handed out Liberty Trike cards. So Liberty Trike, you will have to send her more cards, a lot more cards. I am the only sibling that does not live close to her. I flew down just to put it together, don’t worry, I am there often and she comes to stay with me during the coldest part of winter. Now I have to save up for one for me.  She will never come and visit if I don’t have one here for her to ride.  Well, I kinda think it’s pretty cool. NOW I WANT ONE. Ha! She picked my favorite color too. TWINS. Anyway, I am sure she will have many adventures and I’ll keep you posted of all of them. She loves it. I thank you Liberty Trike.',
    response: 'Heidi, we are truly touched by your heartfelt story and the impact the Liberty Trike has had on your sister Penny\'s life. It warms our hearts to know that Penny is experiencing newfound freedom and joy with her Liberty Trike. Your dedication to helping her and your commitment to her well-being are truly inspiring. We\'re glad the customizations we suggested worked well for her, and it\'s amazing to hear that she spent 4 hours riding with a big smile on her face. We would be more than happy to provide more cards for her to share with others. It\'s also exciting to hear that you\'re considering getting one for yourself. Thank you for sharing your story with us, and we look forward to hearing about Penny\'s many adventures ahead. Best wishes to both of you!'
  },
  {
    name: 'Lori G.',
    date: 'August 23, 2023',
    title: 'Adventures with My Furry Friend!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LoriG-Liberty_Trike.jpg?v=1693413672',
    video: '',
    comment: 'Kenny got a pet bike basket on Sunday. He loves going for rides with me. So far he and I have logged 25 miles since Sunday afternoon. It’s nice having my little buddy with me while I ride my trike.',
    response: 'Lori, your shared adventures with Kenny sound absolutely heartwarming! We\'re thrilled to hear that Kenny is enjoying the rides with you, and it\'s wonderful that you two have already covered 25 miles together. The Liberty Trike not only brings joy to its riders but also extends its charm to our furry friends. We hope these rides continue to create beautiful memories for you and Kenny. If you ever need any assistance or have questions, don\'t hesitate to reach out. Happy riding to you both!'
  },
  {
    name: 'Jennifer M.',
    date: 'August 21, 2023',
    title: 'Life-Changing Experience with My Liberty Trike!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JenniferM-Liberty_Trike.jpg?v=1692623721',
    video: '',
    comment: 'Yesterday was a BIG DAY! After a spinal cord injury and 19 back operations later, I am enjoying my new #LibertyTrike! I researched all types of electric trikes for over a month and Liberty Trike was the winner, hands down! There\'s no other comparison to the quality, being compact, lightweight (compared to others), easily manageable, tons of color options and most importantly... THE CUSTOMER SERVICE!\nThis wasn\'t a lightweight decision for me. In advance I called the company and spoke to Linda. She had all the time in the day for me and answered every question and concern I had thoroughly. (I had no call backs from other companies)\nFortunately, I live in New Jersey and about 45 minutes away from where they make all their new bikes in Pennsylvania. Linda invited me to their warehouse so I could make sure the Liberty Trike was perfect for me.\nNow I know where Santa keeps all of his hard working elves! Jason Kraft(CEO) quickly came running down from his office to greet me and worked with me for a couple hours to teach me everything about the bike and helped facilitate building me my perfect bike on the spot yesterday! I can\'t thank everyone enough for your time yesterday, you made this important day perfect for me.\nLiberty Trike simple rocks. Again, I\'m so fortunate that I live relatively close and was able to have this experience firsthand. For all those who live further away, I just want to emphasize and reassure you that when you invest in a Liberty Trike, I witnessed firsthand that every employee they have is hard working and genuinely cares about every aspect and detail of the work they are doing. You are in good hands!\nJust one last thing, I HAVE THE BEST BIKE OUT THERE, lalalalalalalalala! Mine is better than yours!!!! 😂💜\n#AGreatCompany #ElectricTrike #ElectricTechnologies #Blessed',
    response: 'Jennifer McCann, we\'re truly moved by your heartfelt testimonial. Your journey to embracing the freedom and joy of biking despite your challenges is inspiring. We\'re immensely grateful that you chose Liberty Trike as your companion in this journey. Your kind words about our quality, customer service, and the overall experience mean the world to us. It\'s heartwarming to know that Linda and Jason made your day special at our warehouse. Your enthusiasm and positivity shine through, and we\'re thrilled to be a part of your story. Keep enjoying your Liberty Trike and spreading that wonderful spirit!'
  },
  {
    name: 'Darla B.',
    date: 'August 21, 2023',
    title: 'Exploring Bishop Lake Campground with Joy',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/darlab-liberty_trike.png?v=1692623234',
    video: '',
    html5video: '',
    comment: 'I love biking around at Bishop Lake campground.',
    response: 'Darla B., it\'s wonderful to hear that you\'re enjoying biking around Bishop Lake campground with your Liberty Trike. Exploring the outdoors and soaking in the natural beauty is truly rejuvenating. If you ever want to share more of your experiences or if you have any questions, feel free to reach out. Keep relishing those delightful rides!'
  },
  {
    name: 'Krissy G.',
    date: 'August 10, 2023',
    title: 'Embracing Independence and Joy with Liberty Trike',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Krissy-Liberty-Trike.jpg?v=1691694430',
    video: '',
    html5video: '',
    comment: "Here is my story. My name is Krissy G******. I'm 48 years old, and from Minnesota. I purchased my Liberty Trike in May of 2023. I have never been able to learn to ride or be able to ride a bike my entire life, having been born with a rare degenerative bone disease, causing brittle breakable bones, and muscle weakness too. For the most part, I am wheelchair bound, but can also use crutches for short distances. I went through and survived breast cancer in 2016, and the medication I have to take causes weight gain. I wanted a way to get outside in our Minnesota summer and still get some exercise. I bit the bullet and bought my Liberty Trike. I wish I would have done it years ago. It has been so good for me! I am gaining more strength in my legs, and losing some weight as well. I just turned 100 miles this past weekend after owning it for about only 10 weeks. When I come home from work during the week, by boyfriend and I will go for a nice ride around the pond in our neighborhood and discuss the day. On the weekends, when he is at work, I go for nice rides all around town to just relax with music, or just with the sounds of the neighborhood. If I go too far, and start to get worn out, I don't have to worry, as there is the power assist to make sure I return home safely.\n\nAgain, thanks so much for allowing me to be more independent and enjoy the outdoors. Liberty Trike is a God send!",
    response: "Krissy G., your journey with the Liberty Trike truly warms our hearts. We are deeply moved by your determination and the way you\'ve embraced the freedom to explore the outdoors. Your story is a testament to the power of resilience and the positive impact that the Liberty Trike can have on people\'s lives. We\'re thrilled that you\'re gaining strength, enjoying the rides, and experiencing the joy of being outside. Your words inspire us to continue our mission of providing mobility and independence to individuals like you. If you ever need assistance or have questions, please don\'t hesitate to reach out. Keep on riding and enjoying every moment of your Liberty Trike journey!"
  },
  {
    name: 'Donna N.',
    date: 'August 10, 2023',
    title: 'A Break from the Heat for Noah!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/donnan-liberty_trike.png?v=1691671513',
    video: '',
    html5video: '',
    comment: 'Well we finally got a break from triple digits so my son got to ride! Noah has down syndrome and autism, and is a cancer survivor! Thanks Official Liberty Trike Owners Group for a great deal on Noah’s bike! I know he looks serious lol, but he’s just concentrating!!',
    response: 'Hi Donna! It\'s heartwarming to see Noah enjoying his Liberty Trike. We\'re glad the weather allowed for a great ride. Noah\'s concentration is a testament to his joy and focus while riding. Thank you for sharing this special moment with us. If you ever need any assistance or have questions, don\'t hesitate to reach out. We\'re here to support you and Noah in his biking adventures!',
  },
  {
    name: 'Linda T.',
    date: 'August 10, 2023',
    title: 'Enjoying Outdoor Market and Concert with My LT',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/lindat-liberty_trike.jpg?v=1691671321',
    video: '',
    html5video: '',
    comment: 'Rode my LT to the Wednesday night outdoor market and concert tonight. This is why I wanted an LT to begin with, to go out and have fun. I had a blast. I was surprised how many people came up to me and asked questions and chatted and told me they wanted one. Luckily, I had a supply of cards. I would love to have a local friend group to go riding with. 😎',
    response: 'Linda, we\'re thrilled to hear that you\'re enjoying your Liberty Trike at the outdoor market and concert! It sounds like you had an amazing time and even sparked interest from others. Having a supply of cards to share is a great idea. Riding with a local friend group would be fantastic for even more fun outings. If you ever need anything or have questions, don\'t hesitate to reach out. Keep enjoying your rides and spreading the joy of Liberty Trike!',
  },
  {
    name: 'Linda B.',
    date: 'August 10, 2023',
    title: 'Trike Fun with Friends at the Gym',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/linda-b-liberty_trike.jpg?v=1691671438',
    video: '',
    html5video: '',
    comment: 'Maggs and two friends at the gym?',
    response: 'Linda, it\'s wonderful to see you having fun with Maggs and your friends at the gym! The Liberty Trike is all about creating enjoyable moments and experiences. If you have any stories or more adventures to share, feel free to let us know. Keep having a great time riding!',
  },
  {
  name: 'Nancy W. G.',
  date: 'August 2, 2023',
  title: 'Feeling Alive on Blackwater Heritage Trail!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/nancyg-liberty_trike.jpg?v=1690982084',
  video: '',
  html5video: '',
  comment: 'Another beautiful morning for a bike ride on our favorite local trail. Blackwater Heritage Trail! The Cicadas were singing like crazy. Loving my trike more and more! Makes me feel so alive out in fresh air, sunshine and nature! 12 mile today! Perfect day!',
  response: 'Nancy, we\'re thrilled to hear that you had another wonderful ride on the Blackwater Heritage Trail. It sounds like a perfect day with the Cicadas singing, fresh air, sunshine, and nature surrounding you. We\'re delighted to know that your Liberty Trike is bringing you so much joy and making you feel alive. The freedom and happiness you experience on your rides is what motivates us to keep providing the best experiences possible. If you have any questions or need assistance, don\'t hesitate to reach out. Keep enjoying your rides and making the most of each day!',
  },
  {
  name: 'Rosemary J.',
  date: 'August 1, 2023',
  title: 'Enjoying Summer Rides in Minnesota!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/rosemaryj-liberty_trike.jpg?v=1690982520',
  video: '',
  html5video: '',
  comment: 'Had my daughter & hubby visit me Sat. the 29th & showed off my trike etc.. Then I took it on a short 20 min. ride around 8:40 p.m. as it cooled off enough to get out! It has been in the 90’s here in MN. 😎',
  response: 'Rosemary, it sounds like you had a wonderful time showing off your Liberty Trike to your daughter and hubby. It\'s always fun to share the joy of riding with loved ones. We\'re glad to hear that you managed to sneak in a short evening ride despite the hot weather in Minnesota. The Liberty Trike is designed to provide comfort and enjoyment in various weather conditions. If you have any questions or need assistance, don\'t hesitate to reach out. Keep having fun on your rides and enjoy the summer weather!',
  },
  {
    name: "Chris D",
    date: "July 24, 2023",
    title: "My Liberty Trike Adventure!",
    score: 4.9,
    image: "https://cdn.shopify.com/s/files/1/0865/1792/files/ChrisD-Liberty-Trike.jpg?v=1695476120",
    video: "",
    html5video: "",
    comment: "My husband convinced me to get a Liberty Trike, and it's been a game-changer! I was worried about safety due to my age and osteoporosis, but this trike is perfect. It's compact, easy to transport, and the back brakes are a plus. My husband went all out, adding a dog carrier, comfy seat, gel seat cover, suspension seat post, and more. He even rigged a spare battery for peace of mind. Recently, he upgraded the wheels to mag wheels, and it looks fantastic. I absolutely love riding it around our neighborhood. Thank you, Liberty Trike!",
    response: "Chris D, we're thrilled to hear how your Liberty Trike has become an exciting adventure! Your husband's enthusiasm in customizing it is fantastic. Safety and comfort are top priorities, and it's wonderful to know the trike met your needs. Riding with your toy poodle must be a delight. Your trike journey continues to evolve, and we're here to support your future adventures. If you have any questions or need assistance, please don't hesitate to reach out. Keep enjoying those rides!"
  },
  {
    name: 'Michelle T.',
    date: 'July 25, 2023',
    title: 'Gorgeous Sunset Ride with My Bestie!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Lt-Bestie-Riders.jpg?v=1690315212',
    video: '', 
    html5video: '',
    comment: 'Sunset ride with my bestie in my neighborhood Sunday! Gorgeous sunset and fun ride on trials and sidewalks around my house!',
    response: 'Michelle, we\'re thrilled to hear that you and your bestie had a fantastic sunset ride in your neighborhood. It sounds like a wonderful experience, enjoying the gorgeous sunset and exploring trails and sidewalks around your house. Our goal is to provide you with joyous rides and memorable moments, and we\'re delighted to know that you\'re having fun with your Liberty Trike. Keep cherishing those special rides, and if you have any questions or need assistance, feel free to reach out. Happy riding!',
  },
  {
  name: 'Lana G.',
  date: 'July 24, 2023',
  title: 'Freedom and Joy Camping with My Liberty Trike!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Lana-Liberty_Trike.jpg?v=1690223010',
  video: '',
  html5video: '',
  comment: 'My first time camping with my trike! It was so nice to be able to see things without going through pain from my feet and legs. I really love the freedom I now have. Thank you Liberty Trike❤️',
  response: 'Lana, we\'re absolutely thrilled to hear about your first camping experience with your Liberty Trike! It\'s heartwarming to know that our trike has provided you with the freedom to explore and enjoy without the pain you used to experience. We designed the Liberty Trike to bring joy and comfort to your rides, and we\'re honored to have played a part in your camping journey. If you ever need assistance or have any questions, don\'t hesitate to reach out. Happy riding and camping, and may you continue to cherish the freedom your Liberty Trike brings!',
  },
  {
  name: 'Linda B.',
  date: 'July 24, 2023',
  title: 'A Beautiful Ride Along the Susquehanna River!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LindaB-Liberty_Trike.jpg?v=1690212592',
  video: '',
  html5video: '',
  comment: 'Took Maggs on the Enola Low Grade trail, 12.5 miles to Safe Harbor Dam. Beautiful day riding along the Susquehanna River in PA.',
  response: 'Linda, thank you for sharing your wonderful experience with Maggs, your Liberty Trike! Riding along the Enola Low Grade trail to Safe Harbor Dam, a 12.5-mile journey, sounds absolutely delightful. We\'re glad to hear that you had a beautiful day along the scenic Susquehanna River in PA. Our trikes are designed to bring joy and freedom to your rides, and we\'re delighted that you\'re making the most of your time outdoors. If you have any questions or need any assistance, feel free to reach out. Happy riding and keep exploring new horizons with Maggs!',
  },
  {
    name: 'Rosemary J.',
    date: 'July 24, 2023',
    title: 'Loving My Trike at 79 1/2 Years Old!',
    score: 5,
    image: '',
    video: '', 
    html5video: 'https://cdn.shopify.com/videos/c/o/v/862142e9c1634d43b2e1a497aa1222f8.mp4',
    comment: 'Have had my trike only a few days & love it! 1st trip was riding to my town’s Fri. night car show they have every Fri. night! My son was with me & taped the videos. I never thought I’d be doing this at 79 1/2 years old when it’s been yrs. since I rode a bicycle. Now am getting out more & hoping to stay healthy to do more things! 😎',
    response: 'Rosemary, we\'re so thrilled to hear that you\'re loving your Liberty Trike at 79 1/2 years old! It\'s truly inspiring to know that you\'ve been enjoying the rides and even had a fun trip to your town\'s Fri. night car show. We\'re delighted that your son was there to capture the memories on video. It\'s incredible how our trikes can bring back the joy of cycling and help you stay active and healthy. We\'re here to support you on your journey, and if you ever need any assistance or have any questions, don\'t hesitate to reach out. Keep enjoying your rides and making the most of each day with your Liberty Trike! 😎🚴‍♀️',
  },
  {
    name: 'Laura F.',
    date: 'July 23, 2023',
    title: 'Life-Changing Experience with My Barbie Pink Liberty Trike!',
    score: 5,
    image: '',
    video: '', 
    html5video: 'https://cdn.shopify.com/videos/c/o/v/f1ef9775ae2945db95a8a11a506e4455.mp4',
    comment: 'Rolling along the French Broad river in Asheville, NC. This bike is life-changing!',
    response: 'Laura, we\'re overjoyed to hear that your Barbie Pink Liberty Trike has brought about a life-changing experience for you! Rolling along the French Broad river in Asheville, NC, must have been a delightful and scenic adventure. Our goal is to provide our customers with the best possible experience and seeing your joy and satisfaction is truly rewarding. If you ever need any assistance or have any questions, feel free to reach out. Keep enjoying your rides and making memories with your Liberty Trike!',
  },
  {
  name: 'Claudia C.',
  date: 'July 23, 2023',
  title: 'A Great Time Out with My Liberty Trike!',
  score: 4.8,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/claudia-libertytrike.jpg?v=1690124800',
  video: '',
  html5video: '',
  comment: 'We had a great time out today. Even found a yard sale and loaded up my baskets,\/😁😁😁',
  response: 'Claudia, we\'re thrilled to hear that you had a fantastic time with your Liberty Trike today! It\'s wonderful to know that you even came across a yard sale and made use of your trike\'s baskets. The Liberty Trike is designed to bring convenience and enjoyment to your rides, and we\'re delighted to be a part of your adventures. If you have any questions or need assistance, feel free to reach out anytime. Happy riding!',
  },
  {
    name: 'Bonnie K.',
    date: 'July 23, 2023',
    title: 'A Great Alternative to a Bike After Foot Surgery!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Bonnie-Liberty_Trike.jpg?v=1690126204',
    video: '', 
    html5video: '',
    comment: 'After having major foot surgery, I thought the trike would be a great alternative to a bike. I got it slightly used and made basket liners so my stuff wouldn’t rattle and to look cute 😀. So far so good.',
    response: 'Bonnie, we\'re delighted to hear that your Liberty Trike has provided you with a great alternative to a bike after your major foot surgery. It\'s wonderful that you\'ve customized it with basket liners to keep your belongings secure and add a touch of cuteness to your rides. We hope your recovery is going smoothly and that your trike continues to be a valuable companion in your journey towards better mobility. If you have any questions or need any further assistance, feel free to reach out. Keep enjoying your rides and taking in the sights with your Liberty Trike!',
  },
  {
  name: 'Denise C. L.',
  date: 'July 23, 2023',
  title: 'Grateful for My Liberty Trike!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Denise-liberty_trike.jpg?v=1690124803',
  video: '',
  html5video: '',
  comment: 'Without my Liberty trike I would not have been able to go to Horseshoe Bend in Page Arizona. Thank you Liberty trike I love my bike.',
  response: 'Denise, we\'re incredibly happy to hear that your Liberty Trike allowed you to visit and enjoy places like Horseshoe Bend in Page, Arizona. It\'s heartwarming to know that our trike has been a valuable companion for your adventures. Your love for the bike means a lot to us, and we are committed to providing you with the best experiences possible. If you have any questions or need further assistance, don\'t hesitate to get in touch. Keep exploring and making memories with your Liberty Trike!',
  },
  {
  name: 'Jerry J.',
  date: 'July 23, 2023',
  title: 'Love\'n Life Again with My Liberty Trike!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JerryJ-_Liberty_trike.png?v=1690124861',
  video: '',
  html5video: '',
  comment: 'My Liberty trike gets me back on the trails, that I used to be able to hike - Love\'n life again. Circle B Bar Reserve, Lakeland FL',
  response: 'Jerry, we\'re thrilled to hear that your Liberty Trike has enabled you to rediscover the joy of exploring trails and places like Circle B Bar Reserve in Lakeland, FL. Providing our customers with the freedom to enjoy outdoor adventures is what drives us. Your happiness is our greatest reward, and we\'re honored to be a part of your journey to love life again. If you have any questions or need further assistance, don\'t hesitate to reach out. Keep enjoying your rides and making the most of your time outdoors!',
  },
  {
    name: 'Kathy Johnson',
    date: 'July 22, 2023',
    title: 'Enjoyable Visit with Family and Liberty Trikes!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/kathyj-liberty_trike.jpg?v=1690030886',
    video: '', 
    html5video: '',
    comment: 'My niece and her two teenagers stopped by for a visit during their summer travels. Turns out they all loved our Liberty Trikes!',
    response: 'Kathy, we\'re delighted to hear that your family enjoyed their visit and had a great time with the Liberty Trikes! It\'s always heartwarming to see our trikes bringing joy to family gatherings and creating wonderful memories. If your niece or anyone else in your family is interested in their own Liberty Trike, don\'t hesitate to reach out. We\'re here to help and support you all in your new adventures!',
  },
  {
    name: 'Carol Lazarus Roth',
    date: 'July 22, 2023',
    title: 'Life Changing Experience at Yellowstone National Park!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/carol_l_-_Liberty_trike.png?v=1690030820',
    video: '', 
    html5video: '',
    comment: 'Okay if you’re at all on the fence about buying a Liberty Bike, DO NOT HESITATE! It’s been life changing for me! I had a double knee replacement and have my grandma’s wonky feet and walking on uneven surfaces is scary for my balance. We are at Yellowstone right now and I took the trike all along the Old Faithful boardwalk through the geyser valley and then to the Morning Glory Pool. I never in a million years could have walked this and would have missed out while my husband did it solo. I am enjoying myself again and getting lots of interested comments. I may need to invest in the newer beefy tires because I am having so much fun exploring. Thank you Liberty for helping me enjoy life again❤️',
    response: 'Carol, your review truly warms our hearts! We are so thrilled to hear that your Liberty Trike has been a life-changing experience for you. It\'s incredible to know that it has allowed you to explore and enjoy places like Yellowstone National Park with ease and confidence. Your journey is an inspiration to others, and we are honored to be part of it. If you ever need any assistance or have questions about the beefy tires, don\'t hesitate to reach out. Happy adventuring and keep on exploring!',
  },
  {
    name: 'Tammy A.',
    date: 'July 21, 2023',
    title: '',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Tammya-liberty-trike.jpg?v=1689935582',
    video: '', 
    html5video: '',
    comment: 'We are excited to start this journey!',
    response: 'Hello Tammy! Thank you for choosing the Liberty Trike for your journey! We are thrilled to be part of your exciting adventure. If you have any questions or need assistance along the way, feel free to reach out. Happy riding and enjoy every moment on your Liberty Trike!',
  },
  {
    name: 'Dawn M.',
    date: 'July 19, 2023',
    title: '',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/DawnG-Liberty_Trike.jpg?v=1689796091',
    video: '', 
    html5video: '',
    comment: 'Have you ever wished you could do something that made you feel like a kid again? Something exciting and fun that put a smile on your face? Thanks to my birthday gift from Greg, I have been doing that for the past month.\n\nI haven’t been able to ride a bike since I was in high school. The neuromuscular disease that left me completely disabled for three years left me without enough balance or strength to ride a bike. That all changed when I got my new Liberty Trike! 🙌 I literally felt like a kid who had gotten her first new bike and learned to ride it. I could feel the ear to ear smile as I once again felt the exhilaration of the wind in my face. Pure JOY! I even officially logged the first 100 miles as of today! 🎉🚴\n\nI can’t express how grateful I am to have a new outdoor activity to keep my body moving and add another layer to living with healthy habits! (I’m also extremely thankful for Aminowise to help with quick muscle recovery. Cause if I’m being honest, sore muscles can quickly put a stop to my desire for more movement. 😜)\n\nLet me know if you’d like to \u201ctest drive\u201d my trike, or try a sample of the Aminowise. I’m always happy to help when I can.',
    response: 'Hello Dawn! We are thrilled to hear how much joy and freedom your Liberty Trike has brought you. It\'s incredible to see how it has helped you rediscover the exhilaration of riding and reach your milestone of 100 miles. We are glad that your new outdoor activity is contributing to your healthy habits and well-being. Thank you for sharing your experience, and we appreciate your willingness to offer test drives and share your recommendation of Aminowise. Keep enjoying your rides and spreading the joy of the Liberty Trike!',
  },
  {
  name: 'Laura F.',
  date: 'July 7, 2023',
  title: 'First Day of Sunny Georgia Bike Ride!',
  score: 5,
  image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LauraF-Liberty_Trike.jpg?v=1688909851',
  video: '',
  html5video: '',
  comment: 'Here I go... First day on my bike in sunny Georgia!',
  response: 'Hi Laura! We hope you have an amazing first day on your bike ride in sunny Georgia. Enjoy the beautiful weather and the wonderful sights along the way. Happy cycling!',
  },
  {
    name: 'Linda C.',
    date: 'July 4, 2023',
    title: 'Ready for the Parade with Pearl!',
    score: 4.6,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Linda-k-Liberty-trike.jpg?v=1688556266',
    video: '', 
    html5video: '',
    comment: 'Pearl is ready for the parade!',
    response: 'Hi Linda! We\'re glad to hear that Pearl is ready for the parade. We hope you have a wonderful time and enjoy the festivities!',
  },
  {
    name: 'Susan P.',
    date: 'July 4, 2023',
    title: 'Ready for the Hillsboro Fourth of July Parade!',
    score: 4.7,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Susan_G-liberty_trike.jpg?v=1688556139',
    video: '', 
    html5video: '',
    comment: 'Ross and "MyTrike" are all set to ride to the Hillsboro Fourth of July parade. We saw another lady on a red Liberty Trike ride past us at the parade.',
    response: 'Hi Susan! It\'s wonderful to hear that Ross and "MyTrike" are ready for the Hillsboro Fourth of July parade. Spotting another lady on a red Liberty Trike adds to the excitement of the event. We hope you had a fantastic time at the parade and enjoyed the ride on your Liberty Trike. Happy Fourth of July!',
  },
  {
    name: 'Linda B.',
    date: 'July 2, 2023',
    title: '4th of July Fun in the Retirement Village!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Linda-B-Liberty_Trike.png?v=1688303345',
    video: '', 
    html5video: '',
    comment: 'Rode MAGG\'S in the retirement Village today for 4th of July. I gave out about 25 cards and let others test ride Maggs. To date, we have 5 Liberty Trikes in the Village.',
    response: 'Hi Linda! It sounds like you had a fantastic time riding MAGG\'S in the retirement Village on the 4th of July. Sharing the joy of Liberty Trikes by giving out cards and allowing others to test ride Maggs is a wonderful way to spread the excitement. It\'s great to hear that there are now 5 Liberty Trikes in the Village. Keep on riding and bringing happiness to others!',
  },
  {
    name: 'April C. K.',
    date: 'June 25, 2023',
    title: 'Achieving the 5,000 Mile Goal and Finding Lady Liberty!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/april-liberty-trike.png?v=1687740379',
    video: '', 
    html5video: '',
    comment: 'Today, I am thrilled to announce that I have surpassed my 5,000-mile goal on my Liberty Trike!',
    response: 'Hi April! Congratulations on surpassing your 5,000-mile goal with your Liberty Trike! That\'s an impressive accomplishment, and we\'re thrilled to hear about your journey of adventure and exploration. It\'s wonderful that your rides also led you to discover Lady Liberty, a symbol of freedom and inspiration. We\'re grateful to have played a part in your amazing experiences, and we wish you many more memorable moments with your Liberty Trike!',
  },
  {
    name: 'Carol W. M.',
    date: 'June 25, 2023',
    title: 'Celebrating 1,000 Miles with Plum!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/carolw-liberty_trike.png?v=1687721118',
    video: '', 
    html5video: '',
    comment: 'I did it! Achieved 1,000 miles today on "Plum"! I have owned her since March 2022. Glad I had the back-up battery!',
    response: 'Hi Carol! Congratulations on reaching the incredible milestone of 1,000 miles with Plum, your Liberty Trike! It\'s a fantastic achievement, and we\'re thrilled to hear that you\'ve been enjoying your trike since March 2022. Having a backup battery is indeed a smart choice, ensuring you have the power to continue your rides with confidence. Keep up the great work and keep exploring with Plum!',
  },
  {
    name: 'Laura G. M.',
    date: 'June 23, 2023',
    title: 'Loving My New Ride!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LauraGM-Liberty_Trike.jpg?v=1687560287',
    video: '', 
    html5video: '',
    comment: 'I\'m loving my new ride, Ruby. I\'ve been practicing in an empty parking lot and neighborhood streets. Next, I need to practice folding it up so I can take it in my car to fun places. Would also like to learn how to take my doggy for a short run alongside. Anyone else do that? Suggestions? Thanks!',
    response: 'Hi Laura! We\'re thrilled to hear that you\'re loving your new ride, Ruby. Practicing in empty parking lots and neighborhood streets is a great way to get comfortable with your trike. When it comes to folding it up for transportation, we recommend consulting the user manual for proper instructions. As for taking your doggy for a run alongside, it can be a wonderful experience. Make sure to use a proper leash attachment and gradually introduce your dog to running alongside the trike. It\'s always a good idea to consult with a professional dog trainer for guidance. Enjoy your rides and have fun exploring new places!',
  },
  {
    name: 'Amy T. E.',
    date: 'June 23, 2023',
    title: 'Milestone Achievement: 1,000 Miles!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Mckenna-LibertyTrike.jpg?v=1687560500',
    video: '', 
    html5video: '',
    comment: 'Mckenna got her trike in 2020, and last week she hit 1,000 miles. She was so excited. This has truly changed her life!',
    response: 'Hi Amy! Congratulations to Mckenna on reaching the incredible milestone of 1,000 miles on her trike! We\'re thrilled to hear that this has made such a positive impact on her life. It\'s wonderful to see the joy and excitement that comes from achieving such a significant accomplishment. Keep on riding and exploring new horizons!',
  },
  {
    name: 'Jeff M.',
    date: 'June 22, 2023',
    title: 'Enjoying My Rig with New Pet and Cargo Trailer!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/jeffm-libertytrike-cargo.png?v=1687465097',
    video: '', 
    html5video: '',
    comment: 'My rig with new pet and cargo trailer. Aosom with hitch adapter (pictured below). Rides very nice and with no issues to the trike. Same tight turning radius with trailer.',
    response: 'Hi Jeff! We\'re glad to hear that you\'re enjoying your rig with the new pet and cargo trailer. It\'s great to know that the Aosom trailer with the hitch adapter is working well with your trike, providing a smooth ride and maintaining the tight turning radius. Thank you for sharing your experience with us!',
  },
  {
  name: 'Kelkay B.',
  date: 'June 20, 2023',
  title: 'Fun Learning Experience!',
  score: 5,
  image: '',
  video: '',
  html5video: 'https://cdn.shopify.com/videos/c/o/v/5a9b0acd08354f3ea86ec6b759d9d753.mp4',
  comment: 'Got my Liberty Trike yesterday. It has been so much fun learning how it all works, especially cornering! Every ride is a new adventure!',
  response: 'Hi Kelkay! We\'re delighted to hear that you received your Liberty Trike and are having a fun learning experience with it. Mastering the art of cornering is definitely exciting! We hope every ride continues to bring you joy and new adventures. Happy riding!',
  },
  {
  name: 'Chris P.',
  date: 'June 19, 2023',
  title: 'Feeling Like a Kid Again!',
  score: 5,
  image: '',
  video: '',
  html5video: '',
  comment: 'Got my Liberty Trike assembled on Saturday morning and went for a ride around our neighborhood. Very easy to use and ride, and I felt like a kid again! It has been decades, three hip replacements, and several autoimmune disorders since I last rode a bike. I never thought I\'d see the day. Really looking forward to getting out of the house and exercising a bit. My only regret is I didn\'t think to order it a few months earlier. Our beautiful spring and early summer just gave way to gross heat and humidity in the last two days 🤦‍♀️. #FirstWorldProblems',
  response: 'Hi Chris! We\'re thrilled to hear that you\'re feeling like a kid again on your Liberty Trike. It\'s wonderful that you were able to assemble it and take a ride around your neighborhood. We appreciate your patience in waiting for the right time to get back on a bike and embrace the joy of cycling. Enjoy your rides and have a fantastic time exploring the outdoors!',
  },
  {
    name: 'Rita F.',
    date: 'June 18, 2023',
    title: 'Enjoying the Waubash Cannonball Bike Trail!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/rita-fr-liberty-trike.png?v=1687116266',
    video: '', 
    html5video: '',
    comment: 'It\'s a great day for a trike ride on the Waubash Cannonball Bike Trail in NW Ohio. The scenic views and fresh air make it an enjoyable experience!',
    response: 'Hi Rita! We love the picture of you riding your yellow Liberty Trike on the Waubash Cannonball Bike Trail with your adorable poodle in the back basket. It looks like you\'re having a fantastic day enjoying the scenic views and fresh air. Thank you for sharing your wonderful trike ride with us!',
  },
  {
    name: 'Denise D.',
    date: 'June 18, 2023',
    title: 'Fun at the County Fair!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/denise-LT-LibertyTrike.jpg?v=1687095147',
    video: '', 
    html5video: '',
    comment: 'Took my Liberty Trike to our county fair, "country nights & carnival lights". It was a fantastic experience riding around and enjoying the festive atmosphere!',
    response: 'Hi Denise! We\'re delighted to hear that you had a fun time taking your Liberty Trike to the county fair. "Country nights & carnival lights" sounds like an exciting event, and we\'re glad your trike added to the festive atmosphere. Thank you for sharing your experience with us!',
  },
  {
    name: 'Wendy F.',
    date: 'June 18, 2023',
    title: 'Back to Adventuring with Indy!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/wendy-liberty-trike.png?v=1687094879',
    video: '', 
    html5video: '',
    comment: 'So happy to be back adventuring on my LT, Indy, after several weeks in the infirmary. She\'s feeling 100% better now. I put her through her paces in the dense crowds today and she shone like a star!',
    response: 'Hi Wendy! We\'re thrilled to hear that you\'re back to adventuring with Indy, your Liberty Trike, after your time in the infirmary. It\'s great to know that Indy is feeling better and ready for new adventures. We\'re glad she performed exceptionally well in the dense crowds and stood out like a star. Enjoy your rides and continue exploring with Indy!',
  },
  {
    name: 'Patricia E.',
    date: 'June 17, 2023',
    title: 'Excited for New Adventures with Manjano!',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Patricia_E-Liberty_trike.jpg?v=1687041884',
    video: '', 
    html5video: '',
    comment: 'Hi! I’m near Sacramento, CA. After a few years of limited mobility, I’m looking forward to spending time on my Liberty Trike which I have named Manjano (Swahili for yellow). I look forward to riding on a trail next to the American River and to going to the coast to enjoy riding at the beach. Yes, I have received my MAGS. I’m hoping to soon switch tires and make a couple other adjustments, and practice, practice and more practice.',
    response: 'Hello Patricia! Thank you for sharing your excitement and plans for new adventures with Manjano, your Liberty Trike. It\'s wonderful to hear that you\'re looking forward to riding on the trail near the American River and enjoying the beach. We\'re glad to hear that you have received your MAGS and are planning to make some adjustments to suit your preferences. Remember to take your time practicing and building your confidence. Enjoy your rides and have a fantastic time exploring new places!',
  },
  {
    name: 'Rhonda K.',
    date: 'June 17, 2023',
    title: 'Exciting First Rides',
    score: 4,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/RhondaK-Liberty-Trike.jpg?v=1687024202',
    video: '',
    html5video: '',
    comment: 'Wow! My red LT came yesterday, (only took a few days from the order date) so carefully packaged and, with the great video, my husband and I had it together within the hour. It\'s just beautiful! So glad it is made in the U.S.A.. I have to admit the first ride was crazy scary being the first time on 3 wheels. Second ride was much better, but I\'m still not confident enough to go too far from home. Thanks to all of you for your informative posts, I know it\'s a learning curve and trust issue, so I\'ll get there! Thanks to the people at Liberty Trike and everyone who shares helpful information.',
    response: 'Thank you, Rhonda, for sharing your excitement about your red LT! We\'re glad to hear that it arrived quickly and was carefully packaged. It\'s great that the assembly was smooth with the help of our video. We understand that riding on three wheels for the first time can be a bit scary, but with practice, your confidence will grow. We appreciate your trust and support. Regarding the "Made in the U.S.A." aspect, we\'d like to clarify that while some components of the Liberty Trike are sourced globally, the final assembly and quality control are done in the U.S., ensuring high standards and supporting local jobs. If you want to learn more about the importance of building electric bikes in America, please check out our recent blog post "Electric Bike Technologies: Why Building in America Matters" https://www.libertytrike.com/blogs/liberty-trike/electric-bike-technologies-why-building-in-america-matters. Happy riding and enjoy your Liberty Trike!'
  },
  {
    name: 'Heather H.',
    date: 'June 17, 2023',
    title: 'Independence and Freedom',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/heather_h-Liberty_trike.jpg?v=1687023869',
    video: '', 
    html5video: '',
    comment: 'I love my Liberty trike! Being 29 with a chronic illness is hard to navigate, but having this trike has given me so much independence and freedom to get out on my own again and make it so I’m not housebound. I’m so thankful for it, and my sweet dog loves it - my husband has nicknamed it the running machine. Haha! I attached a short stretchy bike leash to the seat, and it works perfectly. She walks like a pro, but then again she grew up with my wheelchair, so she’s learned quickly not to get run over. I also added this wicker basket from Etsy I love. For anyone looking at getting a trike, I’d highly recommend it! It’s so nice to have a classy looking mobility device instead of a clunky one.',
    response: 'Thank you, Heather, for sharing your wonderful experience with your Liberty trike! We\'re thrilled to hear that it has provided you with independence and freedom, allowing you to get out and about without feeling housebound. It\'s heartwarming to know that your sweet dog enjoys the rides too. The addition of the bike leash and wicker basket sounds perfect for your needs. We appreciate your recommendation and hope you continue to enjoy your classy and reliable mobility device. Happy riding!',
  },
  {
    name: 'Emy B.',
    date: 'June 17, 2023',
    title: 'Loving the Cool Weather Rides',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberteal_-liberty-trike.jpg?v=1686999357',
    video: '', 
    html5video: '',
    comment: 'Loving the cool weather rides on Liberteal!',
    response: 'Thank you for sharing your love for cool weather rides on Liberteal! We\'re thrilled that you\'re enjoying your rides and embracing the refreshing weather. Keep exploring and having fun on your Liberty Trike!',
  },
  {
    name: 'Barbara B.',
    date: 'June 17, 2023',
    title: 'Waiting is Weird',
    score: 5,
    image: '',
    video: '', 
    html5video: '',
    comment: 'Seems I\'ve been wanting one for such a long time, Waiting is Weird, ha! Actually been looking at trikes a couple of years now before narrowing down what was best for me! My main reason for the Liberty Trike is, it separates into two parts (25 lbs each) to place into my tiny car. At 71, so important, the lifting. I love that, and the 6 mo Affirm offer, plus the price!! Can\'t be beat!',
    response: 'Thank you, Barbara, for sharing your experience and excitement about getting your Liberty Trike! We understand that waiting can be tough, but we\'re glad you found the perfect trike for your needs after your careful research. The portability and ease of separation into two parts make it convenient for transportation in your tiny car. We\'re delighted that the features, affordability, and financing options have made your decision even better. Enjoy your rides and the freedom to explore with your Liberty Trike!',
  },
  {
    name: 'Beth W.',
    date: 'June 17, 2023',
    title: 'Love My First Ride',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/bethr-liberty-trike.jpg?v=1686998539',
    video: '',
    html5video: '',
    comment: 'Just got back from my first ride. Love it!',
    response: 'Thank you, Beth, for sharing your enthusiasm after your first ride! We\'re thrilled that you\'re loving your Liberty Trike. Enjoy many more wonderful rides ahead!',
  },
  {
    name: 'Mary U.',
    date: 'June 17, 2023',
    title: 'Liberty Trike',
    score: 5,
    image: '',
    video: '',
    html5video: '',
    comment: 'I really enjoy riding my bike and I have 300 miles on it in one year. Great company and excellent customer service.',
    response: 'Mary U., we\'re thrilled to hear that you\'re enjoying your Liberty Trike and have logged 300 miles in just one year! Thank you for your kind words about our company and customer service. If you ever need assistance or have questions, please don\'t hesitate to reach out. Keep on riding!'
  },
  {
    name: 'Linda T.',
    date: 'June 17, 2023',
    title: 'Building Confidence with My LT',
    score: 4.5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/lindat-liberty-trike.jpg?v=1686998388',
    video: '',
    html5video: '',
    comment: 'I\'ve had my LT for 3 weeks now, mainly riding in front of my house. Today, I took it to an empty parking lot to get some practice. Slowly but surely, I\'m building my confidence. It\'s a great feeling!',
    response: 'Thank you, Linda, for sharing your progress with your LT! We\'re glad to hear that you\'re building your confidence and enjoying the ride. Keep practicing and have fun exploring new areas with your Liberty Trike!',
  },
  {
    name: 'Linda W.',
    date: 'June 16, 2023',
    title: 'Family Ride on the Mike Castle Trail',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/linda-pink-liberty-trike.png?v=1686934378',
    video: '',
    html5video: '',
    comment: 'Going for a ride with my family on the Mike Castle Trail along the C&D Canal in Delaware. The Liberty Trike has been a wonderful addition to our family outings. It allows us all to ride together and enjoy the beautiful scenery along the trail.',
    response: 'Thank you, Linda, for sharing your family ride experience on the Mike Castle Trail! We\'re thrilled to hear that the Liberty Trike has enhanced your family outings, allowing you to ride together and appreciate the beautiful scenery. Enjoy your time on the trail with your loved ones!',
  },
  {
    name: 'Debra F-M.',
    date: 'June 15, 2023',
    title: 'Safe, Secure, and Miraculous!',
    score: 5,
    image: '',
    video: '',
    html5video: '',
    comment: 'I totally love my trike! I met you when I bought my yellow trike last month. After a few rides at home, I got used to the throttle, the hand and coaster brake. My neighborhood street is flat in some areas, downhill and uphill. I’ve had so many compliments on my trike; one neighbor is a retired physical education teacher. The fact that I can even ride a trike is a miracle! I have spinal stenosis, somewhat fixed, and a poor sense of balance. I feel so safe and secure on this trike. I did add the Velcro pedal straps. Huge difference! Love all of the staff who helped adjust everything to make my trike perfect for me!',
    response: 'Thank you, Debra, for sharing your incredible experience with your yellow trike! It\'s wonderful to hear that you quickly adapted to the throttle, the hand, and coaster brake, allowing you to navigate your neighborhood\'s various terrains. The compliments you\'ve received are well-deserved, and it\'s inspiring to know that your trike has given you the ability to ride despite physical challenges. Your safety and security on the trike are of utmost importance, and we\'re glad the Velcro pedal straps made a significant difference. Our staff is dedicated to ensuring your trike is perfect for you. Enjoy many more amazing rides!',
  },
  {
    name: 'Marilyn E.',
    date: 'June 15, 2023',
    title: 'A Blessing for Bike Rides!',
    score: 5,
    image: '',
    video: '',
    html5video: '',
    comment: 'I took my neighbor\'s 5-year-old riding with him on his 20-inch bike in front, and me on my Liberty Trike. He can ride fast, so I had to use 4th speed at times to keep up with him on the trail. We will be doing this all summer now that school is out. During the COVID-19 lockdown, he came to my house next door every morning because his parents are teachers, and there\'s no way they could teach and keep an active 2-year-old safe. As a retired special ed teacher, I taught him like he was in pre-school. We are very close, and he keeps me young. The Liberty Trike helps me continue to do bike rides with my neighbors and little Conor. At 80, I was not sure if riding my expensive small-frame Mountain Bike was safe, so this trike is a blessing.',
    response: 'Thank you, Marilyn, for sharing your heartwarming story! It\'s wonderful to hear that your Liberty Trike has allowed you to enjoy bike rides with your neighbor and little Conor. Your dedication to teaching and bonding with Conor during the lockdown is truly admirable. We\'re glad the Liberty Trike has provided a safe and reliable option for your rides, giving you peace of mind. It\'s amazing to see how the trike has brought joy and kept you young. Wishing you many more memorable adventures with your neighbors and Conor!',
  },
  {
    name: 'Victoria B.',
    date: 'June 15, 2023',
    title: 'Doggy Adventures in Style',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/vickyBand_doggos.jpg?v=1686861619',
    video: '',
    html5video: '',
    comment: 'This is how I take all my dogs out. I get a lot of looks, all nice.',
    response: 'Thank you, Victoria, for sharing your doggy adventures with us! We\'re delighted to hear that you enjoy taking your dogs out with your Liberty Trike. It\'s fantastic that you receive positive attention during your rides. Keep having fun and turning heads with your stylish rides!'
  },
  {
    name: 'Carla G.',
    date: 'June 15, 2023',
    title: 'Fast Delivery and Doggy Adventures',
    score: 5,
    image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/carlag-doggos.jpg?v=1686861258',
    video: '',
    html5video: '',
    comment: 'I ordered mine Monday morning, got it Wednesday 2pm! Out riding with my dogs at 3pm!!! Love this bike !!',
    response: 'Thank you, Carla, for sharing your experience! We\'re thrilled to hear that you received your Liberty Trike quickly and had a great time riding with your dogs. We appreciate your love for our bike. Happy riding with your furry companions!'
  },
   {
      name: 'Joni S. M.',
      date: 'June 12, 2023',
      title: 'A Memorable Ride with Bubblegum!',
      score: 5,
      image: '',
      video: '', 
      html5video: 'https://cdn.shopify.com/videos/c/o/v/c23047560613497983251718c77492b6.mp4',
      comment: 'Longest ride on my trike, Bubblegum, to date. It was right around 14 miles round trip from where I’m staying to South Beach! I loved people watching at the same time I was riding! I forgot my cable and lock. I’ll make sure I take them with me from now on so I can stop and go into stores and restaurants! Did take my extra battery. I had ridden with one of them that was still at 5. I waited until I had three bars before I switched to the fully charged one. It got down to one bar before I got back to where I’m staying.',
      response: 'Thank you, Joni, for sharing your memorable ride with Bubblegum, your Liberty Trike! We\'re thrilled to hear about your longest ride to date, covering around 14 miles round trip to South Beach. It\'s great that you enjoyed people watching while riding and had a fantastic time. Remembering to bring your cable and lock will indeed allow you to stop at stores and restaurants with peace of mind. We appreciate your careful battery management too. Keep exploring and enjoying your rides with Bubblegum!',
    },
    {
      name: 'Kathy K. G.',
      date: 'June 12, 2023',
      title: 'Grateful for the Kindness of Sharon!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/fgsdfg.png?v=1686577469',
      video: '', 
      html5video: '',
      comment: 'Last week I posted and asked if there was anyone in my area that may have a LT. And if so, would they let me come see the trike. Well right away I got an offer from Sharon Keenan. She was so sweet and kind to do this. Had a beautiful drive to her home. Thank you, Sharon, for being so kind and friendly. It was so fun to ride "Molly".',
      response: 'Thank you, Kathy! We\'re delighted to hear about your positive experience connecting with Sharon and riding "Molly". It\'s heartwarming to see our Liberty Trike community coming together to support and share their trikes. We appreciate Sharon\'s kindness and your willingness to explore and connect with fellow riders. If you ever need any assistance or have more experiences to share, please don\'t hesitate to reach out. Happy riding!',
    },
    {
      name: 'Brenda G. S.',
      date: 'June 10, 2023',
      title: 'Unforgettable Trail Experience!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/351322579_10230515827819680_246691573966168284_n.jpg?v=1686425042',
      video: '', 
      html5video: '',
      comment: 'Loved biking with hubby on the trails at First Landing State Park in Virginia Beach, Va. The weather was perfect, and Queen Bee never let me down.',
      response: 'Thank you, Brenda! We\'re thrilled to hear that you had an unforgettable biking experience with your Liberty Trike at First Landing State Park. It\'s wonderful that Queen Bee performed flawlessly, allowing you and your hubby to enjoy the perfect weather and explore the beautiful trails. If you have any more adventures or need any assistance in the future, please don\'t hesitate to reach out. Happy trails!',
    },
    {
      name: 'Steve & Diane V.',
      date: 'June 5, 2023',
      title: 'Fun-filled Adventures with Our Trikes!',
      score: 5,
      image: '',
      video: '', 
      html5video: '',
      comment: 'We love our Liberty Trikes! We rode 20 miles today and love our trikes even more than yesterday. We went out shopping and doing errands, zipping between Indiana and Michigan. A few times, people at the stores came out to check out our trikes, or they watched us ride up. Fun day and great to get out and enjoy! \uD83D\uDE3B',
      response: 'Steve and Diane, thank you for sharing your wonderful experience with your Liberty Trikes! We\'re thrilled to hear that you had a fun-filled adventure riding 20 miles and enjoying your trikes. It\'s fantastic that people showed interest and admiration for your trikes during your shopping trips. We hope your Liberty Trikes continue to bring you joy and memorable moments on your future rides. Happy trails!',
    },
    {
      name: 'Ginny H.',
      date: 'June 5, 2023',
      title: 'Excellent Support and Reliability!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/347115916_741659134414036_1582472249881508672_n.jpg?v=1685976712',
      video: '', 
      html5video: '',
      comment: 'A big thanks to Liberty Official Liberty Trike people for helping us get my Trike up and running again, as the steering went out and needed a new fork and bearings (one was our fault as had tightened it too tight before talking to the experts from Liberty Trike). After showing them the bad parts, they put together a package for us, and two days later, it was at our house. My husband put it together and runs perfectly! Couldn’t be more proud of Liberty Trike\'s help on this problem! I think having a little over 5600 miles helped attribute to the problem considering some of the rough trails I was on and going full speed most of the time!! This is the only problem I have had with the Trike since I bought it in August of 2018. So no complaints here!!!',
      response: 'Thank you so much for your kind words, Ginny! We\'re thrilled that we were able to assist you in getting your Trike up and running smoothly again. It\'s great to hear that your husband successfully assembled it and that you\'re satisfied with the support provided. We appreciate your understanding regarding the wear and tear on your Trike from the rough trails and extensive use. We\'re glad that you\'ve had a positive experience overall, and we hope you continue to enjoy many more miles on your Liberty Trike. Happy riding!',
    },
    {
      name: 'Lee M.',
      date: 'June 5, 2023',
      title: 'Rediscovering the Joy of Riding!',
      score: 5,
      image: '',
      video: '', 
      html5video: '',
      comment: 'I took my new LT to an empty, level school parking lot and practiced starts, with pedals and throttle (slow); stops, using both hand and coaster brake, and reverse. I rode circles and figure eights with throttle at different slow speeds to start. Three wheels vs. two wheels give a different ride and balance and take a little practice. I found I needed to approach inclines and declines straight on, not at an angle. On uneven surfaces, I keep my body straight up. On flat curves, I lean slightly into the turn. I\'m still a novice, still learning, and lovin\' it. I rode 12 miles yesterday on the Wabash Trace, a 62-mile long fine-packed gravel trail here in Iowa. I generally ride at level 4 and about 6 to 9 mph. I had given up on hiking and biking 10 to 15 years ago due to health issues. My LT has put me back out there...but I try to be careful... I\'m 88 years young! Enjoy! Have fun!',
      response: 'Lee, thank you for sharing your incredible journey with your new LT! It\'s inspiring to hear how you\'ve embraced learning and rediscovered the joy of riding. Your tips and insights are valuable to both new and experienced riders. We\'re honored to have played a part in putting you back out there, enjoying the trails and staying active. Keep having fun and enjoying the freedom your LT brings!',
    },
    {
      name: 'Marlene W.',
      date: 'June 4, 2023',
      title: 'Regaining Mobility and Strength!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/351306043_926993968358251_626441679086970737_n.jpg?v=1685903158',
      video: '', 
      html5video: '',
      comment: 'I took my first ride yesterday. It was wonderful. I am disabled with chronic back pain, and I was losing strength in my legs. Steps were becoming a challenge. I plan to regain my legs back with my new ride.',
      response: 'Marlene, we\'re delighted to hear that your first ride on your Liberty Trike was wonderful! It\'s fantastic to know that it is aiding you in regaining mobility and strength. We wish you all the best on your journey to regain your legs. Happy riding!',
    },
    {
      name: 'Carol A. T.',
      date: 'June 4, 2023',
      title: 'LT: My Farm Helper!',
      score: 5,
      image: '',
      video: '', 
      html5video: '',
      comment: 'Well, Ole Yeller (my LT) and I were the ones who herded the 3 naughty calves that found a place where they could crawl under the fence and have fun exploring the wild world beyond the pasture and their mamas back where they belonged. Other chasers on foot ran out of steam long before the calves finally found their way to where they had crawled under and were safely back where they belonged. Sorry, too busy for photo ops!! Love my LT for doing farm chores.',
      response: 'Carol, we\'re thrilled to hear how Ole Yeller, your Liberty Trike, has been such a helpful companion on the farm! It\'s amazing that you were able to successfully herd the naughty calves and ensure they returned safely. We appreciate your love for your LT and its usefulness in farm chores. Keep up the great work!',
    },
    {
      name: 'Diane M.',
      date: 'June 4, 2023',
      title: 'Life-Changing Freedom!',
      score: 5,
      image: '',
      video: '', 
      html5video: '',
      comment: 'I love my Liberty Trike. It has made a huge difference for me. We travel full-time in an RV and the trike fits nicely in the back of our Jeep. I have over 900 miles on it so far. It offers me freedom to get out and go right along with my spouse who is on a bike. The company has great customer support. They are enthusiastic, knowledgeable, and helpful. They want you to get the most enjoyment from your trike. If you’re thinking about getting one, they are so much fun.',
      response: 'Thank you, Diane, for sharing your wonderful experience with your Liberty Trike! We\'re delighted to hear how it has made a huge difference for you and offered you the freedom to ride alongside your spouse. We\'re also thrilled that you\'ve had a positive experience with our customer support. Enjoy the continued fun and adventures on your Liberty Trike!',
    },
    {
      name: 'Chris D.',
      date: 'June 4, 2023',
      title: 'Family Fun with Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/350673514_235131359243365_4736729814591671020_n.jpg?v=1685851854',
      video: '', 
      html5video: '',
      comment: 'My granddaughter and I went on a 5-mile bike ride. She loves going on bike rides with her grandpa and me. We never rode bikes together until after I got my LT. Now we usually pack a lunch and ride to the park and have a little picnic. I\'m so glad I decided to get the LT.',
      response: 'We\'re thrilled to hear about the wonderful family moments your Liberty Trike is helping create! It\'s lovely to hear about your picnics in the park. Continue enjoying your rides with your granddaughter and grandpa!',
    },
    {
      name: 'Jackie Gustafson',
      date: 'June 3, 2023',
      title: 'Joyful Rides with My Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Screenshot_2023-06-03_222838.png?v=1685845910',
      video: '', 
      html5video: '',
      comment: 'I am loving my Liberty trike. My goal right now is 2 miles per day. Hoping to increase my goal next week. I have been stopped multiple times handing out the business cards they sent. I love telling people how much fun they are. At the rate of chatting about the bike and handing out cards I’ll run out soon. I know that one person I gave the card to just bought and rode for the first time today. I’m pretty sure the one I talked to today is ready to buy also. Love sharing info about a great company with a fantastic product.',
      response: 'Your enthusiasm is inspiring, Jackie! We\'re thrilled to see how much you\'re enjoying your Liberty Trike and sharing the joy with others. Thank you for being such an amazing ambassador for our company and products. Keep having fun and reaching your goals!',
    },
    {
      name: 'JayandPam M.',
      date: 'June 2, 2023',
      title: 'Introducing Iris, My Joy!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Screenshot_2023-06-03_155706.png?v=1685822272',
      video: '', 
      html5video: '',
      comment: 'Introducing Iris❤️ she\'s a gem! What a joy she brings to me.❤️❤️',
      response: 'We\'re delighted to hear about the joy that Iris, your Liberty Trike, is bringing you, JayandPam! We hope you continue to have wonderful experiences with your rides. Enjoy!',
    },
    {
      name: 'Victoria S.',
      date: 'June 3, 2023',
      title: 'Excitement of a First Ride!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Screenshot_2023-06-03_120301.png?v=1685808238',
      video: '', 
      html5video: '',
      comment: 'I was so excited after riding the first time yesterday that I pulled her inside my house to look at her last night. Got up this morning and had to look at her first! Brings a smile. It is like a kid at Christmas getting their first bike. Perfect size and so darn adorable. More names needed for the yellow color please. Sunny was mentioned already. Bike bell arrived same day.',
      response: 'We\'re delighted to hear about your excitement, Victoria! It\'s great to see the joy that your Liberty Trike is bringing you. We appreciate your suggestion for more names for the yellow color. Enjoy your rides and that new bike bell!',
    },
    {
      name: 'Marian S.',
      date: 'June 2, 2023',
      title: 'The mags look good and beats the hassle of putting on new tires and tubes.',
      score: 4.5,
      image: '',
      video: '', 
      html5video: 'https://cdn.shopify.com/videos/c/o/v/0ea47145ebd64ac886c09f0db968d8d7.mp4',
      comment: 'After 1500 miles and beginning the 3rd year, definitely needed new tires. The mags look good and beats the hassle of putting on new tires and tubes. Needed a7/8 wrench. The video was good. On the right rear tire I could not turn the hex nut. Tried 2 different sets of allen wrenches but didn’t fit the opening. By the way the bike stand was perfect. Luckily the 3 prong attachment came right off. Couldn’t tighten the hex nut. But was able to align the key in its position. Also got the thumb screws for the basket. I am happy with my purchase.',
      response: 'Thank you for sharing your Liberty Trike experience! It\'s fantastic that you\'ve clocked 1500 miles and maintained your trike well. Your feedback on the video, bike stand, and the addition of thumb screws for the basket is invaluable to us. Don\'t hesitate to reach out if you need further assistance. Safe riding on your Liberty Trike!',
    },  
    
    {
      name: 'Donna N.',
      date: 'June 1, 2023',
      title: 'Taken over by my Down Syndrome son!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/dsson.jpg?v=1685700192',
      video: '', 
      html5video: '',
      comment: 'Well I love my liberty trike but it’s been taking over by my Down Syndrome son!',
      response: 'It\'s absolutely heartwarming to see your son enjoying the Liberty Trike! It looks like he has found a new favorite activity. There\'s something incredibly special about seeing the joy on a child\'s face when they discover something they love. The Trike seems to have found its rightful owner! 😊 Thanks for sharing this beautiful moment with us. 💛🚲💙',
    },  
    
    {
      name: 'Roger s.',
      date: 'May 31, 2023',
      title: 'MAG Wheels are AWESOME',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/350242609_639847187667546_8749234039885498451_n.jpg?v=1685537615',
      video: '', 
      html5video: '',
      comment: '5-31-23 Fruitport, MI. got my new MAG wheels and mounted them this weekend on my 3 yr old 1600 mile trike and it looks good, and  it  rides nice and smooth and quiet, even on grassy fields. It feels like they support my 290lbs 75 yrs old body better. Pic take at granddaughter\'s Softball game- the trike gives me the ability to go where I need to go not where my body limits me.',
      response: 'Roger, we are thrilled your Liberty has been upgraded with the new MAG wheels! We knew these would be a hit! Thank you for being a part of the LT community—enjoy the smooth ride!',
    },  
    
    {
      name: 'Mary W.',
      date: 'May 31, 2023',
      title: 'Trike Travels Made Easy!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Screenshot_2023-06-03_080111.png?v=1685793715',
      video: '', 
      html5video: '',
      comment: 'Today I paid $4 to ride the access bus cross city. It was door to door with big smiles. I don\'t have to worry anymore about taking apart my trike and loading it into my Mazda! We had a lovely 3 mile ride along the river and then lunch with a view. Yay Iris! Yay me!',
      response: 'We\'re thrilled to hear about your wonderful experience, Mary! It\'s great that the Liberty Trike has brought so much convenience and joy to your travels. Continue to enjoy your rides and the beautiful views!',
    },
    
    {
      name: 'Nancy W.',
      date: 'May 26, 2023',
      title: 'Another Awesome 15 Mile Trike Ride on "MISS LIBERTY',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Nancywlt.jpg?v=1685110100',
      video: '', 
      html5video: '',
      comment: 'Another awesome 15 mile bike ride on "MISS LIBERTY" at our favorite trail close to home. Blackwater Heritage Trail in Milton,FL. REACHED 100 MILE. Love my trike. Love being out in the fresh air and sunshine 🌞 And the exercise and nature!',
      response: 'It sounds like you\'re having a blast with your "MISS LIBERTY" trike! Congratulations on hitting the 100-mile mark—that\'s a significant milestone and a testament to your dedication. The Blackwater Heritage Trail sounds lovely. It\'s such a wonderful way to appreciate the beauty of nature while also getting in some good exercise. May you have many more miles of joyous and sunny rides. Keep enjoying and sharing your journeys with us! 🚲🌞💪',
    }, 
    
    {
      name: 'Bethany B.',
      date: 'May 26, 2023',
      title: 'I hit a milestone in just over a year on Gaspee!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/500mileslt.jpg?v=1685110104',
      video: '', 
      html5video: '',
      comment: 'I hit a milestone in just over a year on Gaspee! I think this is love! I was so nervous to buy it but needed something to compensate for not driving. It’s really useful and fun.',
      response: 'Congratulations on hitting your milestone with Gaspee! It\'s so fantastic to hear how much you\'re enjoying your trike and how it has contributed positively to your life. The fact that it\'s not only useful but also fun makes it a double win! Keep enjoying your rides and sharing your experiences with us. Here\'s to many more milestones ahead! 🎉🚲',
    }, 
    
    {
      name: 'Rita R.',
      date: 'May 25, 2023',
      title: 'Pup approved too!',
      score: 5,
      image: '',
      video: '', 
      html5video: 'https://cdn.shopify.com/videos/c/o/v/130dca4ee87343c8bf8acb690ae7a2a9.mp4',
      comment: 'Miss Dixie and I had a nice four mile ride! Love my little Liberty Trike!!',
      response: 'We love that you love it, Rita! Thank you for joining the Liberty community—we are so happy to have you!',
    }, 
    
    {
      name: 'Roger S.',
      date: 'May 25, 2023',
      title: 'Spring Band Concert Made Possible!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/RogerS-LibertyTrike-Concert.jpg?v=1685034254',
      video: '', 
      html5video: '',
      comment: 'With my granddaughters concert 100 miles away and the auditorium 170 yards from the parking lot, My daughter got clearance from the school to let me use my trike to get from the lot to the auditorium, no issues at and and without the trike walking that distance was out, and my granddaughters were happy to see me and my wife there to share their concert and awards. Once inside the auditorium, I tucked the trike under the back seats (out of the way and out of sight) and walked 20 ft to the nice aud chairs.',
      response: 'We\'re truly touched by your story. It\'s inspiring to see how your Liberty Trike played a crucial part in connecting you with your family for such a special occasion. Your granddaughters concert must have been a wonderful event, made all the more memorable by your presence. It\'s also encouraging to see the support you received from the school authorities. Their understanding showcases the strides we re making towards greater accessibility "for" everyone. We appreciate you sharing your positive experience. Stories like these motivate us to keep working on providing freedom and mobility through our trikes. We hope there are many more such family events in your future! Keep riding!',
    }, 
    
    {
      name: 'Michelle T.',
      date: 'May 23, 2023',
      title: 'Double the Fun!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/MichelleT-LibertyTrike-Mountains.jpg?v=1685034254',
      video: '', 
      html5video: 'https://cdn.shopify.com/videos/c/o/v/6a21bb46d4cd4e739524b67de10adae3.mp4',
      comment: 'My best friend and I rode the bikes out today on a beautiful sunny Southern California day. The mountains are alive with flowers by my house. Fun day out on Seabreeze and Skye. I have only had the bikes one week now!',
      response: 'Triking is always a blast with a partner! We hope you enjoy Seabreeze and Skye!'
    }, 
    
    {
      name: 'Carol L.',
      date: 'May 22, 2023',
      title: 'Life-Changer',
      score: 5,
      image: '',
      video: '', 
      html5video: 'https://cdn.shopify.com/videos/c/o/v/8b2de2a588654fa7924cb2f09a0463c9.mp4',
      comment: 'Riding the LT next to my friend and my Cavalier Spaniel. My LT lets me go so much further than I could walk!!',
      response: 'Awesome, Carol! Thank you for sharing - we love the pup too!'
    }, 
    
    {
      name: 'Jackie G.',
      date: 'May 22, 2023',
      title: 'Liberty is the Way To Go!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Screenshot_2023-05-23_at_11.03.24_AM.png?v=1684854222',
      video: '', 
      html5video: '',
      comment: 'I LOVE my Liberty Trike. I have only had it for about 6 weeks. Between rain showers and traveling I have only put on 15 miles. Today I went for an hour long ride while we are camping. Some of it was on paved roads and some on trails. It rode on both types of road marvelously. Thank you Liberty Trike for giving me the ability to go on a hike without feet or leg pain.',
      response: 'Jackie, thank you so much for this wonderful insight and for being a Liberty Trike customer. Have fun with your Liberty as the weather begins to dry up - we know you will!'
    }, 
    
    {
      name: 'Darla B.',
      date: 'May 22, 2023',
      title: 'Just What I Needed',
      score: 4,
      image: '',
      video: '', 
      html5video: 'https://cdn.shopify.com/videos/c/o/v/53beece3ff8b417ea9cde1a962f366d4.mp4',
      comment: 'I finally got my Trike on the bike path! My son walked with me till I got the jest of things! This bike path links all the parks in Oregon, OH. Now I can ride not watch everyone go by from my porch. So much fun! I cannot wait to ride again!!',
      response: 'Thank you for sharing, Darla! We are so happy to have you in the Liberty Trike community.'
    },  
    
    {
      name: 'Cheryl H.',
      date: 'May 20, 2023',
      title: 'Finally, Freedom!',
      score: 5,
      image: '',
      video: '', 
      html5video: 'https://cdn.shopify.com/videos/c/o/v/b9214f8cc6eb4153b28be2a7513de55c.mp4',
      comment: 'I rode through Blanchard Caverns in Arkansas, with a little help on the steep, wet inclines. The power tire lost traction a couple of times but my manly man pushed from behind up the slopes and held my seat going down (awkward choice of words, I know). If not for my LT I would never have been able to see this! Likewise, I was able to make the trek to Blanchard Springs with my sweetie and our dog, Chief. I even rode it into a casino on our way home. It performed great in the campgrounds on gravel or asphalt roads as well. I LOVE MY TRIKE!',
      response: 'We are so happy that your Liberty has given you the freedom to get out and enjoy the outdoors! We look forward ot many more adventures!'
    },    
    {
      name: 'Kay G.',
      date: 'May 15, 2023',
      title: 'Much More Than an eTrike',
      score: 5,
      image: '',
      video: '',
      comment: 'I received my trike about 3 weeks ago. Love this trike, it is so easy to ride. I have been struggling with depression for a while. Meds and therapy weren\’t helping. I can ride this trike and I feel happy I have something to look forward to. I have an ebike I I\’m 69 yrs old and obviously I have balancing problems I had several wrecks on it. That made the depression worse but Liberty Trike saved the day I really do love this bike! It\’s the best thing I\’ve come across. Thank you Liberty Trike! Kay from GA.',
      response: 'Hey Kay! To know that your Liberty can help physically, but most importantly mentally, is simply AMAZING. Thank you for sharing and we hope you see your updates in the FB Group!' 
    },
    
    {
      name: 'Bernie P.',
      date: 'May 15, 2023',
      title: 'Happy with Liberty Trike',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/348587485_206633538392482_5503957447520095313_n.jpg?v=1684865414',
      video: '',
      comment: 'I live in a retirement community where your trike is ideal to get around on, I dont drive so it gets me to the store, dining room, and nearby restaurants. I purchased your trike a year ago, I just purchased a Lectric Trike because of the distance of charge (60 miles). I have put 60 miles on the Lectric Trike and have tested the different features of the trikes. I don\'t like their power assist, yours is better. Their basket is not a basket, just tubing spaced too far apart. The Liberty Trike has more power on inclines and I like the coaster brake feature. The Lectric Trike does not have reverse which I thought I would not miss, I was wrong, it is a must. What your trike needs is lights and a cup holder. After evaluating the two trikes, the Liberty Trike is my top choice. Love it.',
      response: 'Thanks for the firsthand insights Bernie, we are grateful to have you as part of the Liberty Trike community' 
    },
    
    {
      name: 'Linda H.',
      date: 'April 20, 2023',
      title: 'Liberty Trike is a Must-Have',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/104329686_592993638012609_1907809062618075347_n.jpg?v=1684867167',
      video: '', 
      html5video: '',
      comment: 'We got to ride a section of the 84 mile long Weiser River Trail for Father\'s day weekend. We saw a fox, deer, baby snake and grandson Jon caught a lizard. I love that my LT lets me keep on riding with the family!',
      response: 'Thank you for sharing, Darla! We are so happy to have you in the Liberty Trike community.'
    }, 
    
    {
      name: 'Kathy J.',
      date: 'April 17, 2023',
      title: 'Mobility at It\'s Finest',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/128175099_1268580646852682_5738530406504600936_n.jpg?v=1681759243',
      video: '',
      comment: 'I love my Liberty Trike! I live on the beach, so it\’s great for me. I\’m 73 years old, if it wasn\’t for the electric trike I’d be sitting on the bench all day. This way I get to ride up and down the beach. Also, it comes apart in 2 pieces. Best thing I ever purchased, especially after several surgeries. You can peddle if you want it not just sit back and enjoy!! Liberty Trike the best!! ❤️',
      response: 'Wow, we are so happy to hear that you love your Liberty Trike! It sounds like the perfect fit for your lifestyle and location. We love that it has allowed you to enjoy the beach and stay active at 73 years young. And the fact that it comes apart in two pieces is just the cherry on top! Thank you for choosing Liberty Trike and for sharing your positive experience with us. Keep on triking! ❤️' 
    },
    
    {
      name: 'Johanna J.',
      date: 'April 17, 2023',
      title: 'Coolest eTrike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/41937282_10217384946754726_5758859228999581696_n.jpg?v=1681767478',
      video: '',
      comment: 'I kid my husband that it\’s a guy magnetic! I get many “cool bike” comments all the time, the majority from guys! Little boys, teens, surfer dudes, dads, and men my own age (70). I did switch the seat to one without a backrest - I don\’t use it and admittedly thought it made the trike look more like a mobility device. Don’t let the idea of it hold you back, you\’ll look cool riding it, I promise!',
      response: 'Thank you for your comment, and you\'re absolutely right! The Liberty Trike was designed not only to provide mobility assistance but also to look sleek and cool, without necessarily appearing as a traditional mobility device. It\'s great to see that the design has been well-received and is fulfilling its intended purpose. Thanks, Johanna!' 
    },
    
    {
      name: 'Bobbi R.',
      date: 'April 16, 2023',
      title: 'Sunnie!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/314994010_10228900122751852_68718026122446797_n.jpg?v=1681759732',
      video: '',
      comment: 'Liberty Trikes are an incredible workout if u want it to be! All people ever say is "Is that electric?" Or "Where can I get 1?" I\'m loving "Sunnie", my Liberty Trike! 🥰',
      response: 'Thanks, Bobbi! We are THRILLED you\'re loving Sunnie! We can\'t wait to see more of your adventures in the LT group.<br><br><br>Check out our Liberty Trike Facebook Group here: https://www.facebook.com/groups/libertytrike' 
    },
    
    {
      name: 'Norma G.',
      date: 'April 16, 2023',
      title: 'We Love Our LT!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/326267304_1303532806879830_8650633273553807635_n_951fcd3e-7db4-4551-89f5-5012225b45f7.jpg?v=1681758818',
      video: '',
      comment: 'It’s an amazing trike! Both my husband and I have one and ride together almost every day! We both love them! And ever so many people ask us questions about them! We are proud to ride them! It\’s so good for our mental and physical health!!!',
      response: 'Norma, we are beyonf excited to have you and your husabnd and Liberty Trikers! We know the two of you will continue to have a blast together. Thank you for this amazing feedback!' 
    },
    
    {
      name: 'Cindy H.',
      date: 'April 12, 2023',
      title: 'Neighbors Riding Together',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/340499989_1679053675888862_2727046089204125538_n.jpg?v=1681351093',
      video: '',
      comment: 'Looking forward to riding more now that the rain has stopped!! I talked my neighbor, Barb, into buying a Liberty Trike and we both decided on yellow💛💛 Meet Sunshine💛 and Buttercup 💛 Our neighborhood is a great place to practice riding and Barb\’s dog, Emme, loves it, too!! 💗.',
      response: 'Now this is COOL! It\'s always a blast when there\'s a riding buddy! Cindy and Barb, ENJOY!' 
    },
    
    {
      name: 'Deanna R.',
      date: 'April 12, 2023',
      title: 'My Must-Have!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/340612149_783487236451435_2697746371508637458_n.jpg?v=1681350512',
      video: '',
      comment: 'Thank goodness for this trike! Went on an 11 mile ride with my grandson. Never could have done it without the assist. Oh and it\'s good for carrying a skateboard to the skate park too.',
      response: 'Welcome to Liberty Trike, Deanna! We are thrilled that it has helped you in more than one way. We cannot wait to see more of your experiences in the Liberty Trike Group!' 
    },
    
    {
      name: 'Holly R.',
      date: 'April 10, 2023',
      title: 'We Love Our LT!',
      score: 5,
      image: '',
      video: '',
      html5video: 'https://cdn.shopify.com/videos/c/o/v/b0445b9767134fa3975e811edcb12c71.mp4',
      comment: 'I have had my Liberty Trike, Joy (that’s her name) for 45 days and today we hit the 200 miles mark. The co-pilot is Bella. She rides in the front basket. My Cavalier rides in the back basket and we just got out pet trailer for my biggest dog, Shelby. We are having the best time on the trike!!! #LoveMyLibertyTrike! Also, I was having an issue with error 30 on a holiday and posted a question. I was shocked and surprised when the owner of Liberty Trike responded with a video I should watch. I watched and was able to get everything working again. And today I received a follow up call from the service dept. Excellent customer service.',
      response: 'Holly, it is our honor to serve you, Bella, and Shelby! We hope you guys have endless amount of fun on Joy! Thank you for this AMAZING feedback!!!' 
    },
    
    {
      name: 'Julie A.',
      date: 'April 6, 2023',
      title: 'What a Company!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/70621963_10215321610373100_48679743448416256_n.jpg?v=1681160027',
      video: '',
      comment: 'Liberty Trike strives hard to make our trikes with the best materials and quality workmanship available. Even during pandemic times, they made what they could and waited for parts to arrive from overseas to ship trikes out to anxiously waiting customers. Liberty Trike has the best customer service in the whole U.S. Their phones are answered by people in their Croydon, PA office. Their technicians are extremely helpful in troubleshooting issues with customers over the phone and when their is an issue requiring a part to be shipped to the customer, they ship it with a usual 2-day ship time. I have never met people from a company, that cares as much about the customers as they do the trikes and bikes that they make. I wish there was an company award I could give or vote to give for this company. Hands down, Liberty Trike and Electric Bike Technologies would win!!',
      response: 'Wow! This feedback right here truly assured us that we must be doing something right. Julie, thank you for everything and WE are the grateful ones to have such wonderful Liberty Trikers such as yourself...so thank you!' 
    },
    
    {
      name: 'Linda G.',
      date: 'April 6, 2023',
      title: 'SO Much Liberty!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/340154939_947149616457021_3059259789337381025_n.jpg?v=1681077093',
      video: '',
      comment: 'She\’s not just pretty and fun, she’s also functional. Rode her up and down the hill carrying plants and dirt. I love my LIBERTY!',
      response: 'Thank you Linda! This is amazing feedback. Wishing you many woderful memories with your Liberty!' 
    },
    
    {
      name: 'Carol R.',
      date: 'April 5, 2023',
      title: 'Life-Changing!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/335443070_231404099295443_4961146490925081632_n.jpg?v=1681351605',
      video: '',
      comment: 'Loving my trike! What a game changer! I love to explore but with my knees I just can\’t go long distances. Today at Fort Worden I zipped all over the place. It really is life changing ❤️',
      response: 'Carol, we\'re glad that our trike has helped you to maintain your independence and mobility. We designed the Liberty Trike with the goal of giving people the freedom to move around and enjoy the outdoors, and we are so glad that we have been able to achieve that goal for you! Happy Triking!' 
    },
    
    {
      name: 'Nancy G.',
      date: 'April 4, 2023',
      title: 'Outdoor Fun',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/339018865_1250857469181029_5114116466326280364_n.jpg?v=1680793551',
      video: '',
      comment: 'Love my new Liberty Trike! Our first time riding on trails since we moved to FL almost 6 years ago. Rode part of a 32 mile Rails to Trails in Old Town, FL. Nature Coast Trail. Beautiful paved and level trail. Plan on riding more of it this week. Rode 16 mile today. Only 8 of 32 because had to ride back. Battery did well! Had 19.9 mile and 2 bars left. Peddled most of the time...4 and 5  assist which I love...don\'t get as tired. Almost 81 so very helpful...5 stars 🌟',
      response: 'Thank you, Nancy, for taking the time to share your experience with us at Liberty Trike. Your positive review means a lot to us and we\'re glad that you\'re enjoying the freedom and mobility that our trike provides. wIshing you many more adventures to come.' 
    },
    
    {
      name: 'Cheryl D.',
      date: 'April 2, 2023',
      title: 'The Best!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/257545183_4905284262815442_8856935192719282007_n.jpg?v=1680557026',
      video: '',
      comment: 'I Love my trike! I am doing the 100 mile cancer challenge that started April 1st. It has helped me so much in rehabbing my knees after bilateral knee surgery. My trike is over a year old and I get about 12 miles at 4. I do pedal all the way. It takes me an hour and half to do 10 miles. Mostly I bike on light sandy roads and it is flat. I hope some of you are considering to do a challenge on yours! Enjoy this beautiful weather!',
      response: 'Cheryl, this is amazing! Thank you so much for sharing and we wish you the best of luck on your 100-mile challenege...you got this!' 
    },
    
    {
      name: 'Kramer H.',
      date: 'March 31, 2023',
      title: 'Love My LT',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/338527351_571865388374619_8200649785498564206_n.jpg?v=1680379142',
      video: '',
      comment: 'A friend took this photo that really captures the joy and function my LT brings to my life. Ida Mae is my photographers assistant and the LT is my mobile tripod (the day was cold, so Ida Mae is under a jacket 😉).',
      response: 'We love hearing that! Thank you so much for sharing and we hope your Liberty keeps bringing you infinite joy!' 
    },
    
    {
      name: 'Dawn K.',
      date: 'March 24, 2023',
      title: 'Cannot Live Without my LT',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Screenshot_2023-04-01_at_4.24.37_PM.png?v=1680380783',
      video: '',
      comment: 'My trike gets a lot of attention. For example even when at Home Depot, just riding thru at least 3 or 4 people will stop me and ask about it. I ♥️ my trike!',
      response: 'Thank you, Dawn! We know you have been a LT fan for some time and we love having you as a customer—we appreciate you!' 
    },
    
    {
      name: 'Nancy C.',
      date: 'March 17, 2023',
      title: 'So Much Fun',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/329952640_1227056754907561_3358810250967409238_n.jpg?v=1679102868',
      video: '',
      comment: 'Just got mine today and having a hard time stop riding it! I love it!',
      response: 'Always the feedback we want to hear! Thank you, Nancy! We know you will have countless adventures with your Liberty.' 
    },
    
    {
      name: 'Henry K.',
      date: 'March 10, 2023',
      title: 'Best...Everything!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/148114937_10219298499632860_5004547218470299693_n.jpg?v=1678570266',
      video: '',
      comment: 'I am 76 and have had 5 back operations, total knee replacement on both knees and have arthritis too. Have had mine for a around 3 years and love it. I pedal with power on too. Really lets me go places I could not before.',
      response: 'Thank you for your review Henry! We are so glad to hear that you are enjoying your trike!' 
    },
    
    {
      name: 'Donna F.',
      date: 'March 10, 2023',
      title: 'Rehab at its Finest',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/242136646_4037850636327136_5005190251624694830_n.jpg?v=1678802093',
      video: '',
      comment: 'My Liberty Trike was a part of my recovery plan. It helped me when I broke my pelvis. I could barely walk - and only sideways! Using the trike as part of my physical therapy was terrific. The therapists were so impressed when I rolled into my sessions, and asked me to park it inside. Other patients could see that, despite my problem walking, I could ride the trike. Handed out a lot of Liberty Trike cards!',
      response: 'Thanks, Donna! We are incredibly humbled (and so impressed) with your recovery! Happy that Liberty was able to assist with your rehab journey.' 
    },
    
    {
      name: 'Terri L.',
      date: 'March 10, 2023',
      title: 'Nothing Beats My Liberty',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/80121155_10215981142226162_7232131001206439936_n.jpg?v=1678568984',
      video: '',
      comment: 'I bought my refurbished Liberty Trike over four years ago, and have never regretted the purchase. My trike arrived in Florida only a few days after ordering in perfect, new condition. I have never had an issue with my trike. People often stop me to ask where I got it. I am 5ft. 10in. and love it still. Liberty Trike customer service is phenomenal. They do not use a call center, and give prompt service. Liberty Trike has YouTube videos too. Their FB group is fun, and you can learn a lot there...or find a riding buddy in your area.',
      response: 'Thank you, Terri! We are so glad you love your Liberty and appreciate you as a customer. Enjoy!<br><br><br>Check out our Liberty Trike Facebook Group here: https://www.facebook.com/groups/libertytrike' 
    },
    
    {
      name: 'Mary P.',
      date: 'March 8, 2023',
      title: 'Love My Trike',
      score: 5,
      image: '',
      video: '',
      comment: 'I am going into 5th summer (live in Canada so can only ride in summer) with my Liberty Trike. I was nervous because I could not ride a 2 wheeler due to balance. Debated a long time and that is my only regret. It takes a little getting used to but I have never felt unsafe. Easy to adjust speed and you can pedal or not. I had one incident that was totally my fault. Learning how the trike works and taking your time to be comfortable is all you need to worry about. I am able to put mine in the trunk of Honda Civic Coupe. I have taken it a lot of places. My criteria was safe, portable, low maintenance, and fun. This trike has delivered on all the above.',
      response: 'Thank you for sharing your experience, Mary! We hope you continue to have many wonderful adventures and memories in the years to come with your Liberty!'
    },
    
    {
      name: 'Wendy F.',
      date: 'March 6, 2023',
      title: 'Great Company, Amazing Trike',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/314501626_2699718036831859_5007145905820356501_n.jpg?v=1678592133',
      video: '',
      comment: 'It\'s one thing to purchase an electric trike (there are a number of them out there). It\'s quite another to know that the LT team cares about the products they sell, encourages us to build a robust LT Rider community, and consistently offers a superior product and customer service. Thank you, Jason Kraft. LT has no equal.',
      response: 'Wendy, this is amazing, thank you! Thankful to have you as a Liberty Trike customer and we are thrilled to have you a part of this community.'
    },
    
    {
      name: 'Garland C.',
      date: 'March 5, 2023',
      title: 'Thank You!!!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/325291805_709241383998050_7464612082473135411_n.jpg?v=1678800505',
      video: '',
      comment: 'Thank you Liberty Trike for making a great product, wonderful support staff, and service!',
      response: 'Garland, we thank YOU for joining the Liberty Trike community. We are grateful for your support!'
    },
    
    {
      name: 'Peggy O.',
      date: 'March 4, 2023',
      title: 'Best Purchase',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/329001931_1364753244275424_1285618584278166366_n.jpg?v=1677983564',
      video: '',
      comment: 'Best purchase I\’ve made in many years!! Loved spending the day riding with my daughter and grandson!! Looking forward to many more.',
      response: 'Peggy, your review of the Liberty Trike has made our day! Thank you for sharing your experience with your family, your kind words, and for being a part of our community.'
    },
    
    {
      name: 'Audrey M.',
      date: 'March 3, 2023',
      title: 'Love my Liberty Trike',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/329952640_1227056754907561_3358810250967409238_n.jpg?v=1679102868',
      video: '',
      comment: 'Big Bend, Tx. Park trails are somewhat accessible. The trike is performing beautifuly!',
      response: 'Thank you for joining the Liberty Trike world! We cannot wait to see more of your Liberty adventures in the group!' 
    },
    
    {
      name: 'Patty L.',
      date: 'March 1, 2023',
      title: 'New Found Fun',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/334020234_766856721667638_5428591792223612057_n.jpg?v=1677985199',
      video: '',
      comment: 'Riding along the beach on Galveston Island! I LOVE my trike!!!',
      response: 'Thanks, Patty! And what an awesome ride along the beach that is. We hope you have many more adventurous rides with your Liberty.'
    },
    
    {
      name: 'Kay A.',
      date: 'February 24, 2023',
      title: 'Fun with Liberty!',
      score: 5,
      image: '',
      video: '',
      html5video: 'https://cdn.shopify.com/videos/c/o/v/4ce3449f62d54bf9b43e8d90acd556da.mp4',
      comment: 'We had a great Mardi Gras party this week and I got our people up and out of their chairs for a Mardi Gras line dance. I love my Liberty Trike and it keeps me having fun with my disability!',
      response: 'Now this is AWESOME! Thanks for sharing, Kay! We are thrilled that your Liberty Trike provides you the mobility to participate in fun events like this! Keep rockin that trike!'
    },
    
    {
      name: 'Joel and Deborah A.',
      date: 'January 27, 2023',
      title: 'New Liberty Trike Owners',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/344832989_6377826698905516_7315431329702443820_n.jpg?v=1684776794',
      video: '',
      comment: 'We did a bunch of research and settled on the Liberty Trike. I made a number of phone calls with pre-sales questions. The phone was always answered and my questions were always answered in a friendly manner. I called to place my order on Monday. Aaron did a great job of answering even more questions and even got me a discount for ordering two trikes. Only three days later, on Thursday, the trikes arrived! They were easy to put together by watching the video. I needed to call the help line several times to ask questions and again, the phone was always answered promptly by friendly people. In fact, I ended up speaking with Aaron again a few times and he was once again incredibly helpful. I cannot emphasize enough just how impressed I am with not only the product but with the people, especially Aaron. I highly recommend this company!',
      response: 'Joel, we appreciate the kind words and support! Thank you for your review. We value your feedback and are definitely committed to providing the best possible product and service to our customers. Wishing you and Deborah endless adventures on your LTs!'
    },
    
    {
      name: 'Norma G.',
      date: 'January 26, 2023',
      title: 'New Liberty Trike Owners',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/326267304_1303532806879830_8650633273553807635_n.jpg?v=1677858553',
      video: '',
      comment: 'And here I go on my maiden ride! I love it! Stylin in my red helmet!',
      response: 'We are so happy you are enjoying your Liberty, Norma! We also love the safety precautions youare taking with your helmet—smart choice!'
    },
    
    {
      name: 'Cathy M.',
      date: 'January 6, 2023',
      title: 'Awesome Trikes',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Cathys-Husband-Rides.jpg?v=1677617259',
      video: '',
      comment: 'We ended 2022 with my Christmas gift of a Liberty Trike in red. My husband, Tim, loved it so much he was considering getting one for himself. So we are starting 2023 with another trip to Croydan, PA (today) to visit our friends, Linda, Aaron, Tom and Jason (Bob was off today). We left with Tim\'s new Liberty Trike in blue and a few accessories. We do know that both trikes will fit in the back of my Buick Envision SUV. Tim and I are looking forward to riding together.',
      response: 'Cathy, it was an absolute pleasure to serve you and Tim! There is nothing better than a Liberty buddy so we are sure you two will have endless memories and adventures together on your trikes. Have fun!'
    },  
    
    {   
      name: 'Jody B.',
      date: 'January 1, 2023',
      title: 'Bat-Bee!',
      score: 5,
      image: '',
      video: '',
      html5video: 'https://cdn.shopify.com/videos/c/o/v/e76b82e6b54a4695b2836e2a1294d534.mp4',    
      comment: 'Battery charging on my new LT but have been practicing pedaling it around the house! I\’M IN LOVE 😍',
      response: 'The fact that you are in love just pedaling around the house makes us very excited for your outdoor adventures! Have a blast, Jody, and be sure to share your experiences in the LT Facebook Group!'
    },
    
    {
      name: 'Rhonda D.',
      date: 'December 12, 2022',
      title: 'Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/309594993_5523661511057734_3027332192555883332_n.jpg?v=1671477313',
      video: '',
      comment: 'A friend of mine mentioned adult trikes and that idea just captured me. So I searched online and found the Liberty. SO many reasons I went with Liberty: price, features, customer service, electric, cute factor, the community here online, colors… these guys did their research when they developed this gorgeous and functional trike and it’s one tough little thing! I get about 12-plus miles on a charge running at 4-5 around mostly flat neighborhood. The time I spend on my trike is like a vacation!',
      response: 'Rhonda, we are so grateful for your review of the Liberty Trike and for your trust in our product and service! Our favorite part might be the fact that riding your Liberty feels like a vacation. We are so happy it brings you so much joy! Thank you for your support and for being a part of our family.'
    },
    
    {
      name: 'Judi S.',
      date: 'December 2, 2022',
      title: 'Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/317090121_149195047860376_2858534490889878969_n.jpg?v=1678045949',
      video: '',
      comment: 'Just got back from my first practice ride and OMG!!! It was amazing! I was brave enough to ride around my entire 599-home subdivision (lots of streets) and did most of the ride on the streets because the sidewalks are pretty bumpy. I had it up to maximum speed for a while and loved the feel of the cool wind (it\'s a comfortable 74° here in Valrico Florida today). I was even able to get some pedaling in for a bit of much-needed exercise. I doubt I will ever regret my purchase of my beautiful, amazing Black Beauty!!',
      response: 'Thank you, Judi! Black Beauty is lucky to have you as an owner, we know you two will have a blast and many adventures! Thank you for this amazing feedback.'
    },
    
    {
      name: 'Jim G.',
      date: 'November 10, 2022',
      title: 'Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Jim.jpg?v=1670443283',
      video: '',
      comment: 'Best bike I have ever had. Easy to set up. Easy to ride. Front basket was really easy to set up. Powerful motor. Opened up my life. Cannot recommend this more. Buy it and try. You will love it. Well made in the USA. I got orange and love the color (SF Giants).'
    },
    
    {
      name: 'Margo P.',
      date: 'November 3, 2022',
      title: 'Autumn, my Liberty Trike',
      score: 5,
      image: '',
      video: '',
      comment: 'LOVE my Liberty Trike. I love everything about it and love the reverse. It is so easy to pedal, with no power on at all. Give my dogs a ride also on the trike. It is wonderful. Her name is Autumn, and she is orange in color. Did I say I am 75 and enjoying my rides on Autumn? We ride all the time and have had NO problems. She even makes it up our steep driveway and if you live in the hills in W.V., you know just what I mean. She will be with me as long as I live.'
    },
    
    {
      name: 'Mahvash Z.',
      date: 'October 31, 2022',
      title: 'Love It!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/273822218_10228600846353008_495006320494738299_n.jpg?v=1670257084',
      video: '',
      comment: 'Best gift for myself on valentines of 2022, I love it and the people who works there very helpful.<br>Thanks, Mimi'
    },
    
    {
      name: 'Colleen W.',
      date: 'October 1, 2022',
      title: 'Freedom, here I come!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/310133663_3359834957580992_2102882182282142190_n.jpg?v=1677955836',
      video: '',
      comment: 'I got my Liberty trike! I\'ve had for over a week. Been riding some in house. I adventured out today. Ive got my fireworks top celebrating my trike and freedom!  It was sooo much fun! My first car was a yellow Chevelle with a black vinyl top. When I opened that box, what a flood of memories. I ❤️😍 my Liberty trike!!!!!'
    },
    
    {
      name: 'Mia M.',
      date: 'September 30, 2022',
      title: 'Simply Amazing',
      score: 5,
      image: '',
      video: '',
      html5video: 'https://cdn.shopify.com/videos/c/o/v/3e60c971190f493d9c9302aef665ce62.mp4',
      comment: 'I ♥️ my new Liberty Trike and am so happy it found me. It was worth every, single, penny. I rode around the entire lake today with my son, yelling back at him (yes back, because at one point I was at 13.5 mph) “I\’m LIVING!!!” This, from a girl once critically riddled with cancer. Without these wheels I would never have known the beauty and exhilaration of these new nature paths—and the path of life still ahead.'
    }, 
    
    {
      name: 'Stacy G.',
      date: 'September 24, 2022',
      title: 'So Much Freedom',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Screen_Shot_2022-10-02_at_7.30.04_PM_1.png?v=1670256466',
      video: '',
      comment: 'My husband and I are avid campers, staying in Tennessee and the surrounding states multiple times a month. I take my Liberty trike to every campground I go to and use it extensively. I have Ehlers Danlos Syndrome and POTS; without my trike, I would be trapped at home. I can confidently say I have sold at least 20 trikes this year! Whenever we camp, I\'m constantly stopped with questions about the trike. I am eager to give a complete testimonial of how much I love my trike as a disabled person, the specific features of the trike, as well as where they can go to purchase it.'
    }, 
    
    {
      name: 'Don G.',
      date: 'September 22, 2022',
      title: 'Customer Service Rocks!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/313412373_10229324094151257_2815384295989848238_n.jpg?v=1669997751',
      video: '',
      comment: 'The folks at Liberty Trike deserve more than a compliment and thanks for the way they pack the box and protect all the parts of the LT. They have created an amazing product accompanied by packaging that is a work of art. My new LT arrived in perfect shape. The hardest part of the assembly was removing all the protective plastic and zip ties. I am very happy with my new LT.'
    },
    
    {
      name: 'Mrs. Manners',
      date: 'September 10, 2022',
      title: 'Freedom and Fun',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/1599943955070_1.jpg?v=1670256918',
      video: '',
      comment: 'My husband loves his Liberty Trike, and so do I. We now get to share more time together, doing fun things and sharing time outside again. If you are getting older and need a fun way to get back out there, get a Liberty Trike, or if you are younger and want to have fun with the option of pedaling or using the motor get a trike. My sweetheart has COPD and bad knees but has the best time on his trike and has had no issues shopping in stores. It is a senior mobility trike, so they really cannot say no, but no one has had any issues with him using it to shop. He also uses it in our home as well and uses it to walk and play with the dogs again and has taken it to the Rockey Mountains too, and he did good there too. It has been a lifesaver, and it is so much fun. Even my 84-year-old mom loves it.<br><br>The folks at Liberty are beyond great as well. They help kids and seniors and will help with any issue with your bike. There is no bad side to buying a Liberty Trike, they are worth the investment, and seeing my husband smile and laugh while getting exercise and fresh air.'
    },
    
    {
      name: 'Amy L.',
      date: 'July 29, 2022',
      title: 'The Most Freedom!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/285820770_10221504225863537_4157119012941585458_n.jpg?v=1684772489',
      video: '',
      comment: 'Loving these two! The most freedom my husband has had since his motorcycle accident in 2014. I promote them everywhere we go, I’ve been asked if we make them 😂 Only did some tweaking, husband has found adding motorcycle springs under his seat with his suspension post has brought the most comfort. Decided to name mine “Soar”, green like nature and soars like the bald eagle 😆 also Philadelphia Eagles green 😊 so fun!'
    },
    
    {
      name: 'Brian F.',
      date: 'July 5, 2022',
      title: 'Awesome!',
      score: 5,
      image: '',
      video: '',
      comment: 'My Liberty Trike has no problem climbing the long hill from the river bottom up to the top. I had three bars left on my battery, when I was done with my ride. AWESOME! I\’m liking this trike and I pedaled most of the time.'
    },
    
    {
      name: 'Kathy I.',
      date: 'July 5, 2022',
      title: 'I\’m so Grateful!',
      score: 5,
      image: '',
      video: '',
      comment: 'I am 63 years old and my Liberty Trike arrived a couple of weeks ago and I\’m completely comfortable with riding it now. This has been an amazing year, new knee and a new freedom with the LT.'
    },
    
    {
      name: 'Fritz W.',
      date: 'April 25, 2020',
      title: 'Great Fun in Vancouver, Canada',
      score: 5,
      image: '',
      video: '',
      comment: 'I\'ve had the Liberty Trike for six months now, and I live in Vancouver, Canada. My niece, who\'s in Seattle, bought it and gave it to me as a gift.<br><br>I am enjoying this wonderful machine almost every day, weather permitting. I have also attracted a lot of admiring eyes and questions as to where one can get this trike when I am riding around town.<br><br>I also like to thank the excellent customer service provided by the Liberty Trike sales and service team, particularly to Mr. Bill Lloyd.<br><br>THANKS, LIBERTY TRIKE!'
    }, 
    
    {
      name: 'Jai J.',
      date: 'June 9, 2022',
      title: 'Love Them!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JaiJ-LibertyTrike-image.png?v=1662140250',
      video: '',
      comment: 'We\’d had our bikes just shy of a year now, I sure do love them! I love being able to go places outside of the car to ride and stumble upon my wildlife.'
    },
    
    {
      name: 'Deryl W.',
      date: 'June 3, 2022',
      title: 'Love Them!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/284442506_5346135822120111_1293830822579639575_n.jpg?v=1678801640',
      video: '',
      comment: 'Gift for my wife. Initially, she was terrified of it during her first ride, (she never learned to ride a bike--never even had one in her youth). But now...she  L💙VES it!!!🥰🤗'
    },
    
    {
      name: 'Gail D.',
      date: 'May 31, 2022',
      title: 'Love It!',
      score: 5,
      image: '',
      video: '',
      comment: 'We just bought our second Liberty Trike and my husband loves it!'
    },
    
    {
      name: 'Dr. Miller',
      date: 'May 14, 2022',
      title: 'Cool in California',
      score: 5,
      image: '',
      video: '',
      comment: 'I have had my Liberty Trike for 2 weeks. It took 40 minutes to assemble it. Mainly 15 minutes to get it out of the box because it was so well padded and secure. Today, I rode it to a local park on a combination of bike lanes, sidewalks and a bike path. There were some longer hills and it handled them well. I went about 15 miles and had 2 bars left on my battery. I love my Liberty Trike, thank you. 5 Stars!!'
    },
    
    {
      name: 'Gary H.',
      date: 'May 6, 2022',
      title: 'Class Act Company',
      score: 5,
      image: '',
      video: '',
      comment: 'I own only want to say that I think you folks are a class act I\'ve watched the shorts on unpacking and putting together. And it\'s no wonder you\'re so successful I will definitely mention your name throughout the city thanks a lot.'
    },  
    
    {
      name: 'James G.',
      date: 'April 10, 2022',
      title: 'Best Trike',
      score: 5,
      image: '',
      video: '',
      comment: 'Best Trike, I\'ve ever had. Easy to set up and easy to ride. Front basket was really easy to set up. Powerful motor. Opened up my life. Can\'t recommend this more. Buy it and try. You\'ll love it. Well, made in the USA. I got orange and love the color (SF Giants).'
    }, 
    
    {
      name: 'Dwayne C.',
      date: 'March 12, 2022',
      title: 'Now Trikers!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/275671036_10223999228441028_6275076124669205171_n.jpg?v=1678801422',
      video: '',
      comment: 'In January, my wife, Carol, read somewhere online about Liberty Trike, and thought they would be worth trying. We are both in our mid-80s, and can no longer bicycle as we did when we were younger. On January 27 I ordered one for her as a Valentine gift, with the intention of ordering a second trike for myself if she liked it. It arrived February 2, and I was able to assemble it, with a bit of difficulty connecting the cables (can\'t see the arrows easily) and getting the quick release clamps tight enough for the seat post. Carol was not able to try it initially because she was about to start cardiac rehab and lacked sufficient range of motion to sit on the trike and get her feet on the pedals. So I used it several times around our neighborhood and quickly decided to keep it even if it did not work for Carol. Her rehab is progressing rapidly, and today she had her first ride. And loved it! She is now a Triker Grandma. And I am ready to order my own. '
    }, 
    
    {
      name: 'Moe J.',
      date: 'January 26, 2022',
      title: 'Need to Exercise',
      score: 5,
      image: '',
      video: '',
      comment: 'I have a condition that hasn\'t allowed me to ride a standard two-wheeled bike due to muscle loss and poor balance, so walking has been difficult. Being 70 years old, I needed a means of exercise, and purchasing the Liberty Trike has proven to be the answer.<br><br>I ride 5 to 15 miles at least five days a week. The electric motor assist allows me to manage hill inclines with little to no effort. It also gets me home when I\'m exhausted from my energy a distance from home.<br><br>The Liberty Trike is everything it\'s described to be. I should mention that I weigh 230 pounds, and my grandson rides with me in the back basket, and he weighs 60 pounds.<br><br>I have called one time to address a potential issue. The individual at Liberty Trike was very friendly and more than willing to help me resolve my issue. Due to my weight, I made one modification to replace the seat for one with springs and spring loaded seat shaft.'
    }, 
    
    {
      name: 'Deidre D.',
      date: 'January 28, 2022',
      title: 'Independence',
      score: 5,
      image: '',
      video: '',
      comment: 'I finally rode my Liberty Trike, and I love it. It even has more power for growth and experience. Being disabled limits my independence, and the Liberty Trike gives me much more access to move around the community.<br><br>A basket for shopping, pets, recycling disposal, chasing sunsets; numerous activities. The company was very proactive and helpful in solving any issues! Thank you, we have miles of shoreline bike trails, etc., to explore.'
    },
    
    {
      name: 'David S.',
      date: 'February 13, 2022',
      title: 'Completely Satisfied',
      score: 5,
      image: '',
      video: '',
      comment: 'I got mine three days ago, really quick. One of the reasons I got the trike is that I have lost the lower half of my eyesight, and the rest will eventually go away.<br><br>I promised my wife that when I got uncomfortable driving, I would stop driving. Even with my limited eyesight, four back surgeries, and both knees replaced, I could easily assemble it.<br><br>It takes some getting used to, BUT I LOVE IT. We live on some mild hills in California, making it possible for me to go to the store and just around.<br><br>I just wanted to let you know that I APPRECIATE THAT YOU ARE A UNITED STATES MANUFACTURER AND I BELIEVE, IT MAKES IT A GREAT PRODUCT.<br><br>The only thing that I am curious about is that when going downhill and applying the hand brake, it isn\'t smooth like you would expect a disc brake.<br><br>SO FAR, COMPLETELY SATISFIED.'
    },
    
    {
      name: 'Deanna M.',
      date: 'January 9, 2022',
      title: 'Big City Trike Riding',
      score: 5,
      image: '',
      video: '',
      comment: 'I\'m a 69 year old with problems in my ankles. I\'ve been riding my liberty trike for nearly 3 years. I live in NYC and have not been on public transportation since Liberty Trike. I use it for all my errands, grocery shopping and visiting. The wheels are of excellent quality. Never had a flat. I\'ve been able to use it year round by planning my trips no less than 40 degrees, only because I would become too cold at lower temperatures. Strangers ask questions all the time. I\'ve run out of the Liberty Trike business cards twice. Liberty Trike has allowed me to get out of the house and do things for myself. I am really happy with my Liberty Trike.'
    },     
    
    {
      name: 'Carol F.',
      date: 'November 16, 2021',
      title: 'Fun in Florida',
      score: 5,
      image: '',
      video: '',
      comment: 'My dog Tessa gives the Liberty Trike basket a big two-paws up! We love riding the rails to trails system, and we are at 241 miles. I, too, had lost my freedom until Santa Will (my husband) bought me a Liberty Trike. I have given out most of my Liberty Trike cards and have a sale as one of my sisters at the Church bought one, and she loves hers too. I feel like a girl until I look in the mirrors and remember to take it slow. I love the wind in my hair!!!'
    },
    
    {
      name: 'Michael H.',
      date: 'October 7, 2021',
      title: 'A Sense of Normalcy & Increase of Mobility',
      score: 5,
      image: '',
      video: '',
      comment: 'I am a retired Navy/Marine Corps veteran of 20 years service. In 2006, I was in a car wreck that crushed the lower half of my left knee. I\'ve got arthritis (severe) in both feet arches. Mobility until now has been slow and a bit painful. Now I have my Liberty Trike I can get out into the world like I was meant to get out there. In the fresh air. I can say hi to neighbors and take my dog for a walk. The Liberty Trike is pure magic as far as I am concerned. I\'m putting 5-10 miles a day riding it in my little community. Its pretty awesome. I think anyone who needs increased mobility should consider getting one. My "Flash" (my liberty trike name) is my BFF for mobility. I do a pre-ride check on it every day. It\’s fantastic!'
    },    
    
    {
      name: 'Rusty - Trikeman.',
      date: 'October 2, 2021',
      title: 'I Owned a Liberty Trike for 2 Years!',
      score: 5,
      image: '',
      video: '',
      comment: 'Best E-Trike on the market today. I am ordering another one today. Easy to assemble, easy to operate. The size of this E-Trike allows me to take it with me in my Class C Motorhome. Well built and great after the sale service.'
    },     
    
    {
      name: 'Lesa E.',
      date: 'September 24, 2021',
      title: 'It Gave Me Back my Freedom',
      score: 5,
      image: '',
      video: '',
      comment: 'I LOVE my Liberty Trike. I have Parkinson\'s disease and bad balance issues. When I go for a walk, I always feel unsafe and scared, plus I move at the speed of a sloth.<br><br>When I got my Liberty Trike, I suddenly felt so free. I can go to the park with my grandkids or ride alongside my husband as he runs with the dog. Sometimes I use the throttle to go really fast, so I can feel the breeze on my face and feel like a kid again. I ride without the motor and pedal because it\'s a great workout plus, it gets my heart pumping and my legs moving.'
    }, 
    
    {
      name: 'Elvira H.',
      date: 'September 20, 2021',
      title: 'Thank You!',
      score: 4,
      image: '',
      video: '',
      comment: 'I would like to thank you for your quick response to my founded concerns about the delivery of my Liberty Trike. After putting it all together, with the help of my son, it was all in perfect shape. The first test run was a blast. I\’m very happy and hope to be a master in riding the trike in no time. It is very sturdy and I feel secure riding it, I just need to get used to the wider back of 2 wheels. Thank you again for your help. I have total confidence in your company.'
    },     
    
    {
      name: 'Marth B.',
      date: 'August 15, 2021',
      title: 'What a WONDERFUL Trike!',
      score: 5,
      image: '',
      video: '',
      comment: 'You guys have thought of everything! I keep discovering new conveniences on it, like the walk feature to get me up my steep grassy yard, the backing ability, all the odometer readings, the basket, etc.'
    },     
    
    {
      name: 'Kim T.',
      date: 'July 27, 2021',
      title: 'Good Purchase',
      score: 5,
      image: '',
      video: '',
      comment: 'I couldn\’t wait to get my Liberty E-Trike and I\’m enjoying it! People, I pass say that they would like one. Good job, Liberty Trike!'
    }, 
    
    {
      name: 'Linda Z.',
      date: 'February 15, 2021',
      title: 'Very Commendable Company',
      score: 5,
      image: '',
      video: '',
      comment: 'I was interested in the Liberty Trike being an effective tool for helping the youngsters in the TODAY story. I also am very happy with my Liberty Trike experience. I have been working with PT technicians for 20 months. My inability to walk went from being unable to walk at all (following spinal surgery in June 2019) to be able to walk a thousand steps without assistance. The Liberty Trike has been a very welcome tool in my current therapy. I am enjoying frequent trike rides, and have increased my ability to walk, unassisted, to half-mile treks in my PT sessions. My Liberty Trike has played an essential role in my progress. Well done, Liberty Trike!<br><br>Incidentally, I almost forgot to mention that I am 78 years old.<br><br>Thanks,<br>Linda'
    },   
    
    {
      name: 'Gracia S.',
      date: 'May 31, 2021',
      title: 'Amazing Bike, and Amazing Videos',
      score: 5,
      image: '',
      video: '',
      comment: 'I got my Liberty bike a few weeks ago. The amazing thing about Liberty trike is there are videos. I don\'t know why all companies aren\'t doing this. The videos are so comprehensive, easy to understand, and AMAZING! Customer service is great as well. The bike itself is wonderful. I was having balance issues on my two-wheel bike being over 60 and not that experienced on bikes. After three falls from my regular bike, I bought a Liberty Trike and I\'m having a ball. We transport it inside our van, but when we need to, we can fold it. It\'s a great ride and the seat is very comfortable. Thank you so much!'
    },
    
    {
      name: 'Santa G.',
      date: 'May 25, 2021',
      title: 'I Never Had So Much Fun!',
      score: 5,
      image: '',
      comment: 'My son bought me a Liberty Trike, a couple of months ago. I\’m 87 years old and I have been riding my Liberty Trike almost every day and I never had so much fun! I purchased an extra battery and I made a holding bracket in the back basket to take along just in case. I haven\’t had any problems at all, it\’s well made and powder coated. I\’m still getting used to putting the battery in and out. I ride it in all the stores so far and everyone gives me the thumbs up.<br><br>This Christmas, I want to dress up as Santa and rig the Liberty Trike up to look like Santa\’s sled. I\’m going to look into getting a trailer so Santa can haul the gifts around. I want to ride it around and deliver presents to the kids and say Merry Christmas! I\’ll send pictures to show you all next Christmas!<br><br>Best<br>Santa Gordie'
    },  
    
    {
      name: 'Joseph J.',
      date: 'January 8, 2021',
      title: 'This Company Truly DEFINES Customer Service',
      score: 5,
      image: '',
      video: '',
      comment: 'I purchased the Liberty Trike more than a year ago, and after the warranty expired, I had experienced problems, off and on. Liberty Trikes customer service continually worked with me to fix the issues, even though they did not have to. Customer service was very patient with me because most of the problems were things that I caused due to my inability to follow directions. I would charge my battery all night and still get only one bar after completion. They finally figured out I was using the wrong charging setting. They sent me a video of a step-by-step process on how to fix the issue and it worked! I am so thankful that they had a lot of patience with me. One of the service techs told me, “skip, no matter what happens after this is all said and done, we\'ll figure it out and you will be happy,“ so I would like to say I am extremely happy and very thankful that I purchased this product from this company. I guarantee you customer satisfaction is the number one priority for this company and its products. I can personally testify they will "do" what they say they will do, and then some'
    },   
    
    {
      name: 'Suz M.',
      date: 'September 2, 2020',
      title: 'THANK YOU!',
      score: 5,
      image: '',
      video: '',
      comment: 'I had some issues with my Liberty Trike and you graciously offered to repair it for FREE… it now works, better than ever. I’m FREE to roam, a three time Cancer survivor with mobility and Nephropathy issues, and with no balance. You have given me my life back!!'
    },
    
    {
      name: 'Marcia N.',
      date: 'September 14, 2020',
      title: 'I Love My Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LibertyTrike-MarciaN.jpg?v=1600096866',
      video: '',
      comment: 'Hello Jason,<br>Just wanted to let you know how much I am enjoying riding my Liberty Trike! This trike has kept me active all summer when so many activities have shut down due to Covid-19.<br><br>There are lots of great bike paths in Vancouver and being able to get around easily on my Liberty Trike has been wonderful. I can keep up with my cycling group (with a bit of help from the electric assist) and so far I have cycled 400 miles. The carrier basket is perfect for hauling food for our picnics in the park and we bought the longer crank from Liberty and that has helped to give me more "pedal authority” (as you have described it). Last week we did a 20 mile trip from Stanley Park to North Vancouver across the Lion\’s Gate Bridge.<br><br>I am surprised that I do not see more people riding trikes. Whenever I am out riding, I am constantly being stopped by people wanting to know where I purchased mine and I enjoy talking to them about Liberty Trikes.<br>Thanks again for designing such an excellent product! – Marcia'
    },   
    
    {
      name: 'Paula R.',
      date: 'September 9, 2020',
      title: 'Liberty Trike in Chile',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike_Paula-R-Chile.png?v=1599683661',
      video: 'https://youtu.be/TRxvMx8HgOk',
      comment: 'Hi. I\’d like to tell you about my Liberty Trike experience. I\'m 55 years old and I have SMA. My husband found your site on the internet and we decided to buy a Liberty Trike. It was hard and very expensive to ship it to Chile, where we live, but it was worth it, since it has been a good riding experience. My husband has his bike, and I\’m riding my Liberty Trike. It\'s a pleasurable to ride, and at the same time I can exercise. It would be great, if you implement a way, that people outside of the U.S.A. can buy and ship the Liberty Trike, because it was really difficult for us.<br>Thank you, Paula R'
    },    
    
    
    {
      name: 'Lauren U.',
      date: 'August 15, 2020',
      title: 'Freedom to Move is Right!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Freedom-to-Move-Lauren.png?v=1599054586',
      video: '',
      comment: 'My husband\’s birthday gift to me was a Liberty Trike, so I can accompany him on his walks at the beach. I have been missing out, for the last eight years because of walking issues due to M.S. I\’m out moving and seeing life’s beauty, and I named her, “Magic” because it’s so easy, fun, and free! The “freedom to move,” is right and that is magic!'
    },
    
    {
      name: 'Kat T.',
      date: 'July 11, 2020',
      title: 'Life Changer',
      score: 5,
      image: '',
      video: '',
      comment: 'I\'m 59 with knee, hip, back, and balance issues. I love nature photography and used to go on day hikes all the time. As my knees and hip became worse, I had to stop for fear of falling or having one or more body parts hurting so much, that I can\'t get back to the car. I was saddened by this, and the inability to get exercise was making my health problems worse.<br><br>Not any more. My new Liberty Trike has allowed me to safely explore the world again, and get exercise without aggravating my problems or worrying about getting stranded or hurt. The Liberty Trike was easy to assemble, especially with the YouTube video link. I can lift it in and out of my van pretty easily and I plan on getting a scooter ramp/carrier at some point.<br><br>I liked the variety of frame colors and accessories offered. I ordered the cover, but don\'t feel the quality is what it should be, and it won\'t fit if you add mirrors. I plan on designing a trike cover. The seat is slightly larger than a standard bicycle seat and the backrest helps with my comfort level. As I\'m able to ride for longer periods, I\'ll probably need additional padding though.<br><br>The one negative for me, the nuts for the bolts holding the basket/battery mount quickly unscrewed from vibration, so I had to replace them with self-locking nuts. This was a minor problem, easily fixed, and does not take away from the quality and well-thought-out design. I would happily recommend this to anyone. A word of caution to anyone first riding the trike is to take it easy on the corners! As with any three-wheel vehicle, it\'s easy to jackknife!'
    },    
    
    {
      name: 'Fred S.',
      date: 'June 27, 2020',
      title: 'MS Doesn’t Slow Her Down',
      score: 5,
      image: '',
      video: '',
      comment: 'About 8 months ago, my wife Sharon, who has Multiple Sclerosis (MS), bought a Liberty Trike. All I can say is, what a great improvement in her! She can get around and use it as a little workhorse for gardening, planting, and she uses the basket to move things.</br></br>Thanks, to the Liberty Trike team for improving my wife\’s mobility. I have pictures of her proudly riding her trike. We have many residents ask her about the Liberty Trike and how cool it looks and how useful it is. She rides her trike with pride and gusto and always has a pretty huge smile. Liberty Trike gets a 10 plus!'
    },
    
    {
      name: 'Elizabeth R.',
      date: 'April 7, 2020',
      title: 'New Liberty Trike',
      score: 5,
      image: '',
      video: '',
      comment: 'I just received it and it was extremely easy to put together. I watched the video, which explained how to do build it, and it\'s a very good video. I have pulmonary hypertension so I can’t ride a bicycle anymore, which I used to enjoy. I took out, my Liberty Trike today with my husband, just a short ride to get used to it, loved it, thank you so much for making something that makes life more enjoyable for me.'
    },
    {
      name: 'Philip',
      date: 'February 15, 2020',
      title: 'Amazing Service',
      score: 3,
      image: '',
      video: '',
      comment: 'I recently purchased a Liberty Trike for my wife. The purchase was made online about 2400 miles away from the company location. Some ongoing follow up communication by phone and email became necessary following the delivery, assembly and operation of the trike.<br><br>In my experience, I found the service, integrity and communication from the representatives of the company to be incredibly good. The several representatives who assisted me did so in an very exemplary manner. I feel complete trust in them. They seemed more like family than business representatives. They have been wonderful to work with.'
    }, 
    
    {
      name: 'Robert I.',
      date: 'February 6, 2020',
      title: 'Great Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike_VivianI.png?v=1581371973',
      video: '',
      comment: 'Vivian rode her Liberty Trike today for about 40 minutes around our neighborhood. The Liberty Trike worked very well!  It is very well put together and rides great. We really like it, as does one of our neighbors who saw it. One thing Vivian really likes is that the pedals are easy enough to turn on level ground that she can sometimes not need to use the motor. The battery slides in and out very easily. Vivian says the motor seems a little louder than the first one, however it runs just fine. I am guessing there could be some normal variation in that and it\’s nothing to be concerned about.'
    },
    
    {
      name: 'Joyful I.',
      date: 'February, 3, 2020',
      title: 'Get Your Life Back!',
      score: 5,
      image: '',
      video: '',
      comment: 'We researched and shopped for two years looking for a scooter for my hubby. After receiving a broken scooter that sits so close to the ground and made of plastic, we stumbled on Liberty Trike. We took a chance and bought one, and OH MY if you need some spare legs or knees in our case, get one. We both absolutely love our red trike! It makes you feel like a kid again, every time you get one it, You can pedal when you feel like it or let the trike go on its own, or have pedal assist. We added some handicap stickers and printed out the ADA state rules to have in case anyone refused to allow this mobility vehicle inside (no one has) but we have it all just in case. Bought a helmet and a horn and now my hubby is out and about all the time. What a blessing to see him enjoying getting out and getting exercise and fresh air. It is so worth it and these folks stand behind their product and are proud of what they make and they should be. Buy a Liberty Trike and get your life back! Now I just need to get one for myself! (I am a real customer and have not been paid for this review, I just want to share the news about a really great product.)'
    }, 
    
    {
      name: 'Julie A.',
      date: 'January 27, 2020',
      title: 'Love our Liberty Trikes!',
      score: 5,
      image: '',
      video: '',
      comment: 'We have so much fun on our Liberty Trikes! We bought a carrier with a ramp and attach that to the back of our motorhome. We have been from west coast to east coast with them and when the motorhome is parked, they are our only form of travel. We will do grocery runs on them, actually riding them into the store, loading up our baskets, then go through checkout and reload the baskets. Then we motor on back to our campsite.<br><br>We rode 5.6 miles from our campsite in Winslow, AZ to the Barringer Meteor Crater and visitor center and back averaging 14 mph. The road is a mixture of flat and hills – uphill going to the crater and downhill coming back. The Liberty Trikes performed beautifully and we get lots of comments on them. I am disabled, so I ride it everywhere and my husband rides his to keep up with me.'
    },  
    
    {
      name: 'Bonnie B.',
      date: 'January 13, 2020',
      title: 'Definitely a Keeper!',
      score: 5,
      image: '',
      video: '',
      comment: 'I just received mine, 3 days ago! It\’s great, better than I ever could have expected!! I\’m 79 and I have a lot of mobility problems but on the 2nd day, I was riding like a champ! Well worth the money, it\’s very well made and so easy to pedal without using the motor. Definitely a keeper!'
    }, 
    
    {
      name: 'Frank S.',
      date: 'January 11, 2020',
      title: 'Liberty Trike Review',
      score: 5,
      image: '',
      video: '',
      comment: 'I am handicapped from a stroke & have balance issues. I purchased a Liberty Trike about a year ago and have 154 miles on it. It\’s great for me, as I take my dog for exercise a couple times a day! We can run or walk at any pace, this trike is the greatest and very well make, Liberty Trike\’s customer service is great, as well. If you have trouble walking or just want a short distance transportation, I highly recommend this trike!!'
    },  
    
    {
      name: 'Debra S.',
      date: 'September 12, 2019',
      title: 'Whole New World',
      score: 5,
      image: '',
      video: '',
      comment: 'So many people see me ride my bike and stop me. I give them the name but cards are the best! I hope to have many more Liberty Trike owners here to ride with me. Having my bike has enabled me to attend so many more events that I couldn\'t have walked to. I biked in our city\'s 4th of July Parade. I bike to our community park to attend festivals there. I bike to the beach in the summer and to our city pool. Having my Liberty trike has opened up a whole new world of fun!'
    },  
    
    {
      name: 'Glenn L.',
      date: 'November 12, 2019',
      title: 'I\’ll Take Two...',
      score: 5,
      image: '',
      video: '',
      comment: 'I ordered a Liberty Trike for my wife and she loved it. I liked it so much that I ordered one for myself. They are easy to put together. One up grade I did was to order a sheepskin seat cover for each trike. We had two full sized converted trikes but we gave them away because the liberty is so easy to ride and maneuver. We try to ride a little each day and love them more each day.'
    },
    
    {
      name: 'Sue C.',
      date: 'November 4, 2019',
      title: 'Trike Trip',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Sue-Conde.jpg?1520',
      video: '',
      comment: 'Trip to our Santa Cruz Mountains. Specifically Bear Creek Road, POST (Peninsula Open Space Trust) Preserve. Interpretive tour. It\’s been years since, I have been able to do this. Thankful for my Liberty Trike, Seaweed.'
    },   
    
    {
      name: 'Nancy M.',
      date: 'November 7, 2019',
      title: 'Purple Eater Trike',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Nancy-McGahn.jpg?1517',
      video: '',
      comment: 'Just took my first ride on my people purple eater trike. It was wonderful. Easy peddle and I feel great. So inspiring!<br> Thank you, Jason'
    },  
    
    {
      name: 'Betty S.',
      date: 'November 6, 2019',
      title: 'Purple Haze',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Purple-Betty-Sams.jpg?1514',
      video: '',
      comment: 'Rode my trike "Purple Haze" for 1st time today outside and it was cold. We have a long driveway, so I practiced riding and turning. Love it. I actually felt like a child at Christmas time.'
    },  
    
    {
      name: 'Susan A.',
      date: 'November 7, 2019', 
      score: 5,
      image: '',
      title: 'Awesome!',
      comment: 'I\'ve have MS for 40 years and the past few years my mobility has diminished to using a cane and a walker. I\'ve had a recumbent trike and it was fun but somewhat difficult for me to get on. Had to have someone clip my feet onto the pedals and it was cumbersome to transport. When my oldest grandson graduated from high school, parking wasn\'t convenient so my hubby modified an old walker into a mini wheelchair for me. Worked great until we hit a bump and I fell out of it. Hubby started looking at mobility scooters for me when I told him about Liberty Trike. Within a few minutes, he said order it. Because I chose a color (teal) that was not in stock & had to be painted) delivery took a little longer than usual. I absolutely love the trike and my grandkids do too. Everyone is quite impressed with it. We just returned from staying near some of our favorite camp grounds and for the first time ever, I was able to explore the trails my grandkids have explored for years. It was a little challenging but my hubby kept encouraging me and guiding me and in the end I did about 8-9 miles. He was a little worried about the hills, but we did good. May not be a lot to some, but to me it was a milestone. Am looking forward to riding with my grandkids the Summer and daily with my hubby. Thank you Liberty for this wonderful trike. You\'ve changed my life.'
    },    
    
    {
      name: 'Kim H.',
      date: 'October 22, 2019', 
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Allison-Heinrich-Liberty-Trike.jpg?1360',
      title: 'FREEDOM!!',
      comment: 'Hi everyone-meet Allison. She\’s not your typical trike owner but this trike is changing her life-exploring her neighborhood and getting outside, like everyone else. The technology and design of this trike WORKS for people with neuromuscular diseases. Allison has great difficulty walking but with this trike — FREEDOM!<br><br>We love hearing your stories and tips and seeing the enjoyment this trike brings you.'
    },    
    
    {
      name: 'Moon S.',
      date: 'October 12, 2019',
      title: 'First Trike Ride',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-MoonS.jpg?1328',
      video: '',
      comment: 'We had our first trike ride, only 3 miles and in a flat park. There wasn\’t too much of a learning curve after the first mile, kept it mostly on 3. The loading & unload is gonna take me a while to get the hang of it. Mirrors and seat cover on order. Tomorrow, we\’ll try the beach... Holy moly, these Liberty Trikes are fun!'
    },    
    
    {
      name: 'Julie I.',
      date: 'October 15, 2019',
      title: 'I’m Loving It!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Red-JulieI.jpg?1325',
      video: '',
      comment: 'Got my Trike on Oct 9th after waiting a month! My trikes name is Ruby. Today was my 1st time I rode it. Was so busy last week! Have to get use to riding it. A little different from riding a 2 wheel bike! So far I\’m loving it, especially after I get more comfortable riding it! Now I have to get rear view mirrors and a bell!'
    },    
    
    {
      name: 'Ann-Marie W.',
      date: 'October 16, 2019',
      title: 'Liberty Trike In Scotland',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-AnnMarieW.jpg?1320',
      video: '',
      comment: 'I would like to report that I took my Liberty Trike to Scotland with me. Having the trike made travel enjoyable for the first time in a long time. I love that the trike not only give me mobility but the device allows me to be close to eye level with those I meet on the street. It was evident that not only mobility but pain limited my “seeing” the architecture and scenery as well as appreciating the conversations with locals. The Trike was liberating – wonderful<br><br>By the way, the natives l-o-v-e-d the trike. Electric bikes are the rage all over Europe. You will find many city buses and most commuter trains adapted to bike-friendly usage. If going to the UK go to the internet and find the Spokes website to get maps and cycling guides. The internet will also provide other biking tour information. I hope that you find this information helpful and it gives you hope that you can enjoy travel, again.'
    },    
    
    {
      name: 'Gregory T.',
      date: 'September 20, 2019',
      title: 'Woohoo... the Liberty Trike is a Hot!',
      score: 3,
      image: '',
      video: '',
      comment: 'I finally got up the nerve to venture out of my driveway and I am in love with the Liberty Trike. I just rode in my neighborhood but the feeling of freedom and mobility was unbelievable. I can really pedal and believe that it will help my knees to get better. I actually met some of my neighbors that I have not been able to do recently because I can\'t walk. This is the best thing for me to get up and move. I will be forever grateful to Liberty Trike for creating this wonderful product.'
    },     
    {
      name: 'Barbara W.',
      date: 'September 5, 2019',
      title: 'Couldn\'t Be Happier',
      score: 5,
      image: '',
      video: '',
      comment: 'Because of mobility issues I felt stranded at home. No longer the case, I ride my Liberty Trike to work and around the neighborhood for exercise. Best purchase in a long time. Thank you for creating such a wonderful product.'
    },    
    {
      name: 'Ronda C.',
      date: 'September 11, 2019',
      title: 'Love It!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Electric-Bike-Red-RCarr.jpg?1270',
      video: '',
      comment: 'I\’ve had my Liberty Trike for a couple of weeks now and I absolutely love it!'
    },    
    {
      name: 'Tonya T.',
      date: 'September 15, 2019',
      title: 'In Love with My Bubblegum',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Electric-Bike-Pink-TThompson.jpg?1267',
      video: '',
      comment: 'I\'ve had my Bubblegum for 3 months. I have Cerebral Palsy, my boyfriend and I decided we wanted to live on a 41ft cabin cruiser, but living on the docks is an obstacle course for me having mobility issues, so we bought Bubblegum a pink Liberty Trike and she has been awesome! She gets me up and down the docks safely and I have been able to go on bike rides with my grandchildren. I honestly wish Liberty Trike was an option, when my children were young. Thank you Liberty Trike for making a product, that so many of us, can use to make our lives more enjoyable.'
    },    
    {
      name: 'Earla K.',
      date: 'September 14, 2019',
      title: 'AWESOME!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Electric-Bike-Yellow-EKarels.jpg?1264',
      video: '',
      comment: 'Went for my first ride today and it was awesome!'
    },    
    {
      name: 'Pearl H.',
      date: 'September 10, 2019',
      title: 'Love My Bike!',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Yellow-Liberty-Trike-PHess.jpg?1261',
      video: '',
      comment: 'I took a 12 mile ride today on these great bikes!'
    },    
    {
      name: 'Sue O.',
      date: 'September 1, 2019',
      title: 'Love My Bike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Red-Liberty-Trike-ebike-Sconnor.jpg?1163',
      video: '',
      comment: 'I make it to Wilton, only 7 miles one way but for me that is a big deal. The other bike is my daughters new bike, she got that yesterday. The whole family now rides together, first time. I also made it back home. Love being able to be in the woods, love my bike and our bike trail. Thanks Liberty, for getting me back on the trail.'
    },     
    {
      name: 'Jean P.',
      date: 'September 3, 2019',
      title: 'WoW!',
      score: 5,
      image: '',
      video: '',
      comment: 'Just got the Liberty Trike. Everything works! Just went for a spin in our garage and WOW!'
    },  
    {
      name: 'Martin K.',
      date: 'September 2, 2019',
      title: 'A Shriner Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Pink-Liberty-Trike-electric-folding-bike.jpg?1156',
      video: '',
      comment: 'Tara (aka T-Kup) debuted her pink Liberty Trike at the Milford, NH Labor Day Parade. She had a blast!'
    },     
    {
      name: 'Sharon B.',
      date: 'September 1, 2019',
      title: 'Thanks!',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Red-Liberty-Trike-electric-folding-bike.jpg?1153',
      video: '',
      comment: 'Thanks to my Liberty Trike, I enjoyed a great birthday with my family at Knott\'s last Sunday!'
    },    
    {
      name: 'Dale C.',
      date: 'September 3, 2019',
      title: 'Love My Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Electric-Bike-Yellow-DCoddington.jpg?1148',
      video: '',
      comment: 'Hey Ya\’ll, loving my trike in Hillsborough, NJ.'
    },  
    {
      name: 'Long N.',
      date: 'September 3, 2019',
      title: 'This is an Excellent Trike!',
      score: 5,
      image: '',
      video: '',
      comment: 'Very small footprint. Very good on sidewalks without being too imposing on pedestrians. I test drove this Liberty Trike up five level parking garage three times and it can easily handle it at level 5 power. It feels very stable and sturdy with the steel frame. The battery consistently gave me a 20 mile range with no pedaling. Customer service (with Jason) was very good and prompt. I will buy another Liberty Trike for the wife, so we can explore all the parks together.'
    },    
    {
      name: 'Kathy W.',
      date: 'August 23, 2019',
      title: 'I\'m Mobile Again!',
      score: 5,
      image: '',
      video: '',
      comment: 'From 2012-2013 I had 6 cancer surgeries that left me without a tailbone and a nerve bundle that controls my left leg and everything in my pelvic saddle. Long story short, I could no longer walk well or for any distance and chronic nerve pain was only made worse by trying to ride an exercise bike. Then I found the Liberty Trike! The bike saddle is not painful like others are (with gel covers). I can ride a bike again, feel mobile, get some exercise and get outdoors. What can I say? The LT ROCKS!'
    },  
    {
      name: 'John G.',
      date: 'August 1, 2019',
      title: 'My Orange Crush',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Electric-Bike-ebike-ecycle.png?1071',
      video: '',
      comment: 'I just got my Liberty Trike, (Orange Crush) a few weeks ago and find that it is very different from riding my old Bianchi competition triathlon bike that I have been riding for over 20 years. So, it is like learning to ride a bike all over again. I am getting the general sense on how to control my ride and forget that I am not in a race but on a leisurely ride around the neighborhood. Once, I get the hang of it fully, this will be lots of fun.'
    },    
    {
      name: 'Heather P.',
      title: 'Amazing Trike & Customer Service!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Electric-Bike-Orange-ebike.png?1066',
      video: '',
      comment: 'Amazing customer service for an amazing trike! If everything isn\’t right to start with, they really want to work with you to solve it. So much fun!! I’ve gone for a ride everyday, and I\’m about to go out again!'
    },    
    {
      name: 'Lori Anna',
      title: 'Really Loving My New Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Trike-Teal-Electric-Bike.png?1054',
      video: '',
      comment: 'Really loving my new Liberty Trike! My husband is looking forward to upgrading from his standard folding bike to a Liberty Trike, soon!!'
    },     
    {
      name: 'Brenda G.',
      title: 'Absolutely Love Riding It!',
      score: 3,
      image: '',
      video: '',
      comment: 'My Liberty Trike, it is lower to the ground and you have better control. You do have to practice a little first, like going around curves or turns, and I watch my speed when I do turn, but it doesn\'t take long to absolutely love riding it. It is one of my treasures and don\'t regret one dime I spent for it.'
    },     
    {
      name: 'Sunny B.',
      title: 'I love This Thing!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Pink-Trike.png?1047',
      video: '',
      comment: 'So late yesterday afternoon, the big brown truck brought my long awaited delivery. The driver was kind and backed his truck up my steep driveway so the box could be put in the garage. Thinking he may be the next customer for LT cause when he found out it was an electric trike he told me his wife likes for them to go for an after work bicycle ride, but he\'s always too tired from work - said he was going to look into LT and their other bikes after work!<br><br> Upon opening the box I fast realized that I didn\’t have the strength to lift things out so I simply cut the sides down and then had the bonus of a cardboard work surface for assembly. It only took about an hour to assemble and much of that time was spent cutting away tape and bubblewrap - lol.<br><br> Then I wanted to test it but had to get down that steep driveway so I put it in power 1 mode and started down pedaling only. To my surprise the bike veered left as I steered to the right and I nearly rode into the neighbors bushes. Tightening the handlebar lock further resolved that problem - lol. Once on the street it was a lot of fun to zoom around.<br><br> My prior ride was an 1100cc 700 pound motorcycle, upon which 5 ft me, loved to lean into curves to the point that the bikes footboards sparked from scraping the ground. So I thought this 10x lighter trike would be easy to ride but found I have to learn new habits. No more leaning, gotta go slow and turn the wheel instead. I put it in power level 2 and it zoomed back up the steep drive with me barely pedaling. I love this thing!'
    },    
    {
      name: 'Bruce H.',
      title: 'Liberty Trike Wedding',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/BruceH-Liberty-Trike-Electric-Trike-Wedding-Day.png?999',
      video: '',
      comment: 'Thank you so much for my Liberty Trike! It\’s allowed me to do so many things, I couldn\’t do without one. Finding your company was a wonderful thing for me.<br><br>My daughter was getting married and I was worried about walking her down the aisle. I used my Liberty Trike, other special day and was able to make my daughters wedding the day she deserved!<br><br>Thank you, Bruce H.'
    },    
    {
      name: 'Carla',
      title: 'Mobility Back!',
      score: 5,
      image: '',
      video: '',
      comment: 'I received my Liberty Trike yesterday, the color is orange and it is beautiful! I immediately started unpacking it as I had previously watched the video and felt pretty confident. I had to call my neighbor to help me muscle in the handlebars and the pin for the center but other than that it is straightforward and simple. I immediately knew I was going to love it as I rode dirt bikes and ATV’s my whole life.<br><br>I\'ve been in a lot of pain with my arthritis and two bad knees so even going to the grocery store is torture. As soon as I hit the throttle you couldn\'t slap the smile off my face! I have to admit I rode in 4th gear flat out the whole time. I need to reign in my enthusiasm a bit so I do not crash. lol.<br><br>I had 3 bars when I reviewed my bike, put 8 miles on it and still had 2 bars left!!! I plugged in overnight and am on full charge today, it\'s going to be 97 today in Sacramento and I\'m going to look for some water to play in!<br><br>Two things, it is a bit heavier than I anticipated but I\'m pretty confident I will figure out the best way to wrestle it into my outback. My honey will help me figure it out! 2nd thing, this is a trike so you do need to have balance and a little skill, the sidewalk can be dangerous with all the driveway dips and you have to be able to counter lean against the dip.<br><br>Overall I\'m impressed, hooked and addicted, I found myself dreaming about how I should get the bigger trike for around town because my dog Lovey was chasing me and we all want to ride! Thank you Electronic Bike Technologies for making this bike option, I was looking at mobility scooters with 2" clearance that had no options to help my mobility like the pedals that you offer, and now I have my Liberty Trike and it makes me want to cry, thank you for giving me my mobility back!'
    },
    {
      name: 'Mary P.',
      title: 'Neighborhood Tours on my Liberty Trike',
      score: 4,
      image: '',
      video: '',
      comment: 'I opted to have my black bike shipped to UPS at US/Canada border and picked it up and brought into Canada myself. I was required to pay the taxes. Before assembling, I made sure it fit in my Honda Civic trunk. Picked up in SUV (box size). I put the bike together by myself in 1 hr 20 min and I am not a technical person. (I had viewed the helpful videos a few times before bike arrived). Took it on the first test drive today. I had a very negative experience on two wheel bike so I was a little nervous but after 3 miles I was really getting the feel for it. I will do a few more neighborhood tours before hitting the bike paths. I also joined the FB page a few weeks ago to get a sense of how current owners are enjoying. I found that helpful. I am looking forward to spending lots of time with DEX.'
    },      
    {
      name: 'Mitch D.',
      title: 'Received my Liberty Trike Today!',
      score: 5,
      image: '',
      video: '',
      comment: 'Received Liberty Trike today. Carefully followed assembly instructions. Trike went together nicely without a hitch for old all thumbs guy. The wife is as as happy and thrilled as our wedding day, hmm, almost. The trike performs well as advertised. I\'m happy my wife will now be mobile with me. Thank you, Mitch'
    },       
    {
      name: 'Patricia H.',
      title: 'It\'s the Harley of Electric Trikes!!!',
      score: 5,
      image: '',
      video: '',
      comment: 'Received and assembled! Love it!  I\'m 67... about 5\'2.... 110 lbs.... it was so easy to put together all by myself! Rides SO nice! It\'s the Harley of Electric Trikes!'
    },    
    {
      name: 'Phil S.',
      title: 'An Excellent Choice for People with Mobility Issues',
      score: 5,
      image: '',
      video: '',
      comment: 'I looked for a long time for something light weight and cost effective. It has a long battery life, great travel distance, it is portable, excellent maneuverability and power. It met all of the expectations I was looking for with out the feeling I was using a handicap type solution. I am in my 50\'s and I just could not come to grips with using a mobility scooter I like the fact that it can be peddled, all electric or a combination of both. I found that the company and people back their product 100% and take great pride in the product.'
    },
    {
      name: 'Gail T.',
      title: 'I\'m Really Happy with my Liberty Trike',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Gail-T-Liberty-Trike-Electric-tricycle.jpg?1951572574219142761',
      video: '',
      comment: 'I\'m really happy with my Liberty Trike. I was in California for the winter and bought it so I could ride it in Palm Springs and Santa Cruz in the sunshine. I get smiles and thumbs up from folks when I ride it. Here is photo of my trike from oceanside on the paved Santa Cruz trail. I am planning vacations around paved rails to trails and ocean trails. Long Beach, WA in April is next.'
    },
    {
      name: 'David Y.',
      date: 'January 29, 2019',
      title: 'Here We Go!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/David-Y-Liberty-Trike-Electric-tricycle2.jpg?17610959500716915940',
      comment: 'Love my trike — feel free to post my pictures!'
    },
    {
      name: 'Debra-Diane',
      date: 'December 18, 2018',
      title: 'Rudolph led the way!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Debra-Diane-Liberty-Trike-Electric-tricycle.jpg?5312331461185911257',
      comment: 'My neighborhood just had it\'s Christmas Golf Cart Parade; I decorated my trike and rode in it (4.1 miles around the entire golf course plus 2 miles EACH WAY from my house to the Clubhouse to start!)  Had a blast!  Pix attached; Rudolph let the way! Thanks for coming up with something for us who have some "mobility challenges" to be able to get around.'
    },
    {
      name: 'Brad S.',
      date: 'November 13, 2018',
      title: 'I Prefer to Think of it as my Liberty Truck!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/brad_s-LibertyTrike.jpg?11813484716476056288',
      comment: 'At my age, I\'m not too thrilled with talking about my "Tricycle"! I prefer to think of it as my Liberty Truck! I have depended on two different electric bicycles to get groceries and run errands for the last 6 years, 365 days a year, in all sorts of weather. Now I have greater capacity!'
    },
    {
      name: 'Michael B.',
      date: 'November 5, 2018',
      title: 'The Company Stands Behind what they Produce and Offers Constant Support.',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Michael_B-Liberty-Trike-Electric-tricycle.jpg?4084828410705645292',
      comment: 'Three years ago I had lost my sense of balance , fell  on my 2-wheel bike and broke my collar bone. I focused on other activities until I learned about Liberty Trike. This has opened new vistas for me. I can enjoy the fun of seeing nature at a slower pace and still enjoy the breeze in my face. We have a 20 mile bike path near us through beautiful trees and creeks and with views of mountains. I have put 580 miles on the trike in 6 months. The trike is well designed and really sturdy. I can do about 18 miles round trip with just a little pedaling. It is great for a 74 year old guy like me. The Company stands behind what they produce and offers constant support.  I\'m really happy with my purchase.'
    },
    {
      name: 'Yolanda T.',
      date: 'October 28, 2018',
      title: 'Riding around Benicia State Park, CA',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/D-Tost-Liberty-Electric-Trike.JPG?9829475776928439812',
      comment: 'Received this as an Anniversary present. Really a fun trike to ride, first day took it to Benicia State Park by San Francisco Bay.'
    },
    {
      name: 'Lori V.',
      date: 'October 23, 2018',
      title: 'My Niece Borrowed my LT',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LoriV-Liberty-Trike-Electric-Trike.png?15184099663772028109',
      comment: 'My Niece broke her foot playing basketball. So borrowed my LT to go around temple Square in Salt Lake City. My nephews had to join the fun too.'
    },
    {
      name: 'Patsy R.',
      date: 'October 22, 2018',
      title: 'Easy peasy, and boy is it fun to ride',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/PatsyR-Liberty-Trike-Electric-Trike.png?13884658860874159071',
      comment: 'My pit crew got my new trike put together. Easy peasy, and boy is it fun to ride. Can\'t get Jacob off the thing. Rides awesome on the floor of the museum where I work, got a decent run around the 45,000 square foot place today. I was afraid my staff was going to slowy shaking their head at the wierdo boss lady, but, nope everyone took a turn and wanted to help.'
    },
    {
      name: 'Mary FG.',
      date: 'September 14, 2018',
      title: 'LT may get some orders from Navajo Land! It was a hit!!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/MaryFG-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'Yea! Lady and I at Four Corners Monument in Navajo land. Did a lot of shopping and visiting. LT may get some orders from Navajo Land! It was a hit!! The more I ride, the better I get and the more I love it!!! Now off to the Grand Canyon!'
    },
    {
      name: 'Mary A.',
      date: 'September 12, 2018',
      title: 'Here is my little Beauty, Yes, I am In Love with it.',
      score: 3,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/MaryAnn-2-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'Here is my little Beauty, Yes, I am In Love with it, looking forward to doing things that have been too difficult for me to do for awhile, (walking distances is hard for me) Love the color for visibility.'
    },
    {
      name: 'Tom B.',
      date: 'September 8, 2018',
      title: 'This thing is wonderful.',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/TomB-2-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'I haven’t driven anything in years because of diabetic eye surgery. This thing is wonderful. Do you think they’re going to see me coming?'
    },
    {
      name: 'Michelle C.',
      date: 'August 28, 2018',
      title: 'Just loving my Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/MichelleCVF-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'Received my Liberty Trike on Thursday and spent 3 1/2 hrs putting it together! Too stubborn to wait for help so I poked a little hole in the rear basket mesh, trying to tilt and lift out of the box. I knew better but what can I say...that\'s just me! Here I am riding "Batman" with my little dog Ticket in the rear basket. I\'ve put over 10 miles on it since Friday and I\'m so disappointed that it\'s raining today. Ticket gets to run along side also but he can have a break riding. Just loving my Liberty Trike!'
    },
    {
      name: 'Lorraine B.',
      date: 'August 22, 2018',
      title: 'All my dogs want a turn!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LorraineB-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'I took my new pink Liberty trike out on my long driveway and the road today with one of my dogs attached to it. It worked fantastic! Actually, much better than I expected! Here are some pictures of one of my dogs attached to the trike with a Walky Dog bike leash attached to an Xtreme pet products stretch security leash in pink. The section of stretch leash is attached to a pink Pug Life Harness. I leave the detachable leash handle in the trike basket so it\'s there when I need a regular leash setup. Please ignore my weedy yard in the photos. I use to keep it well groomed till I injured myself. All my dogs want a turn!'
    },
    {
      name: 'Linda H.',
      date: 'August 17, 2018',
      title: 'Thank you LT for an awesome trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/LindaH-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'We went to the Boise River Greenbelt this week and I got to go biking on my new Liberty Trike with my grandsons! We had so much fun! Thank you LT for an awesome trike! I thought my biking days were over!'
    },
    {
      name: 'Julie X.',
      date: 'August 12, 2018',
      title: 'Okay... here is my bike.',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JulieXA-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'Okay... here is my bike. The other photo I posted was just a stock photo to show the color I ordered. Received my helmet so I\'m good to go...'
    },
    {
      name: 'Julie S.',
      date: 'August 11, 2018',
      title: 'My LT',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JulieSP-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'This is my Bike'
    },
    {
      name: 'Ann L.',
      date: 'August 7, 2018',
      title: 'That’s me on my Liberty!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/AnnL-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'That’s me on my Liberty!'
    },
    {
      name: 'Jan J.',
      date: 'August 4, 2018',
      title: 'I love my new LT and the grandkids love racing Gramma.',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/JanJ-2-Liberty-Trike-Electric-Trike.png?8322281164129190957',
      comment: 'It was so fun to be able to ride with my grandkids while glamping with them. I love my new LT and the grandkids love racing Gramma.'
    },
    {
      name: 'Lisa T.',
      date: 'July 25, 2018',
      title: 'Well, I Was Standin on the Corner in Winslow Arizona.....',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/lisa-t-winslow.jpg?12299524508761583084',
      comment: 'It seems like the Liberty Trike is going to be a keeper! I\'m a solo full-time RVer, so I have to be able to manage everything by myself. I\'m also only 4\'11" and not very strong. I don\'t have any health issues other than weak hands and fingers. I\'m almost 70.<br><br>I was thrilled that I could get my Trike out of the box at the UPS store and onto my truck. I had a lot of trouble inserting the handlebars into the steer shaft, but the rest went smoothly. I was especially happy that I could connect the 2 halves (major selling point for me).<br><br> I can lift each half up 4 stairs into and out of the RV. Not easy, mind you, but doable. Each half is about 25 lbs. I carry the seat, baskets and battery separately.<br><br> First attempt at riding was me wobbling all over the road. Then I discovered that you only need to turn the wheel ever so slightly! In other words, don\'t over-correct. I still feel like I\'m going to tip over, but I\'m confident that I won\'t. Trust your Trike.<br><br> I hope my story gives others who may be small, weak, and/or solo, the confidence that it can be done and you can enjoy a Liberty Trike if you have a can-do attitude. There\'s a ton of support and information in this group, on YouTube, and from Liberty Trike. - Best birthday present I ever got for myself!'
    },
    {
      name: 'Brian J.',
      date: 'July 19, 2018',
      title: 'When I called, I was treated with calm, kind and knowledgeable responses.',
      score: 5,
      image: '',
      comment: 'Thank you for your assistance with my Liberty Trike. I was concerned about the problem I faced when it would not run. When I called, I was treated with calm, kind and knowledgeable responses. You were prompt in defining my needs and sent the part I needed. I was able to replace the part and was back on the road in a matter of minutes. I also appreciate the ability to track the package as it was shipped. This is wonderful since it removes unnecessary trips to the post office.<br>When I tell people about my Liberty Trike, I have always told them about you; the people that I have dealt with. You have been wonderful, considerate and actually friendly. Thank-you for being who you are.  Happy to be on the road again.'
    },
    {
      name: 'Kathy D.',
      date: 'July 17, 2018',
      title: 'Garage Saling',
      score: 3,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/kathy-d-lt-shopping.png?9546052648091831898',
      comment: 'Went garage saling with my trike. What a blast! I just love it.'
    },
    {
      name: 'Trudy D.',
      date: 'June 22, 2018',
      title: 'I love it!!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/trudy-liberty-trike.jpg?5182994202164448782',
      comment: 'I received my Liberty Trike on Wednesday, June 20, 2018. I love it!!I’ve only ridden around my neighborhood at the moment but soon I will be taking it downtown to New Orleans and enjoying the French quarter.'
    },
    {
      name: 'Ada R.',
      date: 'June 11, 2018',
      title: 'Loving my Trike!!',
      score: 3,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Ada-purple-liberty-trike-sized.jpg?15584232513421996475',
      comment: 'Loving my Trike!! My purple “girl” is attracting a lot of attention in the community where I live. After my Trike, there are 2 more Liberty Trikes, a red one and other blue. Was told a neighbor ordered a pink one. Thank you Liberty Trike for changing the life of many people and for the extra business cards!'
    },
    {
      name: 'Heidi M.',
      date: 'June 11, 2018',
      title: 'Just wanted you to know how thrilled we are with this trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/HeidiM-Moms-LT.jpeg?3059710838666242176',
      comment: 'Just wanted you to know how thrilled we are with this trike! My husband and I purchased this trike so my mother could join us on bike rides - so many great bike trails on Cape Cod. I wanted a bike that I could transport easily by myself if necessary, and this fits the bill. I am fairly strong and it does take all my strength to lift it into our vehicles, but I can do it so we are free to ride any time. One issue that we have had on the rides - we cant go very far without being stopped and asked about the bike. I think you may have a fairly large interest on Cape Cod. We have had so many questions and love the bike so much that we would be willing to hand out a card or brochure for you. I was very impressed with all the available video support for any question that could possibly ever be asked. I am ordering a second battery and charger because we will most definitely be riding more than 10 - 15 miles! This is a photo of my mother (86) riding on the Shining Sea Bike Path today.'
    },
    {
      name: 'Charles W.',
      date: 'June 10, 2018',
      title: 'Wow, just WOW! Had my trike two weeks. A delight.',
      score: 5,
      image: '',
      comment: 'Wow, just WOW! Had my trike two weeks. A delight. I am 82 years OLD! Took it out of the box and had it going in half an hour. My grandson (10) was here and helped - noted that it was orange - his favorite color.  Indicated to him that someday it would be his. His quote upon seeing it "Chuck, you have no idea how much I need this. When I ride my bike down to Grammas and Paws Paws house to swim, I get very tired coming home... paternal grandparents - maybe 3 blocks away and flat ground)!  Loving it and now exploring places I can go with my arthritic knees. Thanks so much.'
    },
    {
      name: 'Isabella M.',
      date: 'June 8, 2018',
      title: 'Exceptional Trike Experience',
      score: 4.8,
      comment: 'My Liberty Trike has provided me with an exceptional riding experience. The electric assistance is smooth and reliable, and the trike\'s overall performance is outstanding. Love every moment with it!',
    },
    {
      name: 'Daniel S.',
      date: 'June 6, 2018',
      title: 'Great Trike for Everyday Use',
      score: 4.8,
      comment: 'The Liberty Trike is perfect for everyday use. It\'s comfortable, efficient, and the electric assistance is a game-changer. Highly recommend for anyone looking for a reliable and versatile trike.',
    },
    {
      name: 'Sophia L.',
      date: 'June 4, 2018',
      title: 'Reliable and Stylish',
      score: 4.8,
      comment: 'My Liberty Trike combines reliability and style. It\'s a head-turner on the streets, and the trike itself is built to last. The electric motor performs flawlessly, providing a smooth and enjoyable ride.',
    },
    {
      name: 'Oliver H.',
      date: 'June 2, 2018',
      title: 'Impressed with the Electric Assistance',
      score: 4.8,
      comment: 'I\'m thoroughly impressed with the electric assistance of my Liberty Trike. It provides the perfect amount of power, and the battery life is exceptional. Highly satisfied with my purchase!',
    },
    {
      name: 'James B.',
      date: 'May 31, 2018',
      title: 'Excellent Investment',
      score: 4.9,
      comment: 'My Liberty Trike has been an excellent investment. The quality and performance exceed my expectations. It has become my preferred mode of transportation. Thank you for a fantastic product!',
    },
    {
      name: 'Ava M.',
      date: 'May 29, 2018',
      title: 'Enjoyable Riding Experience',
      score: 4.7,
      comment: 'Riding my Liberty Trike is a pure joy. The electric assistance provides the perfect amount of boost, and the trike\'s design ensures a comfortable and enjoyable experience. Love every moment with it!',
    },
    {
      name: 'Noah G.',
      date: 'May 27, 2018',
      title: 'Smooth and Reliable Performance',
      score: 4.8,
      comment: 'My Liberty Trike offers a smooth and reliable performance. The electric motor kicks in seamlessly, and the trike\'s stability and build quality inspire confidence. Highly recommended for all riders!',
    },
    {
      name: 'Lily T.',
      date: 'May 25, 2018',
      title: 'Unleashing My Adventurous Side',
      score: 4.8,
      comment: 'The Liberty Trike has unleashed my adventurous side. I can now explore off-road trails and enjoy nature. The trike\'s durability and electric motor make it an excellent companion for outdoor adventures.',
    },
    {
      name: 'Ethan P.',
      date: 'May 23, 2018',
      title: 'Perfect for Commuting',
      score: 4.8,
      comment: 'My Liberty Trike is perfect for daily commuting. It\'s compact, maneuverable, and the electric assistance helps me navigate through traffic effortlessly. Highly satisfied with its performance and convenience.',
    },
    {
      name: 'Emma L.',
      date: 'May 21, 2018',
      title: 'Outstanding Customer Service',
      score: 4.9,
      comment: 'The Liberty Trike\'s customer service is outstanding. The team is responsive, knowledgeable, and went above and beyond to address my inquiries. Thank you for the exceptional support!',
    },
    {
      name: 'Stacy A.',
      date: 'May 19, 2018',
      title: 'Thank you so very much! I love my new Hot Pink Liberty Trike',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/stacya-pink-LT-sized.jpg?7341065500165696072',
      comment: 'Thank you so very much! I love my new Hot Pink Liberty Trike. I had a regular Adult 6 Speed Tricycle which I could not ride very far due to arthritis in my both knees and both hips. Now with my Liberty Trike I can go bike riding with my husband and keep up with him for long distances.'
    },
    {
      name: 'Caleb H.',
      date: 'May 19, 2018',
      title: 'Stylish and Reliable',
      score: 4.7,
      comment: 'My Liberty Trike combines style and reliability. It turns heads wherever I go, and the trike itself is built to last. The electric assistance is smooth, and the ride quality is top-notch. Love it!',
    },
    {
      name: 'Sofia M.',
      date: 'May 17, 2018',
      title: 'Excellent Electric Trike',
      score: 4.9,
      comment: 'I\'m extremely impressed with my Liberty Trike. The electric motor provides a boost when needed, and the battery life is outstanding. The trike\'s build quality and design are exceptional. Highly recommended!',
    },
    {
      name: 'Gabriel B.',
      date: 'May 15, 2018',
      title: 'Versatile and Fun to Ride',
      score: 4.8,
      comment: 'The Liberty Trike is versatile and incredibly fun to ride. I can effortlessly switch between electric and pedal-assisted modes. The trike\'s maneuverability and stability make it perfect for urban commuting and leisurely rides.',
    },
    {
      name: 'Natalie G.',
      date: 'May 13, 2018',
      title: 'Effortless Riding Experience',
      score: 5,
      comment: 'My Liberty Trike offers an effortless riding experience. The electric assistance kicks in seamlessly, and I can enjoy longer rides without fatigue. Highly satisfied with its performance and reliability.',
    },{
      name: 'Paul B.',
      date: 'May 12, 2018',
      title: 'Did not work out, but a great product.',
      score: 5,
      image: '',
      comment: 'I ordered a Liberty in hopes my mother would get out and about a little more.  She could not be convinced to try it.  I contacted the company to make a return and they were supper cooperative, sent me a UPS mailing label and made no hard sell to keep the trike.  I was impressed by the quality and stability of the build.  Plenty of power to zip me (170 lbs) around the neighborhood. Very stable and easy to ride.  For shorter people its ideal as the seat will adjust very low, much more so than any other trike I looked at.'
    },
    {
      name: 'William K.',
      date: 'May 11, 2018',
      title: 'Exceptional Quality and Reliability',
      score: 4.8,
      comment: 'The Liberty Trike stands out in terms of quality and reliability. It\'s built to last, and the components are well-made. The electric motor performs flawlessly, providing a smooth and enjoyable ride.',
    },
    {
      name: 'Olivia S.',
      date: 'May 9, 2018',
      title: 'Freedom to Explore New Places',
      score: 4.8,
      comment: 'With my Liberty Trike, I have the freedom to explore new places with ease. The electric assistance allows me to ride for longer distances, and the trike\'s maneuverability is impressive. Love it!',
    },
    {
      name: 'Benjamin L.',
      date: 'May 7, 2018',
      title: 'Fantastic Electric Trike',
      score: 5,
      comment: 'I\'m having a fantastic experience with my Liberty Trike. The electric motor provides the perfect amount of assistance, and the trike\'s stability gives me peace of mind. Highly recommended!',
    },
    {
      name: 'Sophia H.',
      date: 'May 5, 2018',
      title: 'Smooth Ride and Great Comfort',
      score: 4.7,
      comment: 'The Liberty Trike offers a smooth and comfortable ride. The seat is supportive, and the electric assistance makes pedaling a breeze. I\'m impressed with its quality and overall performance.',
    },
    {
      name: 'Henry M.',
      date: 'May 3, 2018',
      title: 'Impressive Performance on Trails',
      score: 4.9,
      comment: 'Took my Liberty Trike on a trail ride, and it performed exceptionally well. The electric motor handled inclines effortlessly, and the trike\'s stability gave me confidence. Highly recommend for outdoor adventures!',
    },
    {
      name: 'Emily R.',
      date: 'May 1, 2018',
      title: 'Amazing Trike Experience!',
      score: 5,
      comment: 'My Liberty Trike has provided me with an amazing riding experience. The electric assistance is smooth and reliable, and the trike itself is well-built. Highly satisfied with my purchase!',
    },
    {
      name: 'Gusto B.',
      date: 'May 1, 2018',
      title: 'Happy 80th!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Gusti-sized-LT-pink.jpg?17981764142127037182',
      comment: 'Love my pink trike. Its perfect for going to pickleball and yard sales and around town. My teenage granddaughter likes it also! Thank you.'
    },
    {
      name: 'Fred E.',
      date: 'April 24, 2018',
      title: 'Already put 80 miles on it',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Liberty-Electric-Tricycle-Fred_E.jpg?105322647901503327399',
      comment: 'Got mine 3 weeks ago already put 80 miles on it.'
    },
    {
      name: 'Kathy O.',
      date: 'April 13, 2018',
      title: 'I Love It!!!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/kathyolt.jpg?6113627955511889589',
      comment: 'I received my teal trike today!!! I love it!!!'
    },
    {
      name: 'Marie T.',
      date: 'April 12, 2018',
      title: 'I went to the warehouse!',
      score: 4,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/20180405_141220.jpg?10958067556811466182',
      comment: 'My husband and I went to Liberty Trike Warehouse in Croydon, Pa. yesterday! It is about a 2 hour drive from our home. I had e-mailed ahead and asked if it would be ok to visit and we were welcomed. The people who work there are so friendly and helpful...we had the pleasure of meeting Jason Kraft and we were beyond impressed.'
    },
    {
      name: 'Jana G.',
      date: 'April 11, 2018',
      title: 'Sorry, not sorry',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/janagteal.jpg?5915699165718556086',
      comment: 'Sorry my hair is mess but we finally had a warm day in Ohio but windy, so I road down my driveway.'
    },
    {
      name: 'Judy K.',
      date: 'April 10, 2018',
      title: 'Thanks so much!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/judykpink.jpg?12226941737912877552',
      comment: 'Thanks so much to my husband and daughter and the weather, I finally got to ride my LT outside!'
    }, 
    {
      name: 'Darlene M.',
      date: 'March 15, 2018',
      title: 'Trike',
      score: 5,
      image: '',
      comment: 'So excited with my trike. Just love it. It\'s perfect. Thank you. Now can’t wait to use it everyday. Customer service is great. Not 1 complaint. My trike  arrived in perfect condition. ❤️❤️❤️❤️.'
    }, 
    {
      name: 'Diane P.',
      date: 'March 13, 2018',
      title: 'Really good news',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Diane_Poris.jpg?11594307776280368810',
      comment: 'I entered a contest with the Liberty Trike Company and look what I WON. I entered so when I went to Raceway for the nationals I would not have to rent one. I was blown away and could not believe I won but it is here now so it was true. It has a battery or for exercise it has pedals. I really like my new trike. It is good exercise.'
    }, 
    {
      name: 'Steven G.',
      date: 'March 12, 2018',
      title: 'My utter and complete satisfaction with Liberty Trike',
      score: 5,
      image: '',
      comment: 'Let me start off by conveying my frustration with the way myself and my friends get abused by customer service representatives and the companies they work for. Maybe abused is too strong of a term to describe the lack of efficiency and caring I receive with my dealings in life. The Liberty Trike company and its employees that I have been in contact with have been so professional and have handled my concerns and my purchase perfectly. Just as I feel I should be treated. I had a concern with a very small slit on my sidewall and no questions asked, they sent me a new tire. My experience was and continues to be excellent. I strongly recommend anyone to do business with them.'
    }, 
    {
      name: 'Kathy O.',
      date: 'March 9, 2018',
      title: 'My new teal ride',
      score: 5,
      image: '',
      comment: 'I received my teal trike today! I love it! It\'s a real pretty teal and I\'m surprised how easy and smooth it is to ride as a single speed. Everything I want or need is within 4 miles of my house. I\'ll probably rarely use my car. And Colorado weather is gorgeous!'
    }, 
    {
      name: 'Jennie M.',
      date: 'March 5, 2018',
      title: 'Great way to get around',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Jennie_M.jpg?17907316938774127596',
      comment: 'My trike arrived at my RV Campground. Easy to put together! I don’t have a car down here so used it to go for groceries today and then took a spin through the bird sanctuary. I love it!'
    }, 
    {
      name: 'Deb P.',
      date: 'March 1, 2018',
      title: 'Perfect for me',
      score: 5,
      image: '',
      comment: 'I am younger, but have a very seriously crippled foot, and a spinal cord stimulator because of severe nerve damage. The foot is slightly slanted upward (surgical horror), so I have poor balance and cannot walk unaided. I LOVE my trike.'
    }, 
    {
      name: 'Randy D.',
      date: 'February 27, 2018',
      title: 'Wife is so happy',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/004.jpg?2863306610156924195',
      comment: 'Out for a ride at St. Andrews State Park, Panama City Beach. This is far better than the ice storm we left behind last Sunday in Missouri!! Additions to trike: Incredibell bike bell, Mirrycle bike mirror, headlight & taillight, motorcycle clamp-on foot pegs to front fork (my wife has knee trouble & the pegs allow her to straighten her legs out when in electric mode), Sun EZ3 recumbent seat saddle. Thanks Liberty Trike. We really enjoy your product and will recommend you to others. Someday I\'ll either order myself a Liberty or get your kit to electrify my Sun USX.'
    }, 
    {
      name: 'Darlene M.',
      date: 'February 18, 2018',
      title: 'Great purchase',
      score: 4,
      image: '',
      comment: 'I love it! It’s just perfect. Going for my first ride today, so excited. Thank you for all the hard work that was put into making this trike. Well built. I will recommend Liberty Trike to everyone. You’re the best.'
    }, 
    {
      name: 'Barbara S.',
      date: 'February 12, 2018',
      title: 'Sparks a lot of interest',
      score: 5,
      image: '',
      comment: 'I have taken my trike to the state fair where it got as much attention as the exhibits. Today we went to a local farm open house where it also got lots of attention. I need more business cards to give out now!'
    }, 
    {
      name: 'Stephen B.',
      date: 'February 2, 2018',
      title: 'Much better than a wheelchair',
      score: 5,
      image: '',
      comment: 'I\'m so excited about receiving my new Liberty Trike.  I\'m an older guy who has returned to school recently.  The wheelchair my doctor prescribed for me simply couldn\'t meet the daily grind necessary to handle my schedule.  After 6 months, I began to experience issues with the wheelchair device.  I feel confident my Liberty Trike is exactly what I need and have been looking for all along.  I suffer from congestive heart failure and pulmonary hypertension both of which basically steal my breath away.  I refuse to give up on achieving my goals though, and I know my Liberty Trike will be the key to my future success.  Thank you so much.'
    }, 
    {
      name: 'Sally J.',
      date: 'January 29, 2018',
      title: 'My New Harley',
      score: 5,
      image: '',
      comment: 'My new Liberty Trike is assembled and I have already been out for a spin around the neighborhood, not using the battery. It’s so much fun—I love it. There are some adjustments to learn as it is definitely different than a 2 wheeler. Doesn’t take long though.'
    }, 
    {
      name: 'Pamela L.',
      date: 'January 16, 2018',
      title: 'No more limitations',
      score: 5,
      image: '',
      comment: 'I got my trike because I have COPD and CHF among other health issues. I was unable to go on the many trails in the beautiful city where I live because I was just unable to walk very far without having to sit down. Benches on bike and walking trails are sometimes few and far between. Now my trike gives me the freedom to explore places I thought I would never be able to go again. The freedom along with the time spent in the outside air and sunshine are such a health boost. I think these should be covered by insurance because I am sure they improve the health and mood of the people who are out riding who would otherwise be indoors with no activity. So many people have posted about their limitations and how the Liberty Trike has brought them so much happiness and more opportunity. I think anyone who wants one should be able to use it and enjoy it.'
    }, 
    {
      name: 'Rita G.',
      date: 'January 10, 2018',
      title: 'Best medicine',
      score: 5,
      image: '',
      comment: 'Love the trike! At 77+ and being a cancer survivor, it’s great to be able to get outside without wearing myself out. I have the purple trike. I did manage to get a scratch on the frame but ordered some touch up paint. I aim to keep it pretty!'
    }, 
    {
      name: 'Joyce G.',
      date: 'January 5, 2018',
      title: 'Gets me out of the house',
      score: 5,
      image: '',
      comment: 'I am 80 years old with C.O.P.D., arthritis, and diabetes. I have balance problems and I am unable to lift my left foot very high. I have had 4 mini strokes and I have had no trouble riding. I love my trike! It\'s better than sitting by the window watching the world go by when you could be out riding. I carry a cell phone and have a life line. I also carry I.D. just in case. It has all my medical numbers on it and who to call in case of an emergency.'
    }, 
    {
      name: 'Donna F.',
      date: 'January 2, 2018',
      title: 'Great for my mom',
      score: 5,
      image: '',
      comment: 'My mom is 93, mostly blind and a little off balance. She can ride my trike without a problem. You can adjust the speed so that it never goes over six miles an hour in its highest speed. Two miles an hour is a brisk walk pace by comparison.'
    }, 
    {
      name: 'Karen P.',
      date: 'December 27, 2017',
      title: 'Better than my electric wheelchair',
      score: 5,
      image: '',
      comment: 'I am 67 and cannot walk very far at all, maybe 10 ft at a time, I ride it 4 miles a day to the Walmart and Kroger’s. They let me in on my bike just like my electric wheelchair.'
    }, 
    {
      name: 'Debra W.',
      date: 'December 21, 2017',
      title: 'Best way to get around',
      score: 5,
      image: '',
      comment: 'I am loving my trike. After talking with the Liberty folks my sister helped me get a 3-speed gear for pedaling so I can go a bit faster in our bike lanes. I had it installed at a local bike shop. It works perfectly and is a great way to get around in SF! I love my Liberty Trike. And the best customer service with these folks. Thank you!'
    }, 
    {
      name: 'Pat N.',
      date: 'December 12, 2017',
      title: 'Great for Seniors',
      score: 3,
      image: '',
      comment: 'Hats off to Liberty Trike for designing a small trike for us seniors who need a little extra help but don’t want one of those mobility scooters! We may be getting older but we still like to be stylish! Lol...and Liberty Trike has accomplished this for us.'
    }, 
    {
      name: 'Johanna J.',
      date: 'December 7, 2017',
      title: 'Best customer service!',
      score: 5,
      image: '',
      comment: 'Liberty Trike\'s awesome customer service comes through again! They just walked my husband through the process of moving the throttle from the right to the left so now I can ride without bothering my tendinitis. You guys really are the best!'
    }, 
    {
      name: 'Cathie C.',
      date: 'December 4, 2017',
      title: 'Back riding after 20 years!',
      score: 3,
      image: '',
      comment: 'Took my trike out for its maiden voyage today! It was great fun. It\'s such a gorgeous day here in RI and it was a joy to be out on the Blackstone Valley Bikeway. I have MS and haven\'t been able to bike for 20 years. My husband loves to bike and we thought we\'d never bike together again. I guess we were wrong.'
    }, 
    {
      name: 'Helen S.',
      date: 'November 27, 2017',
      title: 'Thankful for my trike',
      score: 5,
      image: '',
      comment: 'I have been riding my trike for over year, matter of fact I was one the first 100 people to buy this trike. It has been a joy at first riding all over Davidson, NC now we moved to Chapel Hill, and enjoying riding to local stores uphill with my assist and coming back from the stores without using assist or pedaling, downhill. Once I felt I was going so fast that when I got to the bottom of a hill, I had to come to a complete stop because I could not use the throttle to boost me up the final hill, no problem, I just started over. It would have been scary if I was riding in the street, since it is busy but I am able to use the sidewalks most of the time. I have used my phone to video once to show my sister in Long Island the beautiful scenery of our neighborhood with all the beautiful trees, especially turning colors of fall. This riding for me is a blessing, only a couple of years ago, I hadn’t been active at all. Being semi handicap, I have to use two canes or my walking chair due to arthritis and loss of balance. I am thankful I can get out on my trike. I have not had any problems with my trike and was fortunate to win the extra battery and free shipping when we bought it.'
    }, 
    {
      name: 'Michelle V.',
      date: 'November 21, 2017',
      title: 'Just Loving my Liberty Trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/23674846_10211030905387819_624425172268186562_o.jpg?12298855747466258579',
      comment: 'Received my Liberty Trike on Thursday and spent 3 1/2 hrs putting it together! Too stubborn to wait for help so I poked a little hole in the rear basket mesh, trying to tilt and lift out of the box. I knew better but what can I say...that\'s just me! Here I am riding "Batman" with my little dog, Ticket in the rear basket. I\'ve put over 10 miles on it since Friday and I\'m so disappointed that it\'s raining today. Ticket gets to run along side also but he can have a break riding.'
    }, 
    {
      name: 'Jack C.',
      date: 'November 18, 2017',
      title: 'Feeling grateful',
      score: 4,
      image: '',
      comment: 'I am so grateful for my e-trike! Great exercise with the motor when I need it. I can once again exercise without pain. Thank you, great product!'
    }, 
    {
      name: 'Brian J.',
      date: 'November 14, 2017',
      title: 'The way to roll',
      score: 5,
      image: '',
      comment: 'The Liberty Trike is definitely the way to roll. I have been so pleased with my Liberty Trike. I get around town easier and can run most of my own errands. I have also taken my Liberty Trike with me to other locales by breaking it down and transporting it in the trunk of the car. Participating in a festival in Stoughton, Wi. I have been to the St. Louis Zoo twice. It is wonderful to be with my grandsons as we explore the confines of the zoo together. The Liberty Trike has given me freedom to be part of life again. Thank you Liberty Trike.'
    }, 
    {
      name: 'Rob S.',
      date: 'November 5, 2017',
      title: 'Fantastic Customer Service',
      score: 5,
      image: '',
      comment: 'We recently purchased a Liberty trike.  During transport, the shipper damaged the cardboard shipping crate and subsequently, the trike.  I called Liberty\'s service department who proactively provided overnight replacement parts.  The next day their chief tech Facetime\'d me and guided me through the instructions to get the bike back to new.  He even emailed us a link to a custom "how-to-fix-it" video on YouTube. The bike now works perfectly and all we lost was a day.  Never, has anyone jumped through as many hoops as Liberty did for us to ensure our experience was satisfactory.  Remarkable!'
    }, 
    {
      name: 'Rosalind F.',
      date: 'November 2, 2017',
      title: 'Such Fun!',
      score: 5,
      image: '',
      comment: 'I was away when my trike arrived, and so today was inauguration day! It was much easier to pedal than I even expected... no hip or knee discomfort! I pedaled around the neighborhood, and even braved a hill. I "played" around with it for over an hour, and only stopped because I ran out of time. What glorious fun!'
    }, 
    {
      name: 'Pat F.',
      date: 'October 24, 2017',
      title: 'Great gift for my daughter',
      score: 3,
      image: '',
      comment: 'My daughter is 26 and has Down syndrome. She rides very successfully and loves her trike!'
    }, 
    {
      name: 'Yvonne G.',
      date: 'October 20, 2017',
      title: 'Cruising Along!',
      score: 5,
      image: '',
      comment: 'I have a Brain Injury and many cognitive issues, and I\'m finding the trike to work for me. I struggle a bit with the setting on the monitor think but other than that, I\'m cruising along.'
    }, 
    {
      name: 'Deb P.',
      date: 'October 17, 2017',
      title: 'Very easy to ride!',
      score: 3,
      image: '',
      comment: 'It\'s not difficult. I always start on the lowest speed and when I begin going uphill, I will go to the second speed. The trike has 5 speeds all together, and if you have any concern about going too fast, you can program the Liberty Trike not to go over a certain speed. It has both hand brakes and coaster brakes, so don\'t worry! You don\'t need good balance because you are on 3 wheels. It will give you a wonderful sense of independence and freedom.'
    }, 
    {
      name: 'Carol G.',
      date: 'October 13, 2017',
      title: 'Just Plain Fun!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/22489671_532742060393282_8935850834458810283_n.jpg?8700694460187535516',
      comment: 'We recently finished our last camping trip for this season and having my Trike to ride around the grounds made it so much more enjoyable. I was able to “visit” other sections of the area that would not have been possible if I had to do it on foot. No stress, no strain...just plain fun! I’m hoping that there will be many more good riding days before I have to put Blackbird into hibernation for the winter. Autumn is a beautiful season here in NH so I should be able to enjoy it for several more weeks. This pic was taken at the last campground and the smile on my face shows how much I was enjoying it.'
    }, 
    {
      name: 'Marie C.',
      date: 'October 11, 2017',
      title: 'Feeling like a kid again!',
      score: 5,
      image: '',
      comment: 'I absolutely love mine!! I haven\'t been on a bike for decades but got right on this and took off! It\'s so much fun that I feel like a little kid again. I got a mirror so I can see what\'s going on behind me so I feel safer and a cell phone holder so it\'s always with me. I got mine around the end of august first of september and have 94 miles on it!!! We went camping this past weekend and I put 19 miles on it in 4 days. Pull the trigger and you\'ll feel years younger and have a blast!'
    }, 
    {
      name: 'LaRienne M.',
      date: 'October 4, 2017',
      title: 'Loving it!',
      score: 5,
      image: '',
      comment: 'Just bought mine and loving it. I named my trike Dark Knight because it’s black. I am 5\'2," I have to sit all the way back on the seat and I readjusted my handlebars now it\'s good. My husband is 6\'3 he sat and rode mine but had to lift the seat and handle bars way up, he looked a little big for it but he loved my bike and he has a regular e-bike.'
    }, 
    {
      name: 'Thomas R.',
      date: 'September 26, 2017',
      title: 'Win-win',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Tom-Regan.png?2891156274091175852',
      comment: 'The Liberty Trike is great especially when getting about is difficult. Pedal for the exercise. Relax with the electric power, a definite win-win.'
    }, 
    {
      name: 'Jennifer F.',
      date: 'September 22, 2017',
      title: 'Awesome!',
      score: 3,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/21369293_1420956324624371_4284518932066795547_n_d58a8c9a-fc5d-4e86-8b4d-515a536e579b.jpg?12829961054632692222',
      comment: 'Inaugural ride in the books! 3.4 miles on the Mickelson Trail in Custer SD. It was awesome to be able to ride with my husband! He rides a Rad Mini e-bike, so he gave me a crash course on how to operate everything, and rode behind me on the trail. Reminded me of my first time on a bike as a kid with my Dad running along beside me! Thank you, Liberty!'
    }, 
    {
      name: 'Robert P.',
      date: 'September 20, 2017',
      title: 'Thanks Liberty',
      score: 4,
      image: '',
      comment: 'Just got back from the State College, PA area. Had a wonderful time on the Rail to Trails Lower Trail. Noticed that I now have almost 60 miles on my trike, without any problems. My wife and I use our trikes on our camping trips and on birding trips. It is a big help to carry my camera equipment. At almost 78 the trike has enabled us to get to some excellent bird photography areas. Thanks Liberty'
    }, 
    {
      name: 'Robin B.',
      date: 'September 19, 2017',
      title: 'This trike is fun!',
      score: 5,
      image: '',
      comment: 'This trike is fun! Riding 15-20 minutes a day. Now Up to 5mph comfortably. Doing gravel, hills, and bad roads to build confidence. This trike is fun to ride and well built. Friends who know bicycles well are impressed with the design and quality. Soon I will tackle traffic!'
    }, 
    {
      name: 'Roger P.',
      date: 'September 16, 2017',
      title: 'So much fun!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Roger_P.jpg?8886858405277432320',
      comment: 'Just got my trike put together this morning and already have 4 miles on it, this is one of the funnest things I have bought in a long time! Really is a quality trike, so enjoyable to ride.'
    }, 
    {
      name: 'Alexis D.',
      date: 'September 15, 2017',
      title: 'Quality Trike',
      score: 3,
      image: '',
      comment: 'WOW! Do I love this trike...hubby and I were out and about today him on his RadMini and me on the Liberty Trike. So much fun.... just road around the park we live in but in a few days will hit the trails. I never road a bike as a child so today did feel like one.'
    }, 
    {
      name: 'Carol G.',
      date: 'September 14, 2017',
      title: 'My birthday present to myself',
      score: 5,
      image: '',
      comment: 'I bought myself a bday present...a black Liberty Trike and named it Blackbird, because I feel free as a bird when I am riding it! Balance and coordination just ain\'t what it used to be for this 77 year old, but after a day of riding Blackbird around our paved driveway, doing circles, learning to us the handbrake, etc., I felt confident enough to head up the driveway incline very easily and onto our country road (dirt road) and was pleased with its performance. I rode just shy of a mile on my maiden voyage. Our driveway has a steep area and I admit I was not confident enough to tackle that on my return so I came to a stop and walked the Trike down to level ground. My husband and I love to camp and this is going to be so helpful in assisting me to get around campgrounds and will give me so much more freedom. I love my Blackbird and think I\'ll get ready and go "flying" again today. Thank you Liberty for the most amazing Trike.'
    }, 
    {
      name: 'Sofia M.',
      date: 'September 14, 2017',
      title: 'Enjoying the Freedom to Explore',
      score: 4.8,
      comment: 'With my Liberty Trike, I\'m enjoying the freedom to explore new places and enjoy the outdoors. The electric assistance is fantastic, and the trike is built to handle different terrains. Highly recommended!',
    },
    {
      name: 'Brian J.',
      date: 'September 13, 2017',
      title: 'Liberty Trike is the answer to my needs',
      score: 5,
      image: '',
      comment: 'The Liberty Trike is the answer to my needs. I rode a trike for about three years. I began to realize I was less able to conquer the hills and distances were not as distant as they used to be. Liberty Trike lives up to its name. The mobility side of this trike has given me the ability to be part of my grandsons\' lives. I am able to not only go to the zoo with them, I can tour the zoo and experience their excitement. I am not left out anymore. Every aspect of the Liberty Trike is 100%. I am thrilled to be on my Liberty Trike. Yes, it also looks fantastic. I get a lot of people stopping me and asking about my ride. I\'m so happy to tell them about it and field questions they have. Traveling with the Liberty Trike is easy and I know. I\'ve brought it with on two trips and enjoyed every minute. By the way. The people at Liberty Trike are great to work with. Get a Liberty Trike and enjoy life again...'
    }, 
    {
      name: 'Linda C.',
      date: 'September 12, 2017',
      title: 'Just love it!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/puppy.jpg?4741016559098694527',
      comment: 'This is Mickey in the basket. I received my Trike the 1st week of July and we have done both Rail Trails in my area (Ayer MA) and part of the Cape Cod Rail Trail. I love it! You don\'t have to put your foot down when you stop. Went over the new bridge at Route 134 in Dennisport on Cape Cod Rail Trail -had to be 30-degrees rise - didn\'t even need 5th gear! But I don\'t have any reflectors on my back wheels. Recommend getting flashers like the "big" bikes are using - some are rechargeable!'
    }, 
    {
      name: 'Rowena G.',
      date: 'September 11, 2017',
      title: 'Riding every day',
      score: 3,
      image: '',
      comment: 'I am riding my trike seven miles a day and will be adding miles each day! Really do enjoy and appreciate all the wonderful comments I receive. Thanks to all of the Liberty Trike family.'
    }, 
    {
      name: 'Laurie W.',
      date: 'September 10, 2017',
      title: 'Love it for exercising my dogs',
      score: 5,
      image: '',
      comment: 'Love my trike...use it to help exercise my high energy sporting dogs (Hungarian Vizslas) as I have knee issues. I feel much safer on this than a two-wheel bike when a dog is trotting alonside especially when there is a squirrel or cat that runs by.'
    }, 
    {
      name: 'Pat F.',
      date: 'September 9, 2017',
      title: 'Fantastic Company',
      score: 5,
      image: '',
      comment: 'I only have great things to say about the trike. The Liberty Trike Company is absolutely fantastic to work with, and they do everything to ensure customers\' satisfaction. I posted about a noise my daughter\'s trike was making and got many suggestions and support from the company.'
    }, 
    {
      name: 'Lynn R.',
      date: 'September 8, 2017',
      title: 'You won\'t go wrong ',
      score: 3,
      image: '',
      comment: 'After having previously bought a "cheaper" electric trike I can assure you that you won\'t go wrong with a Liberty. My other one is basically useless, a big waste of money.'
    },    
    {
      name: 'Deb P.',
      date: 'September 5, 2017',
      title: 'It\'s like freedom for me',
      score: 5,
      image: '',
      comment: 'I have had my Liberty Trike for less than two months and I LOVE it. I went 32 miles on my first charge. I have RSD, so I cannot ride every day because of pain, but this has been like freedom for me! I have a crippled foot and, whether you pedal or not, this trike is fabulous.'
    },
    {
      name: 'Eileen W.',
      date: 'September 1, 2017',
      title: 'Great fun or transportation',
      score: 3,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/Purple_Liberty.jpg?2129525726644098823',
      comment: 'I ordered my trike in purple and I love her. It is great for fun or transportation. Having MS, I can pedal for exercise or use the electric when I get tired.'
    },
    {
      name: 'Robert M.',
      date: 'August 29, 2017',
      title: 'Love my new trike',
      score: 4,
      image: '',
      comment: 'I got my trike about three weeks ago and love it. I have diabetic neuropathy and it gives me the freedom to cruise around the neighborhood.'
    },
    {
      name: 'Maxine R.',
      date: 'August 25, 2017',
      title: 'Best Customer Service',
      score: 5,
      image: '',
      comment: 'Once again, I want to give a shout out to Liberty Trike who offers us the best customer service. My trike was making a noise so Liberty emailed me possible solutions as well as offered to cover the cost for a bike repair shop to fix it. We took her in and will bring her back on Monday for the bearing adjustment. Thanks Liberty! Great decision to buy from this great company.'
    },
    {
      name: 'Douglas R.',
      date: 'August 23, 2017',
      title: 'Just plain awesome!',
      score: 5,
      image: '',
      comment: 'I put my red trike together yesterday and went on my first ride today. Just plain awesome. I had two knee replacements over the past four years and three foot surgeries since July 20th. The freedom to get out and about is just fantastic. Thank you, Liberty Trike!'
    },
    {
      name: 'Christy H.',
      date: 'August 20, 2017',
      title: 'I love my trike!',
      score: 5,
      image: 'https://cdn.shopify.com/s/files/1/0865/1792/files/christy-h-LT.jpg?11889864037439831966',
      comment: 'I love my trike! It allows me, in spite of arthritis, to go just about anywhere ... shopping, the bank, to restaurants or just joy-riding. Have named him Bikey Bikema (old family story). Oh, & I have recently retired down to Sarasota County, Florida.'
    },
    {
      name: 'Deb P.',
      date: 'August 18, 2017',
      title: 'It is amazing!',
      score: 3,
      image: '',
      comment: 'It is amazing! I absolutely LOVE this trike! Without going into detail, I am physically challenged by my left foot. Prior to this, I was an avid cyclist, riding 10 to 20 miles daily. I saw the Liberty Trike while visiting the zoo. I can tell you already that this is a LIFE CHANGING decision! The vey first ride made me feel like I had been freed from a cage. If you are challenged, you cannot afford NOT to get this !!'
    },
    {
      name: 'Sue L.',
      date: 'August 15, 2017',
      title: 'I bought two',
      score: 5,
      image: '',
      comment: 'I bought one last week for myself and this week I\'m buying another for my mildly disabled sister. I put it together myself. One thing seemed not to work. Excellent customer service, even after hours, identified the issue, which was simple (and my fault).Learning to ride it took under three minutes. The terrain in my neighborhood is fairly flat, but it does fine on long sloping roads. Top speed is 15 mph for me. I have a bed and breakfast, so I go to the grocery store every day. I put a bigger basket on the back, which was very easy to swap out.Having the trike is making it easy to go from two cars down to one. It will pay for itself in about a year. Again, I can\'t say enough about the customer service. Real people answer the phone, or will call you back very quickly. Emails are answered even on weekends. I got my trike within 48 hours of ordering it. My sister\'s is taking a little longer because of the color she picked. I have complete confidence that this trike will expand her horizons in a way that is safe and fun. '
    },
    {
      name: 'Joyce G.',
      date: 'August 14, 2017',
      title: 'I REALLY AM ENJOYING THE RIDES, AND GETTING OUT OF THE HOUSE.',
      score: 5,
      comment: 'I BOUGHT MY TRIKE FOR MY BIRTHDAY GIFT THIS YEAR. I REALLY AM ENJOYING THE RIDES, AND GETTING OUT OF THE HOUSE. I HAD SURGERY FOUR WEEKS AGO, SO WILL HAVE TO WAIT FOR THE DOCTORS O.K. BEFORE I CAN RIDE AGAIN. TOO BAD TOO, AS IT HAS GOTTEN SO MUCH COOLER AND I COULD RIDE EVERY DAY, NOW. MY TRIKE IS TEAL.COLOR. MY TRIKE IS "THE MINI GREEN MACHINE" MY NAME IS TRIKER GRANDMA"'
    },
    {
      name: 'Maxine R.',
      date: 'August 13, 2017',
      title: 'I just got my "Sunshine" Liberty trike on Thursday and have been out every day.',
      score: 5,
      comment: 'I just got my "Sunshine" Liberty trike on Thursday and have been out every day. I did a lot of homework and price comparisons before taking the plunge, and the Liberty Trike was extremely reasonable considering all the benefits. I feel confident riding her, and I only dropped one bar after 10 miles, so I don\'t really see the need for an extra battery, knowing it takes such a short time to recharge. I hope you are enjoying yours as much as I\'m enjoying mine. Day two on my sweet Sunshine! Loving every minute and so happy to have the freedom to cycle again at my own pace and soak in all the sights here in the beautiful Columbia Gorge where the hills are plentiful. Gotta love that throttle!',
    },
    {
      name: 'Isabella C.',
      date: 'August 3, 2017',
      title: 'Thrilled with My Liberty Trike',
      score: 5,
      comment: 'I\'m absolutely thrilled with my Liberty Trike! It\'s given me a new sense of freedom and independence. The ride is smooth and comfortable, and I can now explore places I couldn\'t before. Thank you, Liberty Trike!',
    },
    {
      name: 'Daniel M.',
      date: 'July 27, 2017',
      title: 'Great Trike for Outdoor Enthusiasts',
      score: 4.8,
      comment: 'As an outdoor enthusiast, the Liberty Trike has been a great companion. It handles various terrains effortlessly, and the electric motor provides the extra power when needed. I\'m extremely satisfied with its performance.',
    },
    {
      name: 'Sophia L.',
      date: 'July 20, 2017',
      title: 'Perfect for City Adventures',
      score: 4.7,
      comment: 'My Liberty Trike has been perfect for exploring the city. It\'s agile, compact, and the electric motor helps me navigate through busy streets with ease. The build quality is impressive, and I\'m thrilled with my purchase.',
    },
    {
      name: 'Oliver B.',
      date: 'July 13, 2017',
      title: 'Exceptional Quality and Design',
      score: 4.9,
      comment: 'I\'m impressed with the exceptional quality and design of my Liberty Trike. It feels sturdy and well-built. The ride is comfortable, and the electric assistance adds a new level of convenience. Highly recommended!',
    },
    {
      name: 'James S.',
      date: 'July 6, 2017',
      title: 'Smooth Ride and Easy to Use',
      score: 4.8,
      comment: 'The Liberty Trike offers a smooth ride and is incredibly easy to use. It\'s perfect for leisurely rides and commuting alike. I love the convenience and versatility it provides.',
    },
    {
      name: 'Ava M.',
      date: 'June 29, 2017',
      title: 'Fantastic Electric Trike!',
      score: 5,
      comment: 'I\'m having a fantastic experience with my Liberty Trike! The electric assistance makes riding effortless, and the trike is well-built and reliable. It has become my go-to mode of transportation.',
    },
    {
      name: 'Noah P.',
      date: 'June 22, 2017',
      title: 'Great Bike, Great Service',
      score: 4.5,
      comment: 'The Liberty Trike is not only a great bike but also comes with outstanding customer service. The team has been responsive and helpful throughout my purchase journey. Highly appreciated!',
    },
    {
      name: 'Lily T.',
      date: 'June 15, 2017',
      title: 'Freedom to Explore',
      score: 4.7,
      comment: 'With my Liberty Trike, I have the freedom to explore new places without limitations. It\'s easy to ride, and the electric motor provides the extra boost when needed. Couldn\'t be happier!',
    },
    {
      name: 'Ethan G.',
      date: 'June 8, 2017',
      title: 'Impressive Performance and Comfort',
      score: 4.8,
      comment: 'The performance and comfort of my Liberty Trike are impressive. I can easily navigate various terrains, and the seat provides excellent support. I\'m extremely satisfied with my purchase.',
    },
    {
      name: 'Emma W.',
      date: 'June 1, 2017',
      title: 'Loving My New Liberty Trike!',
      score: 4.5,
      comment: 'I\'m absolutely in love with my new Liberty Trike! It has exceeded all my expectations. The electric assistance is incredible, and the ride is smooth and comfortable. Highly recommended!',
    },
    {
      name: 'Brian J.',
      date: 'May 13, 2017',
      title: 'The liberty trike is all I thought it would be and more.',
      score: 5,
      comment: 'Thank you so much. The liberty trike is all I thought it would be and more. You have a fantastic product here. It is going to help me get out and around a lot more. And, it is fun to ride. All those who put this together, great job. Nicole you have been great. You have been so courteous, kind and helpful. Thank you one and all.'
    },
    {
      name: 'Brian J.',
      date: 'May 13, 2017',
      title: 'The liberty trike is all I thought it would be and more.',
      score: 5,
      comment: 'Thank you so much. The liberty trike is all I thought it would be and more. You have a fantastic product here. It is going to help me get out and around a lot more. And, it is fun to ride. All those who put this together, great job. Nicole you have been great. You have been so courteous, kind and helpful. Thank you one and all.'
    },
    {
      name: 'Ruth D.',
      date: 'May 12, 2017',
      title: 'I\'m thrilled with my new trike and so far no more problems.',
      score: 5,
      comment: 'The first trike started having problems within a few days. The customer service and technical support went above and beyond to help get the problem resolved. Calls were returned quickly and tech support even used video chat to assist in troubleshooting. Even after my son worked on it with the technician there were still issues and the company worked with me and sent a NEW trike to replace the defective one. I\'m thrilled with my new trike and so far no more problems.'
    },
    {
      name: 'Paul R.',
      date: 'April 12, 2017',
      title: 'Very high quality trike and good customer service',
      score: 5,
      comment: 'I\'m very impressed with the quality of the Liberty Trike. I also contacted them after receiving it because I had a battery question, and Jason was very helpful and answered all my questions.'
    },
    {
      name: 'Roger J.',
      date: 'April 3, 2017',
      title: 'The Liberty Trike is a joy to use',
      score: 5,
      comment: 'The Liberty Trike is a joy to use. It is very comfortable and very stable and has more than enough power. It is a very high quality machine. I ordered a yellow one for my wife and it arrived on time as promised. Assembly was quick and uncomplicated--it took us no more than 20 minutes. We like it so much that I ordered one for myself today. Liberty Trikes fold in half for easy storage, but my wife and I easily lifted the whole trike in one piece into the back of our mini van. Nice job Liberty!'
    },
    {
      name: 'Vickie S.',
      date: 'March 28, 2017',
      title: 'This really is the bike/trike of my dreams...',
      score: 5,
      comment: 'This really is the bike/trike of my dreams... So easy to operate and so quiet... even took it off road... Walking path and it performed splendidly!!  I installed a cell phone holder and bell on the handle bars and will attach my cool flag today... I\'ll send you a video soon... Thanks so much for the touch up paint!!  Thanks again... I feel like a kid again!!!'
    },
    {
      name: 'Ann K.',
      date: 'March 23, 2017',
      title: 'My trike is beyond my expectations!',
      score: 5,
      comment: 'I just thought you should know that my trike is beyond my expectations! I have now outfitted it with lights, mirrors, rain cover, dog cart hitch, hand-made basket liner, a stand to hold it steady for disconnecting and a small accessory handle bar pouch. It is all decked out for this 76 year old woman! Thank you for my wonderful birthday present!'
    },
    {
      name: 'James A.',
      date: 'February 25, 2017',
      title: 'It gave me back my mobility and freedom',
      score: 5,
      comment: 'I had been severely injured in a traffic accident in 2001. I have not walked normally since and my strength and range are very limited. I bought my Liberty Trike because I thought the ability to pedal along with the motor would allow me to exercise my legs without fearing stranding or hurting myself. Not only did the trike exceed my expectations, but by the third day I was able to take a ride of over two miles. This from someone who uses a cane and, depending on the distance, a walker! I\'m not only looking forward to a sense of freedom but also the muscle strengthening the Liberty Trike will enable. The Liberty Trike itself is a solid, well-engineered machine. It\'s comfortable to ride and the controls and electronic display really make this trike a joy. The ride is extremely fun. Great work everybody!!'
    },
    {
      name: 'Jim B.',
      date: 'February 15, 2017',
      title: 'Very pleased with the overall quality',
      score: 5,
      comment: 'I received the new trike last Thursday and assembled it yesterday. Very pleased with the overall quality. Thanks again for the personalized attention, it is certainly appreciated. My son loves it and is looking forward to going mobile!'
    },
    {
      name: 'Martha O.',
      date: 'February 12, 2017',
      title: 'Great little trike',
      score: 5,
      comment: 'I saw this on facebook and had good reviews from some people there. I bought on a Monday and had it by Friday the same week. So far I like it a lot. I do have hills here in Washington state but it helps a lot. I still have to pedal but it\s much easier than a regular bicycle would be. I would recommend people get help for the initial setup but overall a good experience and I am happy.'
    },
    {
      name: 'Betsy H.',
      date: 'February 10, 2017',
      title: 'Good alternative to mobility scooter',
      score: 4,
      comment: 'I am 82 years young! I have health issues that prevent me from moving too well these days. I own a pride gogo folding mobility scooter but it\'s not much fun. One of my neighbors got a Liberty and I tried it. It takes me time to mount it but it\'s low enough that I can manage to hold the bars, get my butt on the seat and work my leg over. It\'s flat here in Florida so I don\'t have to pedal if I don\'t want to but I can if I do want to work my legs a little. So far it\'s been fun to ride and gets me around in a little more style that the scooter does. I feel younger on it. My basket was bent out of the box so maybe work on packaging a little better but the customer service was kind and send a replacement right away. That\'s my review of the Liberty Trike.'
    },
    {
      name: 'Stacey W.',
      date: 'February 8, 2017',
      title: 'Very coool',
      score: 5,
      comment: 'I\'m very pleased with Liberty Trike. I needed some help getting it together at first but now it\'s all together and I like riding outside again. Thanks for putting up with me and all my quetions. You guys are the best. I\'m happy with my new tricycle.'
    },
    {
      name: 'Janet W.',
      date: 'January 20, 2017',
      title: 'I love it!',
      score: 5,
      comment: 'Thank you! I have been looking for something to get me around the neighborhood more easily. Now I\'m out and about and I love it!'
    },
    {
      name: 'Cory H.',
      date: 'January 14, 2017',
      title: 'Mom\'s new trike',
      score: 3,
      comment: 'Hey Liberty Trike guys... Thanks for your excellent communications. My mom loves the new trike and she\'s riding with some more confidence now after a few days of practice. Thanks for all your suggestions!'
    },
    {
      name: 'Shelli W.',
      date: 'January 7, 2017',
      title: 'I am in LOVE with my new Liberty Trike',
      score: 5,
      comment: 'I am in LOVE with my new Liberty Trike and am the envy of the dog show. I am zipping back and forth from my RV with ease, my dog in tow in the basket. I want to make sure my bike stays shiny new.  Do you make a cover (or know someone who does) so I can keep in out of the weather when I am not on it?'
    },
    {
      name: 'James M.',
      date: 'January 2, 2017',
      title: 'Thank you! Thank you! Thank you!',
      score: 5,
      comment: 'Thank you! Thank you! Thank you! I love my Liberty Trike! I have not been able ride my other tricycle for year since I injured my right leg in an accident and I\'m no spring chicken anymore. I have always enoyed tricycles but with the motor on this one I can get around the neighborhood on my own and really have regained my liberty! Thank you!'
    },
    {
      name: 'Rosa M.',
      date: 'December 28, 2016',
      title: 'I love it.',
      score: 3,
      comment: 'I received my Liberty Trike on Christmas as a gift from my son. I wanted to write and let you know I love it. I have ridden maybe 30 total miles so far and have not had any issues. The basket was broekn when it got hear so thank you for replacing it with the metal one. That metal basket is a much better optin in my opinion.'
    },
    {
      name: 'Linda R.',
      date:  'December 18, 2016',
      title: "Great tricycle",
      score: 4,
      comment: 'I have owned Worksman trikes for years as I have health issues and connot balance a regular bicycle. This trike is smaller but it suits me fine for getting around, especially when I want to just relax and not pedal so much. It means I can go farther sometimes than I normally would. Giving a 4 just because it was packaged not so good and had smoe paint damage when we opened the box. The company did send me touchup paint. Great overall though.'
    },
    {
      name: 'Jim H.',
      date: 'November 9, 2016',
      title: "The trike exceeds all of my expectations!",
      score: 5,
      comment: 'The trike exceeds all of my expectations! The performance far exceeds that of my mobility scooter. I have had six toes amputated because of complications related to diabetes. I also have arthritis of both hips and my lower spine. (It\'s hell getting old!\). The trike fits very easily in both of my SUVs, a Hyundai Tucson and a Subaru Forester. I just need to lower the handlebars and seat. A lot of people in my community have stopped me and asked about trike. I have referred them to your website. Thank you again'
    },
    {
      name: 'Court Rye of Electric Bike Review',
      date: 'August 31, 2016',
      title: 'It\'s awesome!',
      score: 5,
      comment: 'It\'s awesome to see something like this being done in the world of electric bikes.'
    },
    {
      name: 'Marcia L.',
      date: 'April 30, 2016',
      title: 'We are having a blast with our new trikes!',
      score: 3,
      comment: 'We are having a blast with our new trikes! The only problem was getting down the street, we had so many people stopping us to ask questions.'
    },
    {
      name: 'Beatrice M.',
      date: 'April 22, 2016',
      title: 'I love my new found freedom.',
      score: 5,
      comment: 'I am 4 years into my 8th decade! I cannot walk without sticks. When I do walk, I can barely walk a street block and it takes me a long time. Today the trike was put together and charged up. I spent about 45 minutes going up and down the street learning to control the trike and learning the controls. My buddy on her ebike and I set off on my maiden journey! We intended just to go around a couple of blocks! Well a couple of blocks led to 2.4 miles of freedom!! I love my trike! I love my new found freedom and look forward to many more fun trips. For what it\'s worth, I was never able to walk into or around the Palace, today I finally did it and it was great!!'
    },
    {
      name: 'Carrie S.',
      date: 'April 28, 2016',
      title: 'This is a game changer for people like my mom.',
      score: 3,
      comment: 'We got my mom on the trike yesterday. She managed 3.5 miles of riding first time out! My girls (ages 4, 7, and 8) couldn’t keep up with her. They think she is the coolest Nana on the block with her new trike! This is a game changer for people like my mom. A vehicle to help her regain her health. Thanks for dreaming this and then making it happen. Wishing Liberty Trike much success! Let me know if I can help in anyway.'
    },
    {
      name: 'John D',
      date: 'April 20, 2016',
      title: 'I am very pleased with the power of the motor.',
      score: 4,
      comment: 'Today, I took the first extended test drive on my new “Big Orange” Liberty Trike of about nine miles. Everything went pretty much the way I thought it would. I did get a lot of stares and smiles from walkers, drivers, outside diners, and especially kids. I am very pleased with the power of the motor. It was able to handle my 275lbs in good fashion. In fact, I wouldn’t want it to be any more powerful or faster than it is right now. I have to admit to maxing out at 11.5 to 12 MPH when the way ahead permitted. I can’t wait to take this trike to the zoo. I\’ll let you know how Lowe\'s and Walmart feels about running up and down their aisles.'
    }
    
  ];
  